/*
@license
Impulse by Archetype Themes (https://archetypethemes.co)

Plugins:
JavaScript Cookie       2.2.0
AOS                     2.3.4
Flickity                2.3.0 with customizations by Archetype
Flickity Fade           1.0.0 with customizations by Archetype
Photoswipe              4.1.3
Photoswipe UI           4.1.2 with customizations by Archetype
noUiSlider              15.2.0
*/
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.AOS=e():t.AOS=e()}(this,(function(){return function(t){function e(n){if(i[n])return i[n].exports;var o=i[n]={exports:{},id:n,loaded:!1};return t[n].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var i={};return e.m=t,e.c=i,e.p="dist/",e(0)}([function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}var o=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&(t[n]=i[n])}return t},r=(n(i(1)),i(6)),s=n(r),a=n(i(7)),l=n(i(8)),c=n(i(9)),u=n(i(10)),d=n(i(11)),h=n(i(14)),p=[],f=!1,m=document.all&&!window.atob,g={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded",disableMutationObserver:!1},v=function(){if(arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&(f=!0),f)return p=(0,d.default)(p,g),(0,u.default)(p,g.once),p},y=function(){p=(0,h.default)(),v()};t.exports={init:function(t){return g=o(g,t),p=(0,h.default)(),function(t){return!0===t||"mobile"===t&&c.default.mobile()||"phone"===t&&c.default.phone()||"tablet"===t&&c.default.tablet()||"function"==typeof t&&!0===t()}(g.disable)||m?void p.forEach((function(t,e){t.node.removeAttribute("data-aos"),t.node.removeAttribute("data-aos-easing"),t.node.removeAttribute("data-aos-duration"),t.node.removeAttribute("data-aos-delay")})):(document.querySelector("body").setAttribute("data-aos-easing",g.easing),document.querySelector("body").setAttribute("data-aos-duration",g.duration),document.querySelector("body").setAttribute("data-aos-delay",g.delay),"DOMContentLoaded"===g.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?v(!0):"load"===g.startEvent?window.addEventListener(g.startEvent,(function(){v(!0)})):document.addEventListener(g.startEvent,(function(){v(!0)})),window.addEventListener("resize",(0,a.default)(v,50,!0)),window.addEventListener("orientationchange",(0,a.default)(v,50,!0)),window.addEventListener("scroll",(0,s.default)((function(){(0,u.default)(p,g.once)}),99)),g.disableMutationObserver||(0,l.default)("[data-aos]",y),p)},refresh:v,refreshHard:y}},function(t,e){},,,,,function(t,e){(function(e){"use strict";function i(t,e,i){function o(e){var i=d,n=h;return d=h=void 0,v=e,f=t.apply(n,i)}function s(t){var i=t-g;return void 0===g||i>=e||i<0||S&&t-v>=p}function l(){var t=w();return s(t)?c(t):void(m=setTimeout(l,function(t){var i=e-(t-g);return S?x(i,p-(t-v)):i}(t)))}function c(t){return m=void 0,E&&d?o(t):(d=h=void 0,f)}function u(){var t=w(),i=s(t);if(d=arguments,h=this,g=t,i){if(void 0===m)return function(t){return v=t,m=setTimeout(l,e),y?o(t):f}(g);if(S)return m=setTimeout(l,e),o(g)}return void 0===m&&(m=setTimeout(l,e)),f}var d,h,p,f,m,g,v=0,y=!1,S=!1,E=!0;if("function"!=typeof t)throw new TypeError(a);return e=r(e)||0,n(i)&&(y=!!i.leading,p=(S="maxWait"in i)?b(r(i.maxWait)||0,e):p,E="trailing"in i?!!i.trailing:E),u.cancel=function(){void 0!==m&&clearTimeout(m),v=0,d=g=h=m=void 0},u.flush=function(){return void 0===m?f:c(w())},u}function n(t){var e=void 0===t?"undefined":s(t);return!!t&&("object"==e||"function"==e)}function o(t){return"symbol"==(void 0===t?"undefined":s(t))||function(t){return!!t&&"object"==(void 0===t?"undefined":s(t))}(t)&&y.call(t)==c}function r(t){if("number"==typeof t)return t;if(o(t))return l;if(n(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=n(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(u,"");var i=h.test(t);return i||p.test(t)?f(t.slice(2),i?2:8):d.test(t)?l:+t}var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a="Expected a function",l=NaN,c="[object Symbol]",u=/^\s+|\s+$/g,d=/^[-+]0x[0-9a-f]+$/i,h=/^0b[01]+$/i,p=/^0o[0-7]+$/i,f=parseInt,m="object"==(void 0===e?"undefined":s(e))&&e&&e.Object===Object&&e,g="object"==("undefined"==typeof self?"undefined":s(self))&&self&&self.Object===Object&&self,v=m||g||Function("return this")(),y=Object.prototype.toString,b=Math.max,x=Math.min,w=function(){return v.Date.now()};t.exports=function(t,e,o){var r=!0,s=!0;if("function"!=typeof t)throw new TypeError(a);return n(o)&&(r="leading"in o?!!o.leading:r,s="trailing"in o?!!o.trailing:s),i(t,e,{leading:r,maxWait:e,trailing:s})}}).call(e,function(){return this}())},function(t,e){(function(e){"use strict";function i(t){var e=void 0===t?"undefined":r(t);return!!t&&("object"==e||"function"==e)}function n(t){return"symbol"==(void 0===t?"undefined":r(t))||function(t){return!!t&&"object"==(void 0===t?"undefined":r(t))}(t)&&v.call(t)==l}function o(t){if("number"==typeof t)return t;if(n(t))return a;if(i(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=i(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(c,"");var o=d.test(t);return o||h.test(t)?p(t.slice(2),o?2:8):u.test(t)?a:+t}var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},s="Expected a function",a=NaN,l="[object Symbol]",c=/^\s+|\s+$/g,u=/^[-+]0x[0-9a-f]+$/i,d=/^0b[01]+$/i,h=/^0o[0-7]+$/i,p=parseInt,f="object"==(void 0===e?"undefined":r(e))&&e&&e.Object===Object&&e,m="object"==("undefined"==typeof self?"undefined":r(self))&&self&&self.Object===Object&&self,g=f||m||Function("return this")(),v=Object.prototype.toString,y=Math.max,b=Math.min,x=function(){return g.Date.now()};t.exports=function(t,e,n){function r(e){var i=d,n=h;return d=h=void 0,v=e,f=t.apply(n,i)}function a(t){var i=t-g;return void 0===g||i>=e||i<0||S&&t-v>=p}function l(){var t=x();return a(t)?c(t):void(m=setTimeout(l,function(t){var i=e-(t-g);return S?b(i,p-(t-v)):i}(t)))}function c(t){return m=void 0,E&&d?r(t):(d=h=void 0,f)}function u(){var t=x(),i=a(t);if(d=arguments,h=this,g=t,i){if(void 0===m)return function(t){return v=t,m=setTimeout(l,e),w?r(t):f}(g);if(S)return m=setTimeout(l,e),r(g)}return void 0===m&&(m=setTimeout(l,e)),f}var d,h,p,f,m,g,v=0,w=!1,S=!1,E=!0;if("function"!=typeof t)throw new TypeError(s);return e=o(e)||0,i(n)&&(w=!!n.leading,p=(S="maxWait"in n)?y(o(n.maxWait)||0,e):p,E="trailing"in n?!!n.trailing:E),u.cancel=function(){void 0!==m&&clearTimeout(m),v=0,d=g=h=m=void 0},u.flush=function(){return void 0===m?f:c(x())},u}}).call(e,function(){return this}())},function(t,e){"use strict";function i(t){t&&t.forEach((function(t){var e=Array.prototype.slice.call(t.addedNodes),i=Array.prototype.slice.call(t.removedNodes),n=e.concat(i).filter((function(t){return t.hasAttribute&&t.hasAttribute("data-aos")})).length;n&&r()}))}Object.defineProperty(e,"__esModule",{value:!0});var n=window.document,o=window.MutationObserver||window.WebKitMutationObserver,r=function(){};e.default=function(t,e){var s=new o(i);r=e,s.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}},function(t,e){"use strict";function i(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),o=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,r=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,s=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,l=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t)}return n(t,[{key:"phone",value:function(){var t=i();return!(!o.test(t)&&!r.test(t.substr(0,4)))}},{key:"mobile",value:function(){var t=i();return!(!s.test(t)&&!a.test(t.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),t}();e.default=new l},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.default=function(t,e){var i=window.pageYOffset,n=window.innerHeight;t.forEach((function(t,o){!function(t,e,i){var n=t.node.getAttribute("data-aos-once");e>t.position?t.node.classList.add("aos-animate"):void 0!==n&&("false"===n||!i&&"true"!==n)&&t.node.classList.remove("aos-animate")}(t,n+i,e)}))}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(t){return t&&t.__esModule?t:{default:t}}(i(12));e.default=function(t,e){return t.forEach((function(t,i){t.node.classList.add("aos-init"),t.position=(0,n.default)(t.node,e.offset)})),t}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(t){return t&&t.__esModule?t:{default:t}}(i(13));e.default=function(t,e){var i=0,o=0,r=window.innerHeight,s={offset:t.getAttribute("data-aos-offset"),anchor:t.getAttribute("data-aos-anchor"),anchorPlacement:t.getAttribute("data-aos-anchor-placement")};switch(s.offset&&!isNaN(s.offset)&&(o=parseInt(s.offset)),s.anchor&&document.querySelectorAll(s.anchor)&&(t=document.querySelectorAll(s.anchor)[0]),i=(0,n.default)(t).top,s.anchorPlacement){case"top-bottom":break;case"center-bottom":i+=t.offsetHeight/2;break;case"bottom-bottom":i+=t.offsetHeight;break;case"top-center":i+=r/2;break;case"bottom-center":i+=r/2+t.offsetHeight;break;case"center-center":i+=r/2+t.offsetHeight/2;break;case"top-top":i+=r;break;case"bottom-top":i+=t.offsetHeight+r;break;case"center-top":i+=t.offsetHeight/2+r}return s.anchorPlacement||s.offset||isNaN(e)||(o=e),i+o}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.default=function(t){for(var e=0,i=0;t&&!isNaN(t.offsetLeft)&&!isNaN(t.offsetTop);)e+=t.offsetLeft-("BODY"!=t.tagName?t.scrollLeft:0),i+=t.offsetTop-("BODY"!=t.tagName?t.scrollTop:0),t=t.offsetParent;return{top:i,left:e}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.default=function(t){t=t||document.querySelectorAll("[data-aos]");var e=[];return[].forEach.call(t,(function(t,i){e.push({node:t})})),e}}])})),function(t){var e=!1;if("function"==typeof define&&define.amd&&(define(t),e=!0),"object"==typeof exports&&(module.exports=t(),e=!0),!e){var i=window.Cookies,n=window.Cookies=t();n.noConflict=function(){return window.Cookies=i,n}}}((function(){function t(){for(var t=0,e={};t<arguments.length;t++){var i=arguments[t];for(var n in i)e[n]=i[n]}return e}return function e(i){function n(e,o,r){var s;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(r=t({path:"/"},n.defaults,r)).expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*r.expires),r.expires=a}r.expires=r.expires?r.expires.toUTCString():"";try{s=JSON.stringify(o),/^[\{\[]/.test(s)&&(o=s)}catch(t){}o=i.write?i.write(o,e):encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),e=(e=(e=encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var l="";for(var c in r)r[c]&&(l+="; "+c,!0!==r[c]&&(l+="="+r[c]));return document.cookie=e+"="+o+l}e||(s={});for(var u=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,h=0;h<u.length;h++){var p=u[h].split("="),f=p.slice(1).join("=");this.json||'"'!==f.charAt(0)||(f=f.slice(1,-1));try{var m=p[0].replace(d,decodeURIComponent);if(f=i.read?i.read(f,m):i(f,m)||f.replace(d,decodeURIComponent),this.json)try{f=JSON.parse(f)}catch(t){}if(e===m){s=f;break}e||(s[m]=f)}catch(t){}}return s}}return n.set=n,n.get=function(t){return n.call(n,t)},n.getJSON=function(){return n.apply({json:!0},[].slice.call(arguments))},n.defaults={},n.remove=function(e,i){n(e,"",t(i,{expires:-1}))},n.withConverter=e,n}((function(){}))})),
/*!
 * Flickity PACKAGED v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */
function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,(function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{};return(i[t]=i[t]||{})[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var n=this._onceEvents&&this._onceEvents[t],o=0;o<i.length;o++){var r=i[o];n&&n[r]&&(this.off(t,r),delete n[r]),r.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t})),
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */
function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,(function(){"use strict";function t(t){var e=parseFloat(t);return-1==t.indexOf("%")&&!isNaN(e)&&e}var e=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],i=e.length;function n(t){return getComputedStyle(t)}var o,r=!1;function s(a){if(function(){if(!r){r=!0;var e=document.createElement("div");e.style.width="200px",e.style.padding="1px 2px 3px 4px",e.style.borderStyle="solid",e.style.borderWidth="1px 2px 3px 4px",e.style.boxSizing="border-box";var i=document.body||document.documentElement;i.appendChild(e);var a=n(e);o=200==Math.round(t(a.width)),s.isBoxSizeOuter=o,i.removeChild(e)}}(),"string"==typeof a&&(a=document.querySelector(a)),a&&"object"==typeof a&&a.nodeType){var l=n(a);if("none"==l.display)return function(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},n=0;n<i;n++)t[e[n]]=0;return t}();var c={};c.width=a.offsetWidth,c.height=a.offsetHeight;for(var u=c.isBorderBox="border-box"==l.boxSizing,d=0;d<i;d++){var h=e[d],p=l[h],f=parseFloat(p);c[h]=isNaN(f)?0:f}var m=c.paddingLeft+c.paddingRight,g=c.paddingTop+c.paddingBottom,v=c.marginLeft+c.marginRight,y=c.marginTop+c.marginBottom,b=c.borderLeftWidth+c.borderRightWidth,x=c.borderTopWidth+c.borderBottomWidth,w=u&&o,S=t(l.width);!1!==S&&(c.width=S+(w?0:m+b));var E=t(l.height);return!1!==E&&(c.height=E+(w?0:g+x)),c.innerWidth=c.width-(m+b),c.innerHeight=c.height-(g+x),c.outerWidth=c.width+v,c.outerHeight=c.height+y,c}}return s})),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,(function(){"use strict";var t=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i]+"MatchesSelector";if(t[n])return n}}();return function(e,i){return e[t](i)}})),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],(function(i){return e(t,i)})):"object"==typeof module&&module.exports?module.exports=e(t,require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.matchesSelector)}(window,(function(t,e){var i={extend:function(t,e){for(var i in e)t[i]=e[i];return t},modulo:function(t,e){return(t%e+e)%e}},n=Array.prototype.slice;return i.makeArray=function(t){return Array.isArray(t)?t:null==t?[]:"object"==typeof t&&"number"==typeof t.length?n.call(t):[t]},i.removeFrom=function(t,e){var i=t.indexOf(e);-1!=i&&t.splice(i,1)},i.getParent=function(t,i){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,e(t,i))return t},i.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.filterFindElements=function(t,n){t=i.makeArray(t);var o=[];return t.forEach((function(t){if(t instanceof HTMLElement)if(n){e(t,n)&&o.push(t);for(var i=t.querySelectorAll(n),r=0;r<i.length;r++)o.push(i[r])}else o.push(t)})),o},i.debounceMethod=function(t,e,i){i=i||100;var n=t.prototype[e],o=e+"Timeout";t.prototype[e]=function(){var t=this[o];clearTimeout(t);var e=arguments,r=this;this[o]=setTimeout((function(){n.apply(r,e),delete r[o]}),i)}},i.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},i.toDashed=function(t){return t.replace(/(.)([A-Z])/g,(function(t,e,i){return e+"-"+i})).toLowerCase()},i.htmlInit=function(t,e){i.docReady((function(){var n=i.toDashed(e),o="data-"+n,r=document.querySelectorAll("["+o+"]"),s=document.querySelectorAll(".js-"+n),a=i.makeArray(r).concat(i.makeArray(s)),l=o+"-options";a.forEach((function(e){var i,n=e.getAttribute(o)||e.getAttribute(l);try{i=n&&JSON.parse(n)}catch(t){return}new t(e,i)}))}))},i})),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/cell",["get-size/get-size"],(function(i){return e(t,i)})):"object"==typeof module&&module.exports?module.exports=e(t,require("get-size")):(t.Flickity=t.Flickity||{},t.Flickity.Cell=e(t,t.getSize))}(window,(function(t,e){function i(t,e){this.element=t,this.parent=e,this.create()}var n=i.prototype;return n.create=function(){this.element.style.position="absolute",this.element.setAttribute("aria-hidden","true"),this.x=0,this.shift=0,this.element.style[this.parent.originSide]=0},n.destroy=function(){this.unselect(),this.element.style.position="";var t=this.parent.originSide;this.element.style[t]="",this.element.style.transform="",this.element.removeAttribute("aria-hidden")},n.getSize=function(){this.size=e(this.element)},n.setPosition=function(t){this.x=t,this.updateTarget(),this.renderPosition(t)},n.updateTarget=n.setDefaultTarget=function(){var t="left"==this.parent.originSide?"marginLeft":"marginRight";this.target=this.x+this.size[t]+this.size.width*this.parent.cellAlign},n.renderPosition=function(t){var e="left"===this.parent.originSide?1:-1,i=this.parent.options.percentPosition?t*e*(this.parent.size.innerWidth/this.size.width):t*e;this.element.style.transform="translateX("+this.parent.getPositionValue(i)+")"},n.select=function(){this.element.classList.add("is-selected"),this.element.removeAttribute("aria-hidden")},n.unselect=function(){this.element.classList.remove("is-selected"),this.element.setAttribute("aria-hidden","true")},n.wrapShift=function(t){this.shift=t,this.renderPosition(this.x+this.parent.slideableWidth*t)},n.remove=function(){this.element.parentNode.removeChild(this.element)},i})),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/slide",e):"object"==typeof module&&module.exports?module.exports=e():(t.Flickity=t.Flickity||{},t.Flickity.Slide=e())}(window,(function(){"use strict";function t(t){this.parent=t,this.isOriginLeft="left"==t.originSide,this.cells=[],this.outerWidth=0,this.height=0}var e=t.prototype;return e.addCell=function(t){if(this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1==this.cells.length){this.x=t.x;var e=this.isOriginLeft?"marginLeft":"marginRight";this.firstMargin=t.size[e]}},e.updateTarget=function(){var t=this.isOriginLeft?"marginRight":"marginLeft",e=this.getLastCell(),i=e?e.size[t]:0,n=this.outerWidth-(this.firstMargin+i);this.target=this.x+this.firstMargin+n*this.parent.cellAlign},e.getLastCell=function(){return this.cells[this.cells.length-1]},e.select=function(){this.cells.forEach((function(t){t.select()}))},e.unselect=function(){this.cells.forEach((function(t){t.unselect()}))},e.getCellElements=function(){return this.cells.map((function(t){return t.element}))},t})),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/animate",["fizzy-ui-utils/utils"],(function(i){return e(t,i)})):"object"==typeof module&&module.exports?module.exports=e(t,require("fizzy-ui-utils")):(t.Flickity=t.Flickity||{},t.Flickity.animatePrototype=e(t,t.fizzyUIUtils))}(window,(function(t,e){var i={startAnimation:function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},animate:function(){this.applyDragForce(),this.applySelectedAttraction();var t=this.x;if(this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating){var e=this;requestAnimationFrame((function(){e.animate()}))}},positionSlider:function(){var t=this.x;this.options.wrapAround&&this.cells.length>1&&(t=e.modulo(t,this.slideableWidth),t-=this.slideableWidth,this.shiftWrapCells(t)),this.setTranslateX(t,this.isAnimating),this.dispatchScrollEvent()},setTranslateX:function(t,e){t+=this.cursorPosition,t=this.options.rightToLeft?-t:t;var i=this.getPositionValue(t);this.slider.style.transform=e?"translate3d("+i+",0,0)":"translateX("+i+")"},dispatchScrollEvent:function(){var t=this.slides[0];if(t){var e=-this.x-t.target,i=e/this.slidesWidth;this.dispatchEvent("scroll",null,[i,e])}},positionSliderAtSelected:function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,this.positionSlider())},getPositionValue:function(t){return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+"%":Math.round(t)+"px"},settle:function(t){!this.isPointerDown&&Math.round(100*this.x)==Math.round(100*t)&&this.restingFrames++,this.restingFrames>2&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent("settle",null,[this.selectedIndex]))},shiftWrapCells:function(t){var e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);var i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1)},_shiftCells:function(t,e,i){for(var n=0;n<t.length;n++){var o=t[n],r=e>0?i:0;o.wrapShift(r),e-=o.size.outerWidth}},_unshiftCells:function(t){if(t&&t.length)for(var e=0;e<t.length;e++)t[e].wrapShift(0)},integratePhysics:function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},applyForce:function(t){this.velocity+=t},getFrictionFactor:function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},getRestingPosition:function(){return this.x+this.velocity/(1-this.getFrictionFactor())},applyDragForce:function(){if(this.isDraggable&&this.isPointerDown){var t=this.dragX-this.x-this.velocity;this.applyForce(t)}},applySelectedAttraction:function(){if(!(this.isDraggable&&this.isPointerDown)&&!this.isFreeScrolling&&this.slides.length){var t=(-1*this.selectedSlide.target-this.x)*this.options.selectedAttraction;this.applyForce(t)}}};return i})),function(t,e){if("function"==typeof define&&define.amd)define("flickity/js/flickity",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./cell","./slide","./animate"],(function(i,n,o,r,s,a){return e(t,i,n,o,r,s,a)}));else if("object"==typeof module&&module.exports)module.exports=e(t,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./cell"),require("./slide"),require("./animate"));else{var i=t.Flickity;t.Flickity=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,i.Cell,i.Slide,i.animatePrototype)}}(window,(function(t,e,i,n,o,r,s){t.getComputedStyle;function a(t,e){for(t=n.makeArray(t);t.length;)e.appendChild(t.shift())}var l=0,c={};function u(t,e){var i=n.getQueryElement(t);if(i){if(this.element=i,this.element.flickityGUID){var o=c[this.element.flickityGUID];return o&&o.option(e),o}this.options=n.extend({},this.constructor.defaults),this.option(e),this._create()}}u.defaults={accessibility:!0,adaptiveHeight:!1,cellAlign:"center",freeScrollFriction:.075,friction:.28,initialIndex:0,percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0,wrapAround:!1},u.createMethods=[];var d=u.prototype;n.extend(d,e.prototype),d._create=function(){var t=this.guid=++l;for(var e in this.element.flickityGUID=t,c[t]=this,this.selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.originSide=this.options.rightToLeft?"right":"left",this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),this.options.on){var i=this.options.on[e];this.on(e,i)}u.createMethods.forEach((function(t){this[t]()}),this),this.activate()},d.option=function(t){n.extend(this.options,t)},d.activate=function(){this.isActive||(this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize(),a(this._filterFindCellElements(this.element.children),this.slider),this.viewport.appendChild(this.slider),this.element.appendChild(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener("keydown",this)),this.emitEvent("activate"),this.selectInitialIndex(),this.isInitActivated=!0,this.dispatchEvent("ready",null,[this.element]))},d._createSlider=function(){var t=document.createElement("div");t.className="flickity-slider",t.style[this.originSide]=0,this.slider=t},d._filterFindCellElements=function(t){return n.filterFindElements(t,this.options.cellSelector)},d.reloadCells=function(){this.cells=this._makeCells(this.slider.children),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize()},d._makeCells=function(t){return this._filterFindCellElements(t).map((function(t){return new o(t,this)}),this)},d.getLastCell=function(){return this.cells[this.cells.length-1]},d.getLastSlide=function(){return this.slides[this.slides.length-1]},d.positionCells=function(){this._sizeCells(this.cells),this._positionCells(0)},d._positionCells=function(t){t=t||0,this.maxCellHeight=t&&this.maxCellHeight||0;var e=0;if(t>0){var i=this.cells[t-1];e=i.x+i.size.outerWidth}for(var n=this.cells.length,o=t;o<n;o++){var r=this.cells[o];r.setPosition(e),e+=r.size.outerWidth,this.maxCellHeight=Math.max(r.size.outerHeight,this.maxCellHeight)}this.slideableWidth=e,this.updateSlides(),this._containSlides(),this.slidesWidth=n?this.getLastSlide().target-this.slides[0].target:0},d._sizeCells=function(t){t.forEach((function(t){t.getSize()}))},d.updateSlides=function(){if(this.slides=[],this.cells.length){var t=new r(this);this.slides.push(t);var e="left"==this.originSide?"marginRight":"marginLeft",i=this._getCanCellFit();this.cells.forEach((function(n,o){if(t.cells.length){var s=t.outerWidth-t.firstMargin+(n.size.outerWidth-n.size[e]);i.call(this,o,s)||(t.updateTarget(),t=new r(this),this.slides.push(t)),t.addCell(n)}else t.addCell(n)}),this),t.updateTarget(),this.updateSelectedSlide()}},d._getCanCellFit=function(){var t=this.options.groupCells;if(!t)return function(){return!1};if("number"==typeof t){var e=parseInt(t,10);return function(t){return t%e!=0}}var i="string"==typeof t&&t.match(/^(\d+)%$/),n=i?parseInt(i[1],10)/100:1;return function(t,e){return e<=(this.size.innerWidth+1)*n}},d.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},d.getSize=function(){this.size=i(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};var h={center:{left:.5,right:.5},left:{left:0,right:1},right:{right:0,left:1}};return d.setCellAlign=function(){var t=h[this.options.cellAlign];this.cellAlign=t?t[this.originSide]:this.options.cellAlign},d.setGallerySize=function(){if(this.options.setGallerySize){var t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=t+"px"}},d._getWrapShiftCells=function(){if(this.options.wrapAround){this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);var t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1),t=this.size.innerWidth-this.cursorPosition,this.afterShiftCells=this._getGapCells(t,0,1)}},d._getGapCells=function(t,e,i){for(var n=[];t>0;){var o=this.cells[e];if(!o)break;n.push(o),e+=i,t-=o.size.outerWidth}return n},d._containSlides=function(){if(this.options.contain&&!this.options.wrapAround&&this.cells.length){var t=this.options.rightToLeft,e=t?"marginRight":"marginLeft",i=t?"marginLeft":"marginRight",n=this.slideableWidth-this.getLastCell().size[i],o=n<this.size.innerWidth,r=this.cursorPosition+this.cells[0].size[e],s=n-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach((function(t){o?t.target=n*this.cellAlign:(t.target=Math.max(t.target,r),t.target=Math.min(t.target,s))}),this)}},d.dispatchEvent=function(t,e,i){var n=e?[e].concat(i):i;this.emitEvent(t,n)},d.select=function(t,e,i){if(this.isActive&&(t=parseInt(t,10),this._wrapSelect(t),(this.options.wrapAround||e)&&(t=n.modulo(t,this.slides.length)),this.slides[t])){var o=this.selectedIndex;this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent("select",null,[t]),t!=o&&this.dispatchEvent("change",null,[t]),this.dispatchEvent("cellSelect")}},d._wrapSelect=function(t){var e=this.slides.length;if(!(this.options.wrapAround&&e>1))return t;var i=n.modulo(t,e),o=Math.abs(i-this.selectedIndex),r=Math.abs(i+e-this.selectedIndex),s=Math.abs(i-e-this.selectedIndex);!this.isDragSelect&&r<o?t+=e:!this.isDragSelect&&s<o&&(t-=e),t<0?this.x-=this.slideableWidth:t>=e&&(this.x+=this.slideableWidth)},d.previous=function(t,e){this.select(this.selectedIndex-1,t,e)},d.next=function(t,e){this.select(this.selectedIndex+1,t,e)},d.updateSelectedSlide=function(){var t=this.slides[this.selectedIndex];t&&(this.unselectSelectedSlide(),this.selectedSlide=t,t.select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0])},d.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},d.selectInitialIndex=function(){var t=this.options.initialIndex;if(this.isInitActivated)this.select(this.selectedIndex,!1,!0);else{if(t&&"string"==typeof t)if(this.queryCell(t))return void this.selectCell(t,!1,!0);var e=0;t&&this.slides[t]&&(e=t),this.select(e,!1,!0)}},d.selectCell=function(t,e,i){var n=this.queryCell(t);if(n){var o=this.getCellSlideIndex(n);this.select(o,e,i)}},d.getCellSlideIndex=function(t){for(var e=0;e<this.slides.length;e++){if(-1!=this.slides[e].cells.indexOf(t))return e}},d.getCell=function(t){for(var e=0;e<this.cells.length;e++){var i=this.cells[e];if(i.element==t)return i}},d.getCells=function(t){t=n.makeArray(t);var e=[];return t.forEach((function(t){var i=this.getCell(t);i&&e.push(i)}),this),e},d.getCellElements=function(){return this.cells.map((function(t){return t.element}))},d.getParentCell=function(t){var e=this.getCell(t);return e||(t=n.getParent(t,".flickity-slider > *"),this.getCell(t))},d.getAdjacentCellElements=function(t,e){if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;var i=this.slides.length;if(1+2*t>=i)return this.getCellElements();for(var o=[],r=e-t;r<=e+t;r++){var s=this.options.wrapAround?n.modulo(r,i):r,a=this.slides[s];a&&(o=o.concat(a.getCellElements()))}return o},d.queryCell=function(t){if("number"==typeof t)return this.cells[t];if("string"==typeof t){if(t.match(/^[#.]?[\d/]/))return;t=this.element.querySelector(t)}return this.getCell(t)},d.uiChange=function(){this.emitEvent("uiChange")},d.childUIPointerDown=function(t){"touchstart"!=t.type&&t.preventDefault(),this.focus()},d.onresize=function(){this.resize()},n.debounceMethod(u,"onresize",150),d.resize=function(){if(this.isActive&&!this.isAnimating&&!this.isDragging){this.getSize(),this.options.wrapAround&&(this.x=n.modulo(this.x,this.slideableWidth)),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");var t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0)}},d.onkeydown=function(t){var e=document.activeElement&&document.activeElement!=this.element;if(this.options.accessibility&&!e){var i=u.keyboardHandlers[t.keyCode];i&&i.call(this)}},u.keyboardHandlers={37:function(){var t=this.options.rightToLeft?"next":"previous";this.uiChange(),this[t]()},39:function(){var t=this.options.rightToLeft?"previous":"next";this.uiChange(),this[t]()}},d.focus=function(){var e=t.pageYOffset;this.element.focus({preventScroll:!0}),t.pageYOffset!=e&&t.scrollTo(t.pageXOffset,e)},d.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.unselectSelectedSlide(),this.cells.forEach((function(t){t.destroy()})),this.element.removeChild(this.viewport),a(this.slider.children,this.element),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),this.isActive=!1,this.emitEvent("deactivate"))},d.destroy=function(){this.deactivate(),t.removeEventListener("resize",this),this.allOff(),this.emitEvent("destroy"),delete this.element.flickityGUID,delete c[this.guid]},n.extend(d,s),u.data=function(t){var e=(t=n.getQueryElement(t))&&t.flickityGUID;return e&&c[e]},n.htmlInit(u,"flickity"),u.Cell=o,u.Slide=r,u})),
/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */
function(t,e){"function"==typeof define&&define.amd?define("unipointer/unipointer",["ev-emitter/ev-emitter"],(function(i){return e(t,i)})):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.Unipointer=e(t,t.EvEmitter)}(window,(function(t,e){function i(){}var n=i.prototype=Object.create(e.prototype);n.bindStartEvent=function(t){this._bindStartEvent(t,!0)},n.unbindStartEvent=function(t){this._bindStartEvent(t,!1)},n._bindStartEvent=function(e,i){var n=(i=void 0===i||i)?"addEventListener":"removeEventListener",o="mousedown";"ontouchstart"in t?o="touchstart":t.PointerEvent&&(o="pointerdown"),e[n](o,this)},n.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},n.getTouch=function(t){for(var e=0;e<t.length;e++){var i=t[e];if(i.identifier==this.pointerIdentifier)return i}},n.onmousedown=function(t){var e=t.button;e&&0!==e&&1!==e||this._pointerDown(t,t)},n.ontouchstart=function(t){this._pointerDown(t,t.changedTouches[0])},n.onpointerdown=function(t){this._pointerDown(t,t)},n._pointerDown=function(t,e){t.button||this.isPointerDown||(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDown(t,e))},n.pointerDown=function(t,e){this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])};var o={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};return n._bindPostStartEvents=function(e){if(e){var i=o[e.type];i.forEach((function(e){t.addEventListener(e,this)}),this),this._boundPointerEvents=i}},n._unbindPostStartEvents=function(){this._boundPointerEvents&&(this._boundPointerEvents.forEach((function(e){t.removeEventListener(e,this)}),this),delete this._boundPointerEvents)},n.onmousemove=function(t){this._pointerMove(t,t)},n.onpointermove=function(t){t.pointerId==this.pointerIdentifier&&this._pointerMove(t,t)},n.ontouchmove=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerMove(t,e)},n._pointerMove=function(t,e){this.pointerMove(t,e)},n.pointerMove=function(t,e){this.emitEvent("pointerMove",[t,e])},n.onmouseup=function(t){this._pointerUp(t,t)},n.onpointerup=function(t){t.pointerId==this.pointerIdentifier&&this._pointerUp(t,t)},n.ontouchend=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerUp(t,e)},n._pointerUp=function(t,e){this._pointerDone(),this.pointerUp(t,e)},n.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e])},n._pointerDone=function(){this._pointerReset(),this._unbindPostStartEvents(),this.pointerDone()},n._pointerReset=function(){this.isPointerDown=!1,delete this.pointerIdentifier},n.pointerDone=function(){},n.onpointercancel=function(t){t.pointerId==this.pointerIdentifier&&this._pointerCancel(t,t)},n.ontouchcancel=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerCancel(t,e)},n._pointerCancel=function(t,e){this._pointerDone(),this.pointerCancel(t,e)},n.pointerCancel=function(t,e){this.emitEvent("pointerCancel",[t,e])},i.getPointerPoint=function(t){return{x:t.pageX,y:t.pageY}},i})),
/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */
function(t,e){"function"==typeof define&&define.amd?define("unidragger/unidragger",["unipointer/unipointer"],(function(i){return e(t,i)})):"object"==typeof module&&module.exports?module.exports=e(t,require("unipointer")):t.Unidragger=e(t,t.Unipointer)}(window,(function(t,e){function i(){}var n=i.prototype=Object.create(e.prototype);n.bindHandles=function(){this._bindHandles(!0)},n.unbindHandles=function(){this._bindHandles(!1)},n._bindHandles=function(e){for(var i=(e=void 0===e||e)?"addEventListener":"removeEventListener",n=e?this._touchActionValue:"",o=0;o<this.handles.length;o++){var r=this.handles[o];this._bindStartEvent(r,e),r[i]("click",this),t.PointerEvent&&(r.style.touchAction=n)}},n._touchActionValue="none",n.pointerDown=function(t,e){this.okayPointerDown(t)&&(this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},t.preventDefault(),this.pointerDownBlur(),this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e]))};var o={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},r={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};return n.okayPointerDown=function(t){var e=o[t.target.nodeName],i=r[t.target.type],n=!e||i;return n||this._pointerReset(),n},n.pointerDownBlur=function(){var t=document.activeElement;t&&t.blur&&t!=document.body&&t.blur()},n.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,i]),this._dragMove(t,e,i)},n._dragPointerMove=function(t,e){var i={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};return!this.isDragging&&this.hasDragStarted(i)&&this._dragStart(t,e),i},n.hasDragStarted=function(t){return Math.abs(t.x)>3||Math.abs(t.y)>3},n.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},n._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):this._staticClick(t,e)},n._dragStart=function(t,e){this.isDragging=!0,this.isPreventingClicks=!0,this.dragStart(t,e)},n.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},n._dragMove=function(t,e,i){this.isDragging&&this.dragMove(t,e,i)},n.dragMove=function(t,e,i){t.preventDefault(),this.emitEvent("dragMove",[t,e,i])},n._dragEnd=function(t,e){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},n.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},n.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},n._staticClick=function(t,e){this.isIgnoringMouseUp&&"mouseup"==t.type||(this.staticClick(t,e),"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},n.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},i.getPointerPoint=e.getPointerPoint,i})),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/drag",["./flickity","unidragger/unidragger","fizzy-ui-utils/utils"],(function(i,n,o){return e(t,i,n,o)})):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("unidragger"),require("fizzy-ui-utils")):t.Flickity=e(t,t.Flickity,t.Unidragger,t.fizzyUIUtils)}(window,(function(t,e,i,n){n.extend(e.defaults,{draggable:">1",dragThreshold:3}),e.createMethods.push("_createDrag");var o=e.prototype;n.extend(o,i.prototype),o._touchActionValue="pan-y",o._createDrag=function(){this.on("activate",this.onActivateDrag),this.on("uiChange",this._uiChangeDrag),this.on("deactivate",this.onDeactivateDrag),this.on("cellChange",this.updateDraggable)},o.onActivateDrag=function(){this.handles=[this.viewport],this.bindHandles(),this.updateDraggable()},o.onDeactivateDrag=function(){this.unbindHandles(),this.element.classList.remove("is-draggable")},o.updateDraggable=function(){">1"==this.options.draggable?this.isDraggable=this.slides.length>1:this.isDraggable=this.options.draggable,this.isDraggable?this.element.classList.add("is-draggable"):this.element.classList.remove("is-draggable")},o.bindDrag=function(){this.options.draggable=!0,this.updateDraggable()},o.unbindDrag=function(){this.options.draggable=!1,this.updateDraggable()},o._uiChangeDrag=function(){delete this.isFreeScrolling},o.pointerDown=function(e,i){this.isDraggable?this.okayPointerDown(e)&&(this._pointerDownPreventDefault(e),this.pointerDownFocus(e),document.activeElement!=this.element&&this.pointerDownBlur(),this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),this.pointerDownScroll=s(),t.addEventListener("scroll",this),this._pointerDownDefault(e,i)):this._pointerDownDefault(e,i)},o._pointerDownDefault=function(t,e){this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},this._bindPostStartEvents(t),this.dispatchEvent("pointerDown",t,[e])};var r={INPUT:!0,TEXTAREA:!0,SELECT:!0};function s(){return{x:t.pageXOffset,y:t.pageYOffset}}return o.pointerDownFocus=function(t){r[t.target.nodeName]||this.focus()},o._pointerDownPreventDefault=function(t){var e="touchstart"==t.type,i="touch"==t.pointerType,n=r[t.target.nodeName];e||i||n||t.preventDefault()},o.hasDragStarted=function(t){return Math.abs(t.x)>this.options.dragThreshold},o.pointerUp=function(t,e){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down"),this.dispatchEvent("pointerUp",t,[e]),this._dragPointerUp(t,e)},o.pointerDone=function(){t.removeEventListener("scroll",this),delete this.pointerDownScroll},o.dragStart=function(e,i){this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),t.removeEventListener("scroll",this),this.dispatchEvent("dragStart",e,[i]))},o.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.dispatchEvent("pointerMove",t,[e,i]),this._dragMove(t,e,i)},o.dragMove=function(t,e,i){if(this.isDraggable){t.preventDefault(),this.previousDragX=this.dragX;var n=this.options.rightToLeft?-1:1;this.options.wrapAround&&(i.x%=this.slideableWidth);var o=this.dragStartPosition+i.x*n;if(!this.options.wrapAround&&this.slides.length){var r=Math.max(-this.slides[0].target,this.dragStartPosition);o=o>r?.5*(o+r):o;var s=Math.min(-this.getLastSlide().target,this.dragStartPosition);o=o<s?.5*(o+s):o}this.dragX=o,this.dragMoveTime=new Date,this.dispatchEvent("dragMove",t,[e,i])}},o.dragEnd=function(t,e){if(this.isDraggable){this.options.freeScroll&&(this.isFreeScrolling=!0);var i=this.dragEndRestingSelect();if(this.options.freeScroll&&!this.options.wrapAround){var n=this.getRestingPosition();this.isFreeScrolling=-n>this.slides[0].target&&-n<this.getLastSlide().target}else this.options.freeScroll||i!=this.selectedIndex||(i+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.options.wrapAround,this.select(i),delete this.isDragSelect,this.dispatchEvent("dragEnd",t,[e])}},o.dragEndRestingSelect=function(){var t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),n=this._getClosestResting(t,e,-1);return i.distance<n.distance?i.index:n.index},o._getClosestResting=function(t,e,i){for(var n=this.selectedIndex,o=1/0,r=this.options.contain&&!this.options.wrapAround?function(t,e){return t<=e}:function(t,e){return t<e};r(e,o)&&(n+=i,o=e,null!==(e=this.getSlideDistance(-t,n)));)e=Math.abs(e);return{distance:o,index:n-i}},o.getSlideDistance=function(t,e){var i=this.slides.length,o=this.options.wrapAround&&i>1,r=o?n.modulo(e,i):e,s=this.slides[r];if(!s)return null;var a=o?this.slideableWidth*Math.floor(e/i):0;return t-(s.target+a)},o.dragEndBoostSelect=function(){if(void 0===this.previousDragX||!this.dragMoveTime||new Date-this.dragMoveTime>100)return 0;var t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return t>0&&e>0?1:t<0&&e<0?-1:0},o.staticClick=function(t,e){var i=this.getParentCell(t.target),n=i&&i.element,o=i&&this.cells.indexOf(i);this.dispatchEvent("staticClick",t,[e,n,o])},o.onscroll=function(){var t=s(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;(Math.abs(e)>3||Math.abs(i)>3)&&this._pointerDone()},e})),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/prev-next-button",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],(function(i,n,o){return e(t,i,n,o)})):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):e(t,t.Flickity,t.Unipointer,t.fizzyUIUtils)}(window,(function(t,e,i,n){"use strict";var o="http://www.w3.org/2000/svg";function r(t,e){this.direction=t,this.parent=e,this._create()}r.prototype=Object.create(i.prototype),r.prototype._create=function(){this.isEnabled=!0,this.isPrevious=-1==this.direction;var t=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==t;var e=this.element=document.createElement("button");e.className="flickity-button flickity-prev-next-button",e.className+=this.isPrevious?" flickity-previous":" flickity-next",e.setAttribute("type","button"),this.disable(),e.setAttribute("aria-label",this.isPrevious?"Previous":"Next");var i=this.createSVG();e.appendChild(i),this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},r.prototype.activate=function(){this.bindStartEvent(this.element),this.element.addEventListener("click",this),this.parent.element.appendChild(this.element)},r.prototype.deactivate=function(){this.parent.element.removeChild(this.element),this.unbindStartEvent(this.element),this.element.removeEventListener("click",this)},r.prototype.createSVG=function(){var t=document.createElementNS(o,"svg");t.setAttribute("class","flickity-button-icon"),t.setAttribute("viewBox","0 0 100 100");var e=document.createElementNS(o,"path"),i=function(t){if("string"==typeof t)return t;return"M "+t.x0+",50 L "+t.x1+","+(t.y1+50)+" L "+t.x2+","+(t.y2+50)+" L "+t.x3+",50  L "+t.x2+","+(50-t.y2)+" L "+t.x1+","+(50-t.y1)+" Z"}(this.parent.options.arrowShape);return e.setAttribute("d",i),e.setAttribute("class","arrow"),this.isLeft||e.setAttribute("transform","translate(100, 100) rotate(180) "),t.appendChild(e),t},r.prototype.handleEvent=n.handleEvent,r.prototype.onclick=function(){if(this.isEnabled){this.parent.uiChange();var t=this.isPrevious?"previous":"next";this.parent[t]()}},r.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},r.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},r.prototype.update=function(){var t=this.parent.slides;if(this.parent.options.wrapAround&&t.length>1)this.enable();else{var e=t.length?t.length-1:0,i=this.isPrevious?0:e;this[this.parent.selectedIndex==i?"disable":"enable"]()}},r.prototype.destroy=function(){this.deactivate(),this.allOff()},n.extend(e.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),e.createMethods.push("_createPrevNextButtons");var s=e.prototype;return s._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new r(-1,this),this.nextButton=new r(1,this),this.on("activate",this.activatePrevNextButtons))},s.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},s.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},e.PrevNextButton=r,e})),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/page-dots",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],(function(i,n,o){return e(t,i,n,o)})):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):e(t,t.Flickity,t.Unipointer,t.fizzyUIUtils)}(window,(function(t,e,i,n){function o(t){this.parent=t,this._create()}o.prototype=Object.create(i.prototype),o.prototype._create=function(){this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",this.dots=[],this.handleClick=this.onClick.bind(this),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},o.prototype.activate=function(){this.setDots(),this.holder.addEventListener("click",this.handleClick),this.bindStartEvent(this.holder),this.parent.element.appendChild(this.holder)},o.prototype.deactivate=function(){this.holder.removeEventListener("click",this.handleClick),this.unbindStartEvent(this.holder),this.parent.element.removeChild(this.holder)},o.prototype.setDots=function(){var t=this.parent.slides.length-this.dots.length;t>0?this.addDots(t):t<0&&this.removeDots(-t)},o.prototype.addDots=function(t){for(var e=document.createDocumentFragment(),i=[],n=this.dots.length,o=n+t,r=n;r<o;r++){var s=document.createElement("li");s.className="dot",s.setAttribute("aria-label","Page dot "+(r+1)),e.appendChild(s),i.push(s)}this.holder.appendChild(e),this.dots=this.dots.concat(i)},o.prototype.removeDots=function(t){this.dots.splice(this.dots.length-t,t).forEach((function(t){this.holder.removeChild(t)}),this)},o.prototype.updateSelected=function(){this.selectedDot&&(this.selectedDot.className="dot",this.selectedDot.removeAttribute("aria-current")),this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected",this.selectedDot.setAttribute("aria-current","step"))},o.prototype.onTap=o.prototype.onClick=function(t){var e=t.target;if("LI"==e.nodeName){this.parent.uiChange();var i=this.dots.indexOf(e);this.parent.select(i)}},o.prototype.destroy=function(){this.deactivate(),this.allOff()},e.PageDots=o,n.extend(e.defaults,{pageDots:!0}),e.createMethods.push("_createPageDots");var r=e.prototype;return r._createPageDots=function(){this.options.pageDots&&(this.pageDots=new o(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},r.activatePageDots=function(){this.pageDots.activate()},r.updateSelectedPageDots=function(){this.pageDots.updateSelected()},r.updatePageDots=function(){this.pageDots.setDots()},r.deactivatePageDots=function(){this.pageDots.deactivate()},e.PageDots=o,e})),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/player",["ev-emitter/ev-emitter","fizzy-ui-utils/utils","./flickity"],(function(t,i,n){return e(t,i,n)})):"object"==typeof module&&module.exports?module.exports=e(require("ev-emitter"),require("fizzy-ui-utils"),require("./flickity")):e(t.EvEmitter,t.fizzyUIUtils,t.Flickity)}(window,(function(t,e,i){function n(t){this.parent=t,this.state="stopped",this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}n.prototype=Object.create(t.prototype),n.prototype.play=function(){"playing"!=this.state&&(document.hidden?document.addEventListener("visibilitychange",this.onVisibilityPlay):(this.state="playing",document.addEventListener("visibilitychange",this.onVisibilityChange),this.tick()))},n.prototype.tick=function(){if("playing"==this.state){var t=this.parent.options.autoPlay;t="number"==typeof t?t:3e3;var e=this;this.clear(),this.timeout=setTimeout((function(){e.parent.next(!0),e.tick()}),t)}},n.prototype.stop=function(){this.state="stopped",this.clear(),document.removeEventListener("visibilitychange",this.onVisibilityChange)},n.prototype.clear=function(){clearTimeout(this.timeout)},n.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},n.prototype.unpause=function(){"paused"==this.state&&this.play()},n.prototype.visibilityChange=function(){this[document.hidden?"pause":"unpause"]()},n.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},e.extend(i.defaults,{pauseAutoPlayOnHover:!0}),i.createMethods.push("_createPlayer");var o=i.prototype;return o._createPlayer=function(){this.player=new n(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},o.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},o.playPlayer=function(){this.player.play()},o.stopPlayer=function(){this.player.stop()},o.pausePlayer=function(){this.player.pause()},o.unpausePlayer=function(){this.player.unpause()},o.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},o.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},o.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},i.Player=n,i})),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/add-remove-cell",["./flickity","fizzy-ui-utils/utils"],(function(i,n){return e(t,i,n)})):"object"==typeof module&&module.exports?module.exports=e(t,require("./flickity"),require("fizzy-ui-utils")):e(t,t.Flickity,t.fizzyUIUtils)}(window,(function(t,e,i){var n=e.prototype;return n.insert=function(t,e){var i=this._makeCells(t);if(i&&i.length){var n=this.cells.length;e=void 0===e?n:e;var o=function(t){var e=document.createDocumentFragment();return t.forEach((function(t){e.appendChild(t.element)})),e}(i),r=e==n;if(r)this.slider.appendChild(o);else{var s=this.cells[e].element;this.slider.insertBefore(o,s)}if(0===e)this.cells=i.concat(this.cells);else if(r)this.cells=this.cells.concat(i);else{var a=this.cells.splice(e,n-e);this.cells=this.cells.concat(i).concat(a)}this._sizeCells(i),this.cellChange(e,!0)}},n.append=function(t){this.insert(t,this.cells.length)},n.prepend=function(t){this.insert(t,0)},n.remove=function(t){var e=this.getCells(t);if(e&&e.length){var n=this.cells.length-1;e.forEach((function(t){t.remove();var e=this.cells.indexOf(t);n=Math.min(e,n),i.removeFrom(this.cells,t)}),this),this.cellChange(n,!0)}},n.cellSizeChange=function(t){var e=this.getCell(t);if(e){e.getSize();var i=this.cells.indexOf(e);this.cellChange(i)}},n.cellChange=function(t,e){var i=this.selectedElement;this._positionCells(t),this._getWrapShiftCells(),this.setGallerySize();var n=this.getCell(i);n&&(this.selectedIndex=this.getCellSlideIndex(n)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[t]),this.select(this.selectedIndex),e&&this.positionSliderAtSelected()},e})),
/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */
function(t,e){"function"==typeof define&&define.amd?define("flickity/js/index",["./flickity","./drag","./prev-next-button","./page-dots","./player","./add-remove-cell"],e):"object"==typeof module&&module.exports&&(module.exports=e(require("./flickity"),require("./drag"),require("./prev-next-button"),require("./page-dots"),require("./player"),require("./add-remove-cell")))}(window,(function(t){return t})),function(t,e){"function"==typeof define&&define.amd?define(["flickity/js/index","fizzy-ui-utils/utils"],e):"object"==typeof module&&module.exports?module.exports=e(require("flickity"),require("fizzy-ui-utils")):e(t.Flickity,t.fizzyUIUtils)}(this,(function(t,e){var i=t.Slide,n=i.prototype.updateTarget;i.prototype.updateTarget=function(){if(n.apply(this,arguments),this.parent.options.fade){var t=this.target-this.x,e=this.cells[0].x;this.cells.forEach((function(i){var n=i.x-e-t;i.renderPosition(n)}))}};var o=t.prototype;t.createMethods.push("_createFade"),o._createFade=function(){this.fadeIndex=this.selectedIndex,this.prevSelectedIndex=this.selectedIndex,this.on("select",this.onSelectFade),this.on("dragEnd",this.onDragEndFade),this.on("settle",this.onSettleFade),this.on("activate",this.onActivateFade),this.on("deactivate",this.onDeactivateFade)};var r=o.updateSlides;o.updateSlides=function(){r.apply(this,arguments),this.options.fade},o.onSelectFade=function(){this.fadeIndex=Math.min(this.prevSelectedIndex,this.slides.length-1),this.prevSelectedIndex=this.selectedIndex},o.onSettleFade=function(){if(delete this.didDragEnd,this.options.fade)this.slides[this.fadeIndex]},o.onDragEndFade=function(){this.didDragEnd=!0},o.onActivateFade=function(){this.options.fade&&this.element.classList.add("is-fade")},o.onDeactivateFade=function(){this.options.fade&&this.element.classList.remove("is-fade")};var s=o.positionSlider;o.positionSlider=function(){this.options.fade?(this.fadeSlides(),this.dispatchScrollEvent()):s.apply(this,arguments)};var a=o.positionSliderAtSelected;o.positionSliderAtSelected=function(){this.options.fade&&this.setTranslateX(0),a.apply(this,arguments)},o.fadeSlides=function(){if(!(this.slides.length<2)){var t=this.getFadeIndexes(),e=this.slides[t.a],i=this.slides[t.b],n=this.wrapDifference(e.target,i.target),o=this.wrapDifference(e.target,-this.x);o/=n;var r=t.a;this.isDragging&&(r=o>.5?t.a:t.b);null!=this.fadeHideIndex&&this.fadeHideIndex!=r&&this.fadeHideIndex!=t.a&&(this.fadeHideIndex,t.b);this.fadeHideIndex=r}},o.getFadeIndexes=function(){return this.isDragging||this.didDragEnd?this.options.wrapAround?this.getFadeDragWrapIndexes():this.getFadeDragLimitIndexes():{a:this.fadeIndex,b:this.selectedIndex}},o.getFadeDragWrapIndexes=function(){var t=this.slides.map((function(t,e){return this.getSlideDistance(-this.x,e)}),this),i=t.map((function(t){return Math.abs(t)})),n=Math.min.apply(Math,i),o=i.indexOf(n),r=t[o],s=this.slides.length,a=r>=0?1:-1;return{a:o,b:e.modulo(o+a,s)}},o.getFadeDragLimitIndexes=function(){for(var t=0,e=0;e<this.slides.length-1;e++){var i=this.slides[e];if(-this.x<i.target)break;t=e}return{a:t,b:t+1}},o.wrapDifference=function(t,e){var i=e-t;if(!this.options.wrapAround)return i;var n=i+this.slideableWidth,o=i-this.slideableWidth;return Math.abs(n)<Math.abs(i)&&(i=n),Math.abs(o)<Math.abs(i)&&(i=o),i};var l=o._getWrapShiftCells;o._getWrapShiftCells=function(){this.options.fade||l.apply(this,arguments)};var c=o.shiftWrapCells;return o.shiftWrapCells=function(){this.options.fade||c.apply(this,arguments)},t})),
/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
function(t,e){"function"==typeof define&&define.amd?define(e):"object"==typeof exports?module.exports=e():t.PhotoSwipe=e()}(this,(function(){"use strict";return function(t,e,i,n){var o={features:null,bind:function(t,e,i,n){var o=(n?"remove":"add")+"EventListener";e=e.split(" ");for(var r=0;r<e.length;r++)e[r]&&t[o](e[r],i,!1)},isArray:function(t){return t instanceof Array},createEl:function(t,e){var i=document.createElement(e||"div");return t&&(i.className=t),i},getScrollY:function(){var t=window.pageYOffset;return void 0!==t?t:document.documentElement.scrollTop},unbind:function(t,e,i){o.bind(t,e,i,!0)},removeClass:function(t,e){var i=new RegExp("(\\s|^)"+e+"(\\s|$)");t.className=t.className.replace(i," ").replace(/^\s\s*/,"").replace(/\s\s*$/,"")},addClass:function(t,e){o.hasClass(t,e)||(t.className+=(t.className?" ":"")+e)},hasClass:function(t,e){return t.className&&new RegExp("(^|\\s)"+e+"(\\s|$)").test(t.className)},getChildByClass:function(t,e){for(var i=t.firstChild;i;){if(o.hasClass(i,e))return i;i=i.nextSibling}},arraySearch:function(t,e,i){for(var n=t.length;n--;)if(t[n][i]===e)return n;return-1},extend:function(t,e,i){for(var n in e)if(e.hasOwnProperty(n)){if(i&&t.hasOwnProperty(n))continue;t[n]=e[n]}},easing:{sine:{out:function(t){return Math.sin(t*(Math.PI/2))},inOut:function(t){return-(Math.cos(Math.PI*t)-1)/2}},cubic:{out:function(t){return--t*t*t+1}}},detectFeatures:function(){if(o.features)return o.features;var t=o.createEl().style,e="",i={};if(i.oldIE=document.all&&!document.addEventListener,i.touch="ontouchstart"in window,window.requestAnimationFrame&&(i.raf=window.requestAnimationFrame,i.caf=window.cancelAnimationFrame),i.pointerEvent=!!window.PointerEvent||navigator.msPointerEnabled,!i.pointerEvent){var n=navigator.userAgent;if(/iP(hone|od)/.test(navigator.platform)){var r=navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);r&&r.length>0&&(r=parseInt(r[1],10))>=1&&r<8&&(i.isOldIOSPhone=!0)}var s=n.match(/Android\s([0-9\.]*)/),a=s?s[1]:0;(a=parseFloat(a))>=1&&(a<4.4&&(i.isOldAndroid=!0),i.androidVersion=a),i.isMobileOpera=/opera mini|opera mobi/i.test(n)}for(var l,c,u=["transform","perspective","animationName"],d=["","webkit","Moz","ms","O"],h=0;h<4;h++){e=d[h];for(var p=0;p<3;p++)l=u[p],c=e+(e?l.charAt(0).toUpperCase()+l.slice(1):l),!i[l]&&c in t&&(i[l]=c);e&&!i.raf&&(e=e.toLowerCase(),i.raf=window[e+"RequestAnimationFrame"],i.raf&&(i.caf=window[e+"CancelAnimationFrame"]||window[e+"CancelRequestAnimationFrame"]))}if(!i.raf){var f=0;i.raf=function(t){var e=(new Date).getTime(),i=Math.max(0,16-(e-f)),n=window.setTimeout((function(){t(e+i)}),i);return f=e+i,n},i.caf=function(t){clearTimeout(t)}}return i.svg=!!document.createElementNS&&!!document.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,o.features=i,i}};o.detectFeatures(),o.features.oldIE&&(o.bind=function(t,e,i,n){e=e.split(" ");for(var o,r=(n?"detach":"attach")+"Event",s=function(){i.handleEvent.call(i)},a=0;a<e.length;a++)if(o=e[a])if("object"==typeof i&&i.handleEvent){if(n){if(!i["oldIE"+o])return!1}else i["oldIE"+o]=s;t[r]("on"+o,i["oldIE"+o])}else t[r]("on"+o,i)});var r=this,s={allowPanToNext:!0,spacing:.12,bgOpacity:1,mouseUsed:!1,loop:!0,pinchToClose:!0,closeOnScroll:!0,closeOnVerticalDrag:!0,verticalDragRange:.75,hideAnimationDuration:333,showAnimationDuration:333,showHideOpacity:!1,focus:!0,escKey:!0,arrowKeys:!0,mainScrollEndFriction:.35,panEndFriction:.35,isClickableElement:function(t){return"A"===t.tagName},getDoubleTapZoom:function(t,e){return t||e.initialZoomLevel<.7?1:1.33},maxSpreadZoom:1.33,modal:!0,scaleMode:"fit"};o.extend(s,n);var a,l,c,u,d,h,p,f,m,g,v,y,b,x,w,S,E,C,D,k,P,_,I,A,T,M,z,L,O,F,N,U,R,j,W,V,H,q,B,Z,X,Y,G,K,$,J,Q,tt,et,it,nt,ot,rt,st,at,lt,ct={x:0,y:0},ut={x:0,y:0},dt={x:0,y:0},ht={},pt=0,ft={},mt={x:0,y:0},gt=0,vt=!0,yt=[],bt={},xt=!1,wt=function(t,e){o.extend(r,e.publicMethods),yt.push(t)},St=function(t){var e=We();return t>e-1?t-e:t<0?e+t:t},Et={},Ct=function(t,e){return Et[t]||(Et[t]=[]),Et[t].push(e)},Dt=function(t){var e=Et[t];if(e){var i=Array.prototype.slice.call(arguments);i.shift();for(var n=0;n<e.length;n++)e[n].apply(r,i)}},kt=function(){return(new Date).getTime()},Pt=function(t){st=t,r.bg.style.opacity=t*s.bgOpacity},_t=function(t,e,i,n,o){(!xt||o&&o!==r.currItem)&&(n/=o?o.fitRatio:r.currItem.fitRatio),t[_]=y+e+"px, "+i+"px"+b+" scale("+n+")"},It=function(t){et&&(t&&(g>r.currItem.fitRatio?xt||(Ke(r.currItem,!1,!0),xt=!0):xt&&(Ke(r.currItem),xt=!1)),_t(et,dt.x,dt.y,g))},At=function(t){t.container&&_t(t.container.style,t.initialPosition.x,t.initialPosition.y,t.initialZoomLevel,t)},Tt=function(t,e){e[_]=y+t+"px, 0px"+b},Mt=function(t,e){if(!s.loop&&e){var i=u+(mt.x*pt-t)/mt.x,n=Math.round(t-ue.x);(i<0&&n>0||i>=We()-1&&n<0)&&(t=ue.x+n*s.mainScrollEndFriction)}ue.x=t,Tt(t,d)},zt=function(t,e){var i=de[t]-ft[t];return ut[t]+ct[t]+i-i*(e/v)},Lt=function(t,e){t.x=e.x,t.y=e.y,e.id&&(t.id=e.id)},Ot=function(t){t.x=Math.round(t.x),t.y=Math.round(t.y)},Ft=null,Nt=function(){Ft&&(o.unbind(document,"mousemove",Nt),o.addClass(t,"pswp--has_mouse"),s.mouseUsed=!0,Dt("mouseUsed")),Ft=setTimeout((function(){Ft=null}),100)},Ut=function(t,e){var i=Ze(r.currItem,ht,t);return e&&(tt=i),i},Rt=function(t){return t||(t=r.currItem),t.initialZoomLevel},jt=function(t){return t||(t=r.currItem),t.w>0?s.maxSpreadZoom:1},Wt=function(t,e,i,n){return n===r.currItem.initialZoomLevel?(i[t]=r.currItem.initialPosition[t],!0):(i[t]=zt(t,n),i[t]>e.min[t]?(i[t]=e.min[t],!0):i[t]<e.max[t]&&(i[t]=e.max[t],!0))},Vt=function(t){var e="";s.escKey&&27===t.keyCode?e="close":s.arrowKeys&&(37===t.keyCode?e="prev":39===t.keyCode&&(e="next")),e&&(t.ctrlKey||t.altKey||t.shiftKey||t.metaKey||(t.preventDefault?t.preventDefault():t.returnValue=!1,r[e]()))},Ht=function(t){t&&(Y||X||it||H)&&(t.preventDefault(),t.stopPropagation())},qt=function(){r.setScrollOffset(0,o.getScrollY())},Bt={},Zt=0,Xt=function(t){Bt[t]&&(Bt[t].raf&&M(Bt[t].raf),Zt--,delete Bt[t])},Yt=function(t){Bt[t]&&Xt(t),Bt[t]||(Zt++,Bt[t]={})},Gt=function(){for(var t in Bt)Bt.hasOwnProperty(t)&&Xt(t)},Kt=function(t,e,i,n,o,r,s){var a,l=kt();Yt(t);var c=function(){if(Bt[t]){if((a=kt()-l)>=n)return Xt(t),r(i),void(s&&s());r((i-e)*o(a/n)+e),Bt[t].raf=T(c)}};c()},$t={shout:Dt,listen:Ct,viewportSize:ht,options:s,isMainScrollAnimating:function(){return it},getZoomLevel:function(){return g},getCurrentIndex:function(){return u},isDragging:function(){return B},isZooming:function(){return J},setScrollOffset:function(t,e){ft.x=t,F=ft.y=e,Dt("updateScrollOffset",ft)},applyZoomPan:function(t,e,i,n){dt.x=e,dt.y=i,g=t,It(n)},init:function(){if(!a&&!l){var i;r.framework=o,r.template=t,r.bg=o.getChildByClass(t,"pswp__bg"),z=t.className,a=!0,N=o.detectFeatures(),T=N.raf,M=N.caf,_=N.transform,O=N.oldIE,r.scrollWrap=o.getChildByClass(t,"pswp__scroll-wrap"),r.container=o.getChildByClass(r.scrollWrap,"pswp__container"),d=r.container.style,r.itemHolders=S=[{el:r.container.children[0],wrap:0,index:-1},{el:r.container.children[1],wrap:0,index:-1},{el:r.container.children[2],wrap:0,index:-1}],S[0].el.style.display=S[2].el.style.display="none",function(){if(_){var e=N.perspective&&!A;return y="translate"+(e?"3d(":"("),void(b=N.perspective?", 0px)":")")}_="left",o.addClass(t,"pswp--ie"),Tt=function(t,e){e.left=t+"px"},At=function(t){var e=t.fitRatio>1?1:t.fitRatio,i=t.container.style,n=e*t.w,o=e*t.h;i.width=n+"px",i.height=o+"px",i.left=t.initialPosition.x+"px",i.top=t.initialPosition.y+"px"},It=function(){if(et){var t=et,e=r.currItem,i=e.fitRatio>1?1:e.fitRatio,n=i*e.w,o=i*e.h;t.width=n+"px",t.height=o+"px",t.left=dt.x+"px",t.top=dt.y+"px"}}}(),m={resize:r.updateSize,orientationchange:function(){clearTimeout(U),U=setTimeout((function(){ht.x!==r.scrollWrap.clientWidth&&r.updateSize()}),500)},scroll:qt,keydown:Vt,click:Ht};var n=N.isOldIOSPhone||N.isOldAndroid||N.isMobileOpera;for(N.animationName&&N.transform&&!n||(s.showAnimationDuration=s.hideAnimationDuration=0),i=0;i<yt.length;i++)r["init"+yt[i]]();if(e)(r.ui=new e(r,o)).init();Dt("firstUpdate"),u=u||s.index||0,(isNaN(u)||u<0||u>=We())&&(u=0),r.currItem=je(u),(N.isOldIOSPhone||N.isOldAndroid)&&(vt=!1),t.setAttribute("aria-hidden","false"),s.modal&&(vt?t.style.position="fixed":(t.style.position="absolute",t.style.top=o.getScrollY()+"px")),void 0===F&&(Dt("initialLayout"),F=L=o.getScrollY());var c="pswp--open ";for(s.mainClass&&(c+=s.mainClass+" "),s.showHideOpacity&&(c+="pswp--animate_opacity "),c+=A?"pswp--touch":"pswp--notouch",c+=N.animationName?" pswp--css_animation":"",c+=N.svg?" pswp--svg":"",o.addClass(t,c),r.updateSize(),h=-1,gt=null,i=0;i<3;i++)Tt((i+h)*mt.x,S[i].el.style);O||o.bind(r.scrollWrap,f,r),Ct("initialZoomInEnd",(function(){r.setContent(S[0],u-1),r.setContent(S[2],u+1),S[0].el.style.display=S[2].el.style.display="block",s.focus&&t.focus(),o.bind(document,"keydown",r),N.transform&&o.bind(r.scrollWrap,"click",r),s.mouseUsed||o.bind(document,"mousemove",Nt),o.bind(window,"resize scroll orientationchange",r),Dt("bindEvents")})),r.setContent(S[1],u),r.updateCurrItem(),Dt("afterInit"),vt||(x=setInterval((function(){Zt||B||J||g!==r.currItem.initialZoomLevel||r.updateSize()}),1e3)),o.addClass(t,"pswp--visible")}},close:function(){a&&(a=!1,l=!0,Dt("close"),o.unbind(window,"resize scroll orientationchange",r),o.unbind(window,"scroll",m.scroll),o.unbind(document,"keydown",r),o.unbind(document,"mousemove",Nt),N.transform&&o.unbind(r.scrollWrap,"click",r),B&&o.unbind(window,p,r),clearTimeout(U),Dt("unbindEvents"),Ve(r.currItem,null,!0,r.destroy))},destroy:function(){Dt("destroy"),Fe&&clearTimeout(Fe),t.setAttribute("aria-hidden","true"),t.className=z,x&&clearInterval(x),o.unbind(r.scrollWrap,f,r),o.unbind(window,"scroll",r),fe(),Gt(),Et=null},panTo:function(t,e,i){i||(t>tt.min.x?t=tt.min.x:t<tt.max.x&&(t=tt.max.x),e>tt.min.y?e=tt.min.y:e<tt.max.y&&(e=tt.max.y)),dt.x=t,dt.y=e,It()},handleEvent:function(t){t=t||window.event,m[t.type]&&m[t.type](t)},goTo:function(t){var e=(t=St(t))-u;gt=e,u=t,r.currItem=je(u),pt-=e,Mt(mt.x*pt),Gt(),it=!1,r.updateCurrItem()},next:function(){r.goTo(u+1)},prev:function(){r.goTo(u-1)},updateCurrZoomItem:function(t){if(t&&Dt("beforeChange",0),S[1].el.children.length){var e=S[1].el.children[0];et=o.hasClass(e,"pswp__zoom-wrap")?e.style:null}else et=null;tt=r.currItem.bounds,v=g=r.currItem.initialZoomLevel,dt.x=tt.center.x,dt.y=tt.center.y,t&&Dt("afterChange")},invalidateCurrItems:function(){w=!0;for(var t=0;t<3;t++)S[t].item&&(S[t].item.needsUpdate=!0)},updateCurrItem:function(t){if(0!==gt){var e,i=Math.abs(gt);if(!(t&&i<2)){r.currItem=je(u),xt=!1,Dt("beforeChange",gt),i>=3&&(h+=gt+(gt>0?-3:3),i=3);for(var n=0;n<i;n++)gt>0?(e=S.shift(),S[2]=e,h++,Tt((h+2)*mt.x,e.el.style),r.setContent(e,u-i+n+1+1)):(e=S.pop(),S.unshift(e),h--,Tt(h*mt.x,e.el.style),r.setContent(e,u+i-n-1-1));if(et&&1===Math.abs(gt)){var o=je(E);o.initialZoomLevel!==g&&(Ze(o,ht),Ke(o),At(o))}gt=0,r.updateCurrZoomItem(),E=u,Dt("afterChange")}}},updateSize:function(e){if(!vt&&s.modal){var i=o.getScrollY();if(F!==i&&(t.style.top=i+"px",F=i),!e&&bt.x===window.innerWidth&&bt.y===window.innerHeight)return;bt.x=window.innerWidth,bt.y=window.innerHeight,t.style.height=bt.y+"px"}if(ht.x=r.scrollWrap.clientWidth,ht.y=r.scrollWrap.clientHeight,qt(),mt.x=ht.x+Math.round(ht.x*s.spacing),mt.y=ht.y,Mt(mt.x*pt),Dt("beforeResize"),void 0!==h){for(var n,a,l,c=0;c<3;c++)n=S[c],Tt((c+h)*mt.x,n.el.style),l=u+c-1,s.loop&&We()>2&&(l=St(l)),(a=je(l))&&(w||a.needsUpdate||!a.bounds)?(r.cleanSlide(a),r.setContent(n,l),1===c&&(r.currItem=a,r.updateCurrZoomItem(!0)),a.needsUpdate=!1):-1===n.index&&l>=0&&r.setContent(n,l),a&&a.container&&(Ze(a,ht),Ke(a),At(a));w=!1}v=g=r.currItem.initialZoomLevel,(tt=r.currItem.bounds)&&(dt.x=tt.center.x,dt.y=tt.center.y,It(!0)),Dt("resize")},zoomTo:function(t,e,i,n,r){e&&(v=g,de.x=Math.abs(e.x)-dt.x,de.y=Math.abs(e.y)-dt.y,Lt(ut,dt));var s=Ut(t,!1),a={};Wt("x",s,a,t),Wt("y",s,a,t);var l=g,c=dt.x,u=dt.y;Ot(a);var d=function(e){1===e?(g=t,dt.x=a.x,dt.y=a.y):(g=(t-l)*e+l,dt.x=(a.x-c)*e+c,dt.y=(a.y-u)*e+u),r&&r(e),It(1===e)};i?Kt("customZoomTo",0,1,i,n||o.easing.sine.inOut,d):d(1)}},Jt={},Qt={},te={},ee={},ie={},ne=[],oe={},re=[],se={},ae=0,le={x:0,y:0},ce=0,ue={x:0,y:0},de={x:0,y:0},he={x:0,y:0},pe=function(t,e){return se.x=Math.abs(t.x-e.x),se.y=Math.abs(t.y-e.y),Math.sqrt(se.x*se.x+se.y*se.y)},fe=function(){G&&(M(G),G=null)},me=function(){B&&(G=T(me),Ie())},ge=function(t,e){return!(!t||t===document)&&(!(t.getAttribute("class")&&t.getAttribute("class").indexOf("pswp__scroll-wrap")>-1)&&(e(t)?t:ge(t.parentNode,e)))},ve={},ye=function(t,e){return ve.prevent=!ge(t.target,s.isClickableElement),Dt("preventDragEvent",t,e,ve),ve.prevent},be=function(t,e){return e.x=t.pageX,e.y=t.pageY,e.id=t.identifier,e},xe=function(t,e,i){i.x=.5*(t.x+e.x),i.y=.5*(t.y+e.y)},we=function(){var t=dt.y-r.currItem.initialPosition.y;return 1-Math.abs(t/(ht.y/2))},Se={},Ee={},Ce=[],De=function(t){for(;Ce.length>0;)Ce.pop();return I?(lt=0,ne.forEach((function(t){0===lt?Ce[0]=t:1===lt&&(Ce[1]=t),lt++}))):t.type.indexOf("touch")>-1?t.touches&&t.touches.length>0&&(Ce[0]=be(t.touches[0],Se),t.touches.length>1&&(Ce[1]=be(t.touches[1],Ee))):(Se.x=t.pageX,Se.y=t.pageY,Se.id="",Ce[0]=Se),Ce},ke=function(t,e){var i,n,o,a,l=dt[t]+e[t],c=e[t]>0,u=ue.x+e.x,d=ue.x-oe.x;if(i=l>tt.min[t]||l<tt.max[t]?s.panEndFriction:1,l=dt[t]+e[t]*i,(s.allowPanToNext||g===r.currItem.initialZoomLevel)&&(et?"h"!==nt||"x"!==t||X||(c?(l>tt.min[t]&&(i=s.panEndFriction,tt.min[t]-l,n=tt.min[t]-ut[t]),(n<=0||d<0)&&We()>1?(a=u,d<0&&u>oe.x&&(a=oe.x)):tt.min.x!==tt.max.x&&(o=l)):(l<tt.max[t]&&(i=s.panEndFriction,l-tt.max[t],n=ut[t]-tt.max[t]),(n<=0||d>0)&&We()>1?(a=u,d>0&&u<oe.x&&(a=oe.x)):tt.min.x!==tt.max.x&&(o=l))):a=u,"x"===t))return void 0!==a&&(Mt(a,!0),K=a!==oe.x),tt.min.x!==tt.max.x&&(void 0!==o?dt.x=o:K||(dt.x+=e.x*i)),void 0!==a;it||K||g>r.currItem.fitRatio&&(dt[t]+=e[t]*i)},Pe=function(t){if(!("mousedown"===t.type&&t.button>0))if(Re)t.preventDefault();else if(!q||"mousedown"!==t.type){if(ye(t,!0)&&t.preventDefault(),Dt("pointerDown"),I){var e=o.arraySearch(ne,t.pointerId,"id");e<0&&(e=ne.length),ne[e]={x:t.pageX,y:t.pageY,id:t.pointerId}}var i=De(t),n=i.length;$=null,Gt(),B&&1!==n||(B=ot=!0,o.bind(window,p,r),V=at=rt=H=K=Y=Z=X=!1,nt=null,Dt("firstTouchStart",i),Lt(ut,dt),ct.x=ct.y=0,Lt(ee,i[0]),Lt(ie,ee),oe.x=mt.x*pt,re=[{x:ee.x,y:ee.y}],j=R=kt(),Ut(g,!0),fe(),me()),!J&&n>1&&!it&&!K&&(v=g,X=!1,J=Z=!0,ct.y=ct.x=0,Lt(ut,dt),Lt(Jt,i[0]),Lt(Qt,i[1]),xe(Jt,Qt,he),de.x=Math.abs(he.x)-dt.x,de.y=Math.abs(he.y)-dt.y,Q=pe(Jt,Qt))}},_e=function(t){if(t.preventDefault(),I){var e=o.arraySearch(ne,t.pointerId,"id");if(e>-1){var i=ne[e];i.x=t.pageX,i.y=t.pageY}}if(B){var n=De(t);if(nt||Y||J)$=n;else if(ue.x!==mt.x*pt)nt="h";else{var r=Math.abs(n[0].x-ee.x)-Math.abs(n[0].y-ee.y);Math.abs(r)>=10&&(nt=r>0?"h":"v",$=n)}}},Ie=function(){if($){var t=$.length;if(0!==t)if(Lt(Jt,$[0]),te.x=Jt.x-ee.x,te.y=Jt.y-ee.y,J&&t>1){if(ee.x=Jt.x,ee.y=Jt.y,!te.x&&!te.y&&function(t,e){return t.x===e.x&&t.y===e.y}($[1],Qt))return;Lt(Qt,$[1]),X||(X=!0,Dt("zoomGestureStarted"));var e=pe(Jt,Qt),i=Le(e);i>r.currItem.initialZoomLevel+r.currItem.initialZoomLevel/15&&(at=!0);var n=1,o=Rt(),a=jt();if(i<o)if(s.pinchToClose&&!at&&v<=r.currItem.initialZoomLevel){var l=1-(o-i)/(o/1.2);Pt(l),Dt("onPinchClose",l),rt=!0}else(n=(o-i)/o)>1&&(n=1),i=o-n*(o/3);else i>a&&((n=(i-a)/(6*o))>1&&(n=1),i=a+n*o);n<0&&(n=0),e,xe(Jt,Qt,le),ct.x+=le.x-he.x,ct.y+=le.y-he.y,Lt(he,le),dt.x=zt("x",i),dt.y=zt("y",i),V=i>g,g=i,It()}else{if(!nt)return;if(ot&&(ot=!1,Math.abs(te.x)>=10&&(te.x-=$[0].x-ie.x),Math.abs(te.y)>=10&&(te.y-=$[0].y-ie.y)),ee.x=Jt.x,ee.y=Jt.y,0===te.x&&0===te.y)return;if("v"===nt&&s.closeOnVerticalDrag&&"fit"===s.scaleMode&&g===r.currItem.initialZoomLevel){ct.y+=te.y,dt.y+=te.y;var c=we();return H=!0,Dt("onVerticalDrag",c),Pt(c),void It()}!function(t,e,i){if(t-j>50){var n=re.length>2?re.shift():{};n.x=e,n.y=i,re.push(n),j=t}}(kt(),Jt.x,Jt.y),Y=!0,tt=r.currItem.bounds,ke("x",te)||(ke("y",te),Ot(dt),It())}}},Ae=function(t){if(N.isOldAndroid){if(q&&"mouseup"===t.type)return;t.type.indexOf("touch")>-1&&(clearTimeout(q),q=setTimeout((function(){q=0}),600))}var e;if(Dt("pointerUp"),ye(t,!1)&&t.preventDefault(),I){var i=o.arraySearch(ne,t.pointerId,"id");if(i>-1)if(e=ne.splice(i,1)[0],navigator.msPointerEnabled){e.type={4:"mouse",2:"touch",3:"pen"}[t.pointerType],e.type||(e.type=t.pointerType||"mouse")}else e.type=t.pointerType||"mouse"}var n,a=De(t),l=a.length;if("mouseup"===t.type&&(l=0),2===l)return $=null,!0;1===l&&Lt(ie,a[0]),0!==l||nt||it||(e||("mouseup"===t.type?e={x:t.pageX,y:t.pageY,type:"mouse"}:t.changedTouches&&t.changedTouches[0]&&(e={x:t.changedTouches[0].pageX,y:t.changedTouches[0].pageY,type:"touch"})),Dt("touchRelease",t,e));var c=-1;if(0===l&&(B=!1,o.unbind(window,p,r),fe(),J?c=0:-1!==ce&&(c=kt()-ce)),ce=1===l?kt():-1,n=-1!==c&&c<150?"zoom":"swipe",J&&l<2&&(J=!1,1===l&&(n="zoomPointerUp"),Dt("zoomGestureEnded")),$=null,Y||X||it||H)if(Gt(),W||(W=Te()),W.calculateSwipeSpeed("x"),H){if(we()<s.verticalDragRange)r.close();else{var u=dt.y,d=st;Kt("verticalDrag",0,1,300,o.easing.cubic.out,(function(t){dt.y=(r.currItem.initialPosition.y-u)*t+u,Pt((1-d)*t+d),It()})),Dt("onVerticalDrag",1)}}else{if((K||it)&&0===l){if(ze(n,W))return;n="zoomPointerUp"}it||("swipe"===n?!K&&g>r.currItem.fitRatio&&Me(W):Oe())}},Te=function(){var t,e,i={lastFlickOffset:{},lastFlickDist:{},lastFlickSpeed:{},slowDownRatio:{},slowDownRatioReverse:{},speedDecelerationRatio:{},speedDecelerationRatioAbs:{},distanceOffset:{},backAnimDestination:{},backAnimStarted:{},calculateSwipeSpeed:function(n){re.length>1?(t=kt()-j+50,e=re[re.length-2][n]):(t=kt()-R,e=ie[n]),i.lastFlickOffset[n]=ee[n]-e,i.lastFlickDist[n]=Math.abs(i.lastFlickOffset[n]),i.lastFlickDist[n]>20?i.lastFlickSpeed[n]=i.lastFlickOffset[n]/t:i.lastFlickSpeed[n]=0,Math.abs(i.lastFlickSpeed[n])<.1&&(i.lastFlickSpeed[n]=0),i.slowDownRatio[n]=.95,i.slowDownRatioReverse[n]=1-i.slowDownRatio[n],i.speedDecelerationRatio[n]=1},calculateOverBoundsAnimOffset:function(t,e){i.backAnimStarted[t]||(dt[t]>tt.min[t]?i.backAnimDestination[t]=tt.min[t]:dt[t]<tt.max[t]&&(i.backAnimDestination[t]=tt.max[t]),void 0!==i.backAnimDestination[t]&&(i.slowDownRatio[t]=.7,i.slowDownRatioReverse[t]=1-i.slowDownRatio[t],i.speedDecelerationRatioAbs[t]<.05&&(i.lastFlickSpeed[t]=0,i.backAnimStarted[t]=!0,Kt("bounceZoomPan"+t,dt[t],i.backAnimDestination[t],e||300,o.easing.sine.out,(function(e){dt[t]=e,It()})))))},calculateAnimOffset:function(t){i.backAnimStarted[t]||(i.speedDecelerationRatio[t]=i.speedDecelerationRatio[t]*(i.slowDownRatio[t]+i.slowDownRatioReverse[t]-i.slowDownRatioReverse[t]*i.timeDiff/10),i.speedDecelerationRatioAbs[t]=Math.abs(i.lastFlickSpeed[t]*i.speedDecelerationRatio[t]),i.distanceOffset[t]=i.lastFlickSpeed[t]*i.speedDecelerationRatio[t]*i.timeDiff,dt[t]+=i.distanceOffset[t])},panAnimLoop:function(){if(Bt.zoomPan&&(Bt.zoomPan.raf=T(i.panAnimLoop),i.now=kt(),i.timeDiff=i.now-i.lastNow,i.lastNow=i.now,i.calculateAnimOffset("x"),i.calculateAnimOffset("y"),It(),i.calculateOverBoundsAnimOffset("x"),i.calculateOverBoundsAnimOffset("y"),i.speedDecelerationRatioAbs.x<.05&&i.speedDecelerationRatioAbs.y<.05))return dt.x=Math.round(dt.x),dt.y=Math.round(dt.y),It(),void Xt("zoomPan")}};return i},Me=function(t){if(t.calculateSwipeSpeed("y"),tt=r.currItem.bounds,t.backAnimDestination={},t.backAnimStarted={},Math.abs(t.lastFlickSpeed.x)<=.05&&Math.abs(t.lastFlickSpeed.y)<=.05)return t.speedDecelerationRatioAbs.x=t.speedDecelerationRatioAbs.y=0,t.calculateOverBoundsAnimOffset("x"),t.calculateOverBoundsAnimOffset("y"),!0;Yt("zoomPan"),t.lastNow=kt(),t.panAnimLoop()},ze=function(t,e){var i,n,a;if(it||(ae=u),"swipe"===t){var l=ee.x-ie.x,c=e.lastFlickDist.x<10;l>30&&(c||e.lastFlickOffset.x>20)?n=-1:l<-30&&(c||e.lastFlickOffset.x<-20)&&(n=1)}n&&((u+=n)<0?(u=s.loop?We()-1:0,a=!0):u>=We()&&(u=s.loop?0:We()-1,a=!0),a&&!s.loop||(gt+=n,pt-=n,i=!0));var d,h=mt.x*pt,p=Math.abs(h-ue.x);return i||h>ue.x==e.lastFlickSpeed.x>0?(d=Math.abs(e.lastFlickSpeed.x)>0?p/Math.abs(e.lastFlickSpeed.x):333,d=Math.min(d,400),d=Math.max(d,250)):d=333,ae===u&&(i=!1),it=!0,Dt("mainScrollAnimStart"),Kt("mainScroll",ue.x,h,d,o.easing.cubic.out,Mt,(function(){Gt(),it=!1,ae=-1,(i||ae!==u)&&r.updateCurrItem(),Dt("mainScrollAnimComplete")})),i&&r.updateCurrItem(!0),i},Le=function(t){return 1/Q*t*v},Oe=function(){var t=g,e=Rt(),i=jt();g<e?t=e:g>i&&(t=i);var n,s=st;return rt&&!V&&!at&&g<e?(r.close(),!0):(rt&&(n=function(t){Pt((1-s)*t+s)}),r.zoomTo(t,0,200,o.easing.cubic.out,n),!0)};wt("Gestures",{publicMethods:{initGestures:function(){var t=function(t,e,i,n,o){C=t+e,D=t+i,k=t+n,P=o?t+o:""};(I=N.pointerEvent)&&N.touch&&(N.touch=!1),I?navigator.msPointerEnabled?t("MSPointer","Down","Move","Up","Cancel"):t("pointer","down","move","up","cancel"):N.touch?(t("touch","start","move","end","cancel"),A=!0):t("mouse","down","move","up"),p=D+" "+k+" "+P,f=C,I&&!A&&(A=navigator.maxTouchPoints>1||navigator.msMaxTouchPoints>1),r.likelyTouchDevice=A,m[C]=Pe,m[D]=_e,m[k]=Ae,P&&(m[P]=m[k]),N.touch&&(f+=" mousedown",p+=" mousemove mouseup",m.mousedown=m[C],m.mousemove=m[D],m.mouseup=m[k]),A||(s.allowPanToNext=!1)}}});var Fe,Ne,Ue,Re,je,We,Ve=function(e,i,n,a){var l;Fe&&clearTimeout(Fe),Re=!0,Ue=!0,e.initialLayout?(l=e.initialLayout,e.initialLayout=null):l=s.getThumbBoundsFn&&s.getThumbBoundsFn(u);var d=n?s.hideAnimationDuration:s.showAnimationDuration,h=function(){Xt("initialZoom"),n?(r.template.removeAttribute("style"),r.bg.removeAttribute("style")):(Pt(1),i&&(i.style.display="block"),o.addClass(t,"pswp--animated-in"),Dt("initialZoom"+(n?"OutEnd":"InEnd"))),a&&a(),Re=!1};if(!d||!l||void 0===l.x)return Dt("initialZoom"+(n?"Out":"In")),g=e.initialZoomLevel,Lt(dt,e.initialPosition),It(),t.style.opacity=n?0:1,Pt(1),void(d?setTimeout((function(){h()}),d):h());var p,f;p=c,f=!r.currItem.src||r.currItem.loadError||s.showHideOpacity,e.miniImg&&(e.miniImg.style.webkitBackfaceVisibility="hidden"),n||(g=l.w/e.w,dt.x=l.x,dt.y=l.y-L,r[f?"template":"bg"].style.opacity=.001,It()),Yt("initialZoom"),n&&!p&&o.removeClass(t,"pswp--animated-in"),f&&(n?o[(p?"remove":"add")+"Class"](t,"pswp--animate_opacity"):setTimeout((function(){o.addClass(t,"pswp--animate_opacity")}),30)),Fe=setTimeout((function(){if(Dt("initialZoom"+(n?"Out":"In")),n){var i=l.w/e.w,r={x:dt.x,y:dt.y},s=g,a=st,c=function(e){1===e?(g=i,dt.x=l.x,dt.y=l.y-F):(g=(i-s)*e+s,dt.x=(l.x-r.x)*e+r.x,dt.y=(l.y-F-r.y)*e+r.y),It(),f?t.style.opacity=1-e:Pt(a-e*a)};p?Kt("initialZoom",0,1,d,o.easing.cubic.out,c,h):(c(1),Fe=setTimeout(h,d+20))}else g=e.initialZoomLevel,Lt(dt,e.initialPosition),It(),Pt(1),f?t.style.opacity=1:Pt(1),Fe=setTimeout(h,d+20)}),n?25:90)},He={},qe=[],Be={index:0,errorMsg:'<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',forceProgressiveLoading:!1,preload:[1,1],getNumItemsFn:function(){return Ne.length}},Ze=function(t,e,i){if(t.src&&!t.loadError){var n=!i;if(n&&(t.vGap||(t.vGap={top:0,bottom:0}),Dt("parseVerticalMargin",t)),He.x=e.x,He.y=e.y-t.vGap.top-t.vGap.bottom,n){var o=He.x/t.w,r=He.y/t.h;t.fitRatio=o<r?o:r;var a=s.scaleMode;"orig"===a?i=1:"fit"===a?i=t.fitRatio:"zoom"===a&&(i=Math.max(t.initialZoomLevel||1,t.fitRatio)),i>1&&(i=1),t.initialZoomLevel=i,t.bounds||(t.bounds={center:{x:0,y:0},max:{x:0,y:0},min:{x:0,y:0}})}if(!i)return;return function(t,e,i){var n=t.bounds;n.center.x=Math.round((He.x-e)/2),n.center.y=Math.round((He.y-i)/2)+t.vGap.top,n.max.x=e>He.x?Math.round(He.x-e):n.center.x,n.max.y=i>He.y?Math.round(He.y-i)+t.vGap.top:n.center.y,n.min.x=e>He.x?0:n.center.x,n.min.y=i>He.y?t.vGap.top:n.center.y}(t,t.w*i,t.h*i),n&&i===t.initialZoomLevel&&(t.initialPosition=t.bounds.center),t.bounds}return t.w=t.h=0,t.initialZoomLevel=t.fitRatio=1,t.bounds={center:{x:0,y:0},max:{x:0,y:0},min:{x:0,y:0}},t.initialPosition=t.bounds.center,t.bounds},Xe=function(t,e,i,n,o,s){e.loadError||n&&(e.imageAppended=!0,Ke(e,n,e===r.currItem&&xt),i.appendChild(n),s&&setTimeout((function(){e&&e.loaded&&e.placeholder&&(e.placeholder.style.display="none",e.placeholder=null)}),500))},Ye=function(t){t.loading=!0,t.loaded=!1;var e=t.img=o.createEl("pswp__img","img"),i=function(){t.loading=!1,t.loaded=!0,t.loadComplete?t.loadComplete(t):t.img=null,e.onload=e.onerror=null,e=null};return e.onload=i,e.onerror=function(){t.loadError=!0,i()},e.src=t.src,e},Ge=function(t,e){if(t.src&&t.loadError&&t.container)return e&&(t.container.innerHTML=""),t.container.innerHTML=s.errorMsg.replace("%url%",t.src),!0},Ke=function(t,e,i){if(t.src){e||(e=t.container.lastChild);var n=i?t.w:Math.round(t.w*t.fitRatio),o=i?t.h:Math.round(t.h*t.fitRatio);t.placeholder&&!t.loaded&&(t.placeholder.style.width=n+"px",t.placeholder.style.height=o+"px"),e.style.width=n+"px",e.style.height=o+"px"}},$e=function(){if(qe.length){for(var t,e=0;e<qe.length;e++)(t=qe[e]).holder.index===t.index&&Xe(t.index,t.item,t.baseDiv,t.img,0,t.clearPlaceholder);qe=[]}};wt("Controller",{publicMethods:{lazyLoadItem:function(t){t=St(t);var e=je(t);e&&(!e.loaded&&!e.loading||w)&&(Dt("gettingData",t,e),e.src&&Ye(e))},initController:function(){o.extend(s,Be,!0),r.items=Ne=i,je=r.getItemAt,We=s.getNumItemsFn,s.loop,We()<3&&(s.loop=!1),Ct("beforeChange",(function(t){var e,i=s.preload,n=null===t||t>=0,o=Math.min(i[0],We()),a=Math.min(i[1],We());for(e=1;e<=(n?a:o);e++)r.lazyLoadItem(u+e);for(e=1;e<=(n?o:a);e++)r.lazyLoadItem(u-e)})),Ct("initialLayout",(function(){r.currItem.initialLayout=s.getThumbBoundsFn&&s.getThumbBoundsFn(u)})),Ct("mainScrollAnimComplete",$e),Ct("initialZoomInEnd",$e),Ct("destroy",(function(){for(var t,e=0;e<Ne.length;e++)(t=Ne[e]).container&&(t.container=null),t.placeholder&&(t.placeholder=null),t.img&&(t.img=null),t.preloader&&(t.preloader=null),t.loadError&&(t.loaded=t.loadError=!1);qe=null}))},getItemAt:function(t){return t>=0&&(void 0!==Ne[t]&&Ne[t])},allowProgressiveImg:function(){return s.forceProgressiveLoading||!A||s.mouseUsed||screen.width>1200},setContent:function(t,e){s.loop&&(e=St(e));var i=r.getItemAt(t.index);i&&(i.container=null);var n,l=r.getItemAt(e);if(l){Dt("gettingData",e,l),t.index=e,t.item=l;var c=l.container=o.createEl("pswp__zoom-wrap");if(!l.src&&l.html&&(l.html.tagName?c.appendChild(l.html):c.innerHTML=l.html),Ge(l),Ze(l,ht),!l.src||l.loadError||l.loaded)l.src&&!l.loadError&&((n=o.createEl("pswp__img","img")).style.opacity=1,n.src=l.src,Ke(l,n),Xe(0,l,c,n));else{if(l.loadComplete=function(i){if(a){if(t&&t.index===e){if(Ge(i,!0))return i.loadComplete=i.img=null,Ze(i,ht),At(i),void(t.index===u&&r.updateCurrZoomItem());i.imageAppended?!Re&&i.placeholder&&(i.placeholder.style.display="none",i.placeholder=null):N.transform&&(it||Re)?qe.push({item:i,baseDiv:c,img:i.img,index:e,holder:t,clearPlaceholder:!0}):Xe(0,i,c,i.img,0,!0)}i.loadComplete=null,i.img=null,Dt("imageLoadComplete",e,i)}},o.features.transform){var d="pswp__img pswp__img--placeholder";d+=l.msrc?"":" pswp__img--placeholder--blank";var h=o.createEl(d,l.msrc?"img":"");l.msrc&&(h.src=l.msrc),Ke(l,h),c.appendChild(h),l.placeholder=h}l.loading||Ye(l),r.allowProgressiveImg()&&(!Ue&&N.transform?qe.push({item:l,baseDiv:c,img:l.img,index:e,holder:t}):Xe(0,l,c,l.img,0,!0))}Ue||e!==u?At(l):(et=c.style,Ve(l,n||l.img)),t.el.innerHTML="",t.el.appendChild(c)}else t.el.innerHTML=""},cleanSlide:function(t){t.img&&(t.img.onload=t.img.onerror=null),t.loaded=t.loading=t.img=t.imageAppended=!1}}});var Je,Qe,ti={},ei=function(t,e,i){var n=document.createEvent("CustomEvent"),o={origEvent:t,target:t.target,releasePoint:e,pointerType:i||"touch"};n.initCustomEvent("pswpTap",!0,!0,o),t.target.dispatchEvent(n)};wt("Tap",{publicMethods:{initTap:function(){Ct("firstTouchStart",r.onTapStart),Ct("touchRelease",r.onTapRelease),Ct("destroy",(function(){ti={},Je=null}))},onTapStart:function(t){t.length>1&&(clearTimeout(Je),Je=null)},onTapRelease:function(t,e){var i,n;if(e&&(!Y&&!Z&&!Zt)){var r=e;if(Je&&(clearTimeout(Je),Je=null,i=r,n=ti,Math.abs(i.x-n.x)<25&&Math.abs(i.y-n.y)<25))return void Dt("doubleTap",r);if("mouse"===e.type)return void ei(t,e,"mouse");if("BUTTON"===t.target.tagName.toUpperCase()||o.hasClass(t.target,"pswp__single-tap"))return void ei(t,e);Lt(ti,r),Je=setTimeout((function(){ei(t,e),Je=null}),300)}}}}),wt("DesktopZoom",{publicMethods:{initDesktopZoom:function(){O||(A?Ct("mouseUsed",(function(){r.setupDesktopZoom()})):r.setupDesktopZoom(!0))},setupDesktopZoom:function(e){Qe={};var i="wheel mousewheel DOMMouseScroll";Ct("bindEvents",(function(){o.bind(t,i,r.handleMouseWheel)})),Ct("unbindEvents",(function(){Qe&&o.unbind(t,i,r.handleMouseWheel)})),r.mouseZoomedIn=!1;var n,s=function(){r.mouseZoomedIn&&(o.removeClass(t,"pswp--zoomed-in"),r.mouseZoomedIn=!1),g<1?o.addClass(t,"pswp--zoom-allowed"):o.removeClass(t,"pswp--zoom-allowed"),a()},a=function(){n&&(o.removeClass(t,"pswp--dragging"),n=!1)};Ct("resize",s),Ct("afterChange",s),Ct("pointerDown",(function(){r.mouseZoomedIn&&(n=!0,o.addClass(t,"pswp--dragging"))})),Ct("pointerUp",a),e||s()},handleMouseWheel:function(t){if(g<=r.currItem.fitRatio)return s.modal&&(!s.closeOnScroll||Zt||B?t.preventDefault():_&&Math.abs(t.deltaY)>2&&(c=!0,r.close())),!0;if(t.stopPropagation(),Qe.x=0,"deltaX"in t)1===t.deltaMode?(Qe.x=18*t.deltaX,Qe.y=18*t.deltaY):(Qe.x=t.deltaX,Qe.y=t.deltaY);else if("wheelDelta"in t)t.wheelDeltaX&&(Qe.x=-.16*t.wheelDeltaX),t.wheelDeltaY?Qe.y=-.16*t.wheelDeltaY:Qe.y=-.16*t.wheelDelta;else{if(!("detail"in t))return;Qe.y=t.detail}Ut(g,!0);var e=dt.x-Qe.x,i=dt.y-Qe.y;(s.modal||e<=tt.min.x&&e>=tt.max.x&&i<=tt.min.y&&i>=tt.max.y)&&t.preventDefault(),r.panTo(e,i)},toggleDesktopZoom:function(e){e=e||{x:ht.x/2+ft.x,y:ht.y/2+ft.y};var i=s.getDoubleTapZoom(!0,r.currItem),n=g===i;r.mouseZoomedIn=!n,r.zoomTo(n?r.currItem.initialZoomLevel:i,e,333),o[(n?"remove":"add")+"Class"](t,"pswp--zoomed-in")}}}),o.extend(r,$t)}})),function(t,e){"function"==typeof define&&define.amd?define(e):"object"==typeof exports?module.exports=e():t.PhotoSwipeUI_Default=e()}(this,(function(){"use strict";return function(t,e){var i,n,o,r,s,a,l,c,u,d,h,p,f,m,g,v,y,b,x=this,w=!1,S=!0,E=!0,C={barsSize:{top:44,bottom:"auto"},closeElClasses:["item","caption","zoom-wrap","ui","top-bar"],timeToIdle:4e3,timeToIdleOutside:1e3,loadingIndicatorDelay:1e3,addCaptionHTMLFn:function(t,e){return t.title?(e.children[0].innerHTML=t.title,!0):(e.children[0].innerHTML="",!1)},closeEl:!0,captionEl:!0,fullscreenEl:!0,zoomEl:!0,shareEl:!0,counterEl:!0,arrowEl:!0,preloaderEl:!0,tapToClose:!1,tapToToggleControls:!0,clickToCloseNonZoomable:!0,shareButtons:[{id:"facebook",label:"Share on Facebook",url:"https://www.facebook.com/sharer/sharer.php?u={{url}}"},{id:"twitter",label:"Tweet",url:"https://twitter.com/intent/tweet?text={{text}}&url={{url}}"},{id:"pinterest",label:"Pin it",url:"http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"},{id:"download",label:"Download image",url:"{{raw_image_url}}",download:!0}],getImageURLForShare:function(){return t.currItem.src||""},getPageURLForShare:function(){return window.location.href},getTextForShare:function(){return t.currItem.title||""},indexIndicatorSep:" / ",fitControlsWidth:1200},D=function(t){if(v)return!0;t=t||window.event,g.timeToIdle&&g.mouseUsed&&!u&&O();for(var i,n,o=(t.target||t.srcElement).getAttribute("class")||"",r=0;r<R.length;r++)(i=R[r]).onTap&&o.indexOf("pswp__"+i.name)>-1&&(i.onTap(),n=!0);if(n){t.stopPropagation&&t.stopPropagation(),v=!0;var s=e.features.isOldAndroid?600:30;setTimeout((function(){v=!1}),s)}},k=function(){return!t.likelyTouchDevice||g.mouseUsed||screen.width>g.fitControlsWidth},P=function(t,i,n){e[(n?"add":"remove")+"Class"](t,"pswp__"+i)},_=function(){var t=1===g.getNumItemsFn();t!==m&&(P(n,"ui--one-slide",t),m=t)},I=function(){P(l,"share-modal--hidden",E)},A=function(){return(E=!E)?(e.removeClass(l,"pswp__share-modal--fade-in"),setTimeout((function(){E&&I()}),300)):(I(),setTimeout((function(){E||e.addClass(l,"pswp__share-modal--fade-in")}),30)),E||M(),!1},T=function(e){var i=(e=e||window.event).target||e.srcElement;return t.shout("shareLinkClick",e,i),!(!i.href||!i.hasAttribute("download")&&(window.open(i.href,"pswp_share","scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left="+(window.screen?Math.round(screen.width/2-275):100)),E||A(),1))},M=function(){for(var t,e,i,n,o="",r=0;r<g.shareButtons.length;r++)t=g.shareButtons[r],e=g.getImageURLForShare(t),i=g.getPageURLForShare(t),n=g.getTextForShare(t),o+='<a href="'+t.url.replace("{{url}}",encodeURIComponent(i)).replace("{{image_url}}",encodeURIComponent(e)).replace("{{raw_image_url}}",e).replace("{{text}}",encodeURIComponent(n))+'" target="_blank" class="pswp__share--'+t.id+'"'+(t.download?"download":"")+">"+t.label+"</a>",g.parseShareButtonOut&&(o=g.parseShareButtonOut(t,o));l.children[0].innerHTML=o,l.children[0].onclick=T},z=function(t){for(var i=0;i<g.closeElClasses.length;i++)if(e.hasClass(t,"pswp__"+g.closeElClasses[i]))return!0},L=0,O=function(){clearTimeout(b),L=0,u&&x.setIdle(!1)},F=function(t){var e=(t=t||window.event).relatedTarget||t.toElement;e&&"HTML"!==e.nodeName||(clearTimeout(b),b=setTimeout((function(){x.setIdle(!0)}),g.timeToIdleOutside))},N=function(t){p!==t&&(P(h,"preloader--active",!t),p=t)},U=function(t){var i=t.vGap;if(k()){var s=g.barsSize;if(g.captionEl&&"auto"===s.bottom)if(r||((r=e.createEl("pswp__caption pswp__caption--fake")).appendChild(e.createEl("pswp__caption__center")),n.insertBefore(r,o),e.addClass(n,"pswp__ui--fit")),g.addCaptionHTMLFn(t,r,!0)){var a=r.clientHeight;i.bottom=parseInt(a,10)||44}else i.bottom=s.top;else i.bottom="auto"===s.bottom?0:s.bottom;i.top=s.top}else i.top=i.bottom=0},R=[{name:"caption",option:"captionEl",onInit:function(t){o=t}},{name:"share-modal",option:"shareEl",onInit:function(t){l=t},onTap:function(){A()}},{name:"button--share",option:"shareEl",onInit:function(t){a=t},onTap:function(){A()}},{name:"button--zoom",option:"zoomEl",onTap:t.toggleDesktopZoom},{name:"counter",option:"counterEl",onInit:function(t){s=t}},{name:"button--close",option:"closeEl",onTap:t.close},{name:"button--arrow--left",option:"arrowEl",onTap:t.prev},{name:"button--arrow--right",option:"arrowEl",onTap:t.next},{name:"button--fs",option:"fullscreenEl",onTap:function(){i.isFullscreen()?i.exit():i.enter()}},{name:"preloader",option:"preloaderEl",onInit:function(t){h=t}}];x.init=function(){e.extend(t.options,C,!0),g=t.options,n=e.getChildByClass(t.scrollWrap,"pswp__ui"),d=t.listen,function(){var t;d("onVerticalDrag",(function(t){S&&t<.95?x.hideControls():!S&&t>=.95&&x.showControls()})),d("onPinchClose",(function(e){S&&e<.9?(x.hideControls(),t=!0):t&&!S&&e>.9&&x.showControls()})),d("zoomGestureEnded",(function(){(t=!1)&&!S&&x.showControls()}))}(),d("beforeChange",x.update),d("doubleTap",(function(e){var i=t.currItem.initialZoomLevel;t.getZoomLevel()!==i?t.zoomTo(i,e,333):t.zoomTo(g.getDoubleTapZoom(!1,t.currItem),e,333)})),d("preventDragEvent",(function(t,e,i){var n=t.target||t.srcElement;n&&n.getAttribute("class")&&t.type.indexOf("mouse")>-1&&(n.getAttribute("class").indexOf("__caption")>0||/(SMALL|STRONG|EM)/i.test(n.tagName))&&(i.prevent=!1)})),d("bindEvents",(function(){e.bind(n,"pswpTap click",D),e.bind(t.scrollWrap,"pswpTap",x.onGlobalTap),t.likelyTouchDevice||e.bind(t.scrollWrap,"mouseover",x.onMouseOver)})),d("unbindEvents",(function(){E||A(),y&&clearInterval(y),e.unbind(document,"mouseout",F),e.unbind(document,"mousemove",O),e.unbind(n,"pswpTap click",D),e.unbind(t.scrollWrap,"pswpTap",x.onGlobalTap),e.unbind(t.scrollWrap,"mouseover",x.onMouseOver),i&&(e.unbind(document,i.eventK,x.updateFullscreen),i.isFullscreen()&&(g.hideAnimationDuration=0,i.exit()),i=null)})),d("destroy",(function(){g.captionEl&&(r&&n.removeChild(r),e.removeClass(o,"pswp__caption--empty")),l&&(l.children[0].onclick=null),e.removeClass(n,"pswp__ui--over-close"),e.addClass(n,"pswp__ui--hidden"),x.setIdle(!1)})),g.showAnimationDuration||e.removeClass(n,"pswp__ui--hidden"),d("initialZoomIn",(function(){g.showAnimationDuration&&e.removeClass(n,"pswp__ui--hidden")})),d("initialZoomOut",(function(){e.addClass(n,"pswp__ui--hidden")})),d("parseVerticalMargin",U),function(){var t,i,o,r=function(n){if(n)for(var r=n.length,s=0;s<r;s++){t=n[s],i=t.className;for(var a=0;a<R.length;a++)o=R[a],i.indexOf("pswp__"+o.name)>-1&&(g[o.option]?(e.removeClass(t,"pswp__element--disabled"),o.onInit&&o.onInit(t)):e.addClass(t,"pswp__element--disabled"))}};r(n.children);var s=e.getChildByClass(n,"pswp__top-bar");s&&r(s.children)}(),g.shareEl&&a&&l&&(E=!0),_(),g.timeToIdle&&d("mouseUsed",(function(){e.bind(document,"mousemove",O),e.bind(document,"mouseout",F),y=setInterval((function(){2==++L&&x.setIdle(!0)}),g.timeToIdle/2)})),g.fullscreenEl&&!e.features.isOldAndroid&&(i||(i=x.getFullscreenAPI()),i?(e.bind(document,i.eventK,x.updateFullscreen),x.updateFullscreen(),e.addClass(t.template,"pswp--supports-fs")):e.removeClass(t.template,"pswp--supports-fs")),g.preloaderEl&&(N(!0),d("beforeChange",(function(){clearTimeout(f),f=setTimeout((function(){t.currItem&&t.currItem.loading?(!t.allowProgressiveImg()||t.currItem.img&&!t.currItem.img.naturalWidth)&&N(!1):N(!0)}),g.loadingIndicatorDelay)})),d("imageLoadComplete",(function(e,i){t.currItem===i&&N(!0)})))},x.setIdle=function(t){u=t,P(n,"ui--idle",t)},x.update=function(){S&&t.currItem?(x.updateIndexIndicator(),g.captionEl&&(g.addCaptionHTMLFn(t.currItem,o),P(o,"caption--empty",!t.currItem.title)),w=!0):w=!1,E||A(),_()},x.updateFullscreen=function(n){n&&setTimeout((function(){t.setScrollOffset(0,e.getScrollY())}),50),e[(i.isFullscreen()?"add":"remove")+"Class"](t.template,"pswp--fs")},x.updateIndexIndicator=function(){g.counterEl&&(s.innerHTML=t.getCurrentIndex()+1+g.indexIndicatorSep+g.getNumItemsFn())},x.onGlobalTap=function(i){var n=(i=i||window.event).target||i.srcElement;if(!v)if(i.detail&&"mouse"===i.detail.pointerType){if(z(n))return void t.close();e.hasClass(n,"pswp__img")&&(1===t.getZoomLevel()&&t.getZoomLevel()<=t.currItem.fitRatio?g.clickToCloseNonZoomable&&t.close():t.toggleDesktopZoom(i.detail.releasePoint))}else if(g.tapToToggleControls&&(S?x.hideControls():x.showControls()),g.tapToClose&&(e.hasClass(n,"pswp__img")||z(n)))return void t.close()},x.onMouseOver=function(t){var e=(t=t||window.event).target||t.srcElement;P(n,"ui--over-close",z(e))},x.hideControls=function(){e.addClass(n,"pswp__ui--hidden"),S=!1},x.showControls=function(){S=!0,w||x.update(),e.removeClass(n,"pswp__ui--hidden")},x.supportsFullscreen=function(){var t=document;return!!(t.exitFullscreen||t.mozCancelFullScreen||t.webkitExitFullscreen||t.msExitFullscreen)},x.getFullscreenAPI=function(){var e,i=document.documentElement,n="fullscreenchange";return i.requestFullscreen?e={enterK:"requestFullscreen",exitK:"exitFullscreen",elementK:"fullscreenElement",eventK:n}:i.mozRequestFullScreen?e={enterK:"mozRequestFullScreen",exitK:"mozCancelFullScreen",elementK:"mozFullScreenElement",eventK:"moz"+n}:i.webkitRequestFullscreen?e={enterK:"webkitRequestFullscreen",exitK:"webkitExitFullscreen",elementK:"webkitFullscreenElement",eventK:"webkit"+n}:i.msRequestFullscreen&&(e={enterK:"msRequestFullscreen",exitK:"msExitFullscreen",elementK:"msFullscreenElement",eventK:"MSFullscreenChange"}),e&&(e.enter=function(){return c=g.closeOnScroll,g.closeOnScroll=!1,"webkitRequestFullscreen"!==this.enterK?t.template[this.enterK]():void t.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)},e.exit=function(){return g.closeOnScroll=c,document[this.exitK]()},e.isFullscreen=function(){return document[this.elementK]}),e}}})),
/*!
 * noUiSlider v15.2.0
 * Lightweight JavaScript range slider library with full multi-touch support.
 * MIT license
 */
function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).noUiSlider={})}(this,(function(t){"use strict";var e,i;function n(t){return"object"==typeof t&&"function"==typeof t.to}function o(t){t.parentElement.removeChild(t)}function r(t){return null!=t}function s(t){t.preventDefault()}function a(t){return"number"==typeof t&&!isNaN(t)&&isFinite(t)}function l(t,e,i){i>0&&(h(t,e),setTimeout((function(){p(t,e)}),i))}function c(t){return Math.max(Math.min(t,100),0)}function u(t){return Array.isArray(t)?t:[t]}function d(t){var e=(t=String(t)).split(".");return e.length>1?e[1].length:0}function h(t,e){t.classList&&!/\s/.test(e)?t.classList.add(e):t.className+=" "+e}function p(t,e){t.classList&&!/\s/.test(e)?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\b)"+e.split(" ").join("|")+"(\\b|$)","gi")," ")}function f(t){var e=void 0!==window.pageXOffset,i="CSS1Compat"===(t.compatMode||"");return{x:e?window.pageXOffset:i?t.documentElement.scrollLeft:t.body.scrollLeft,y:e?window.pageYOffset:i?t.documentElement.scrollTop:t.body.scrollTop}}function m(t,e){return 100/(e-t)}function g(t,e,i){return 100*e/(t[i+1]-t[i])}function v(t,e){for(var i=1;t>=e[i];)i+=1;return i}function y(t,e,i){if(i>=t.slice(-1)[0])return 100;var n=v(i,t),o=t[n-1],r=t[n],s=e[n-1],a=e[n];return s+function(t,e){return g(t,t[0]<0?e+Math.abs(t[0]):e-t[0],0)}([o,r],i)/m(s,a)}function b(t,e,i,n){if(100===n)return n;var o=v(n,t),r=t[o-1],s=t[o];return i?n-r>(s-r)/2?s:r:e[o-1]?t[o-1]+function(t,e){return Math.round(t/e)*e}(n-t[o-1],e[o-1]):n}t.PipsMode=void 0,(e=t.PipsMode||(t.PipsMode={})).Range="range",e.Steps="steps",e.Positions="positions",e.Count="count",e.Values="values",t.PipsType=void 0,(i=t.PipsType||(t.PipsType={}))[i.None=-1]="None",i[i.NoValue=0]="NoValue",i[i.LargeValue=1]="LargeValue",i[i.SmallValue=2]="SmallValue";var x=function(){function t(t,e,i){var n;this.xPct=[],this.xVal=[],this.xSteps=[],this.xNumSteps=[],this.xHighestCompleteStep=[],this.xSteps=[i||!1],this.xNumSteps=[!1],this.snap=e;var o=[];for(Object.keys(t).forEach((function(e){o.push([u(t[e]),e])})),o.sort((function(t,e){return t[0][0]-e[0][0]})),n=0;n<o.length;n++)this.handleEntryPoint(o[n][1],o[n][0]);for(this.xNumSteps=this.xSteps.slice(0),n=0;n<this.xNumSteps.length;n++)this.handleStepPoint(n,this.xNumSteps[n])}return t.prototype.getDistance=function(t){var e,i=[];for(e=0;e<this.xNumSteps.length-1;e++){var n=this.xNumSteps[e];if(n&&t/n%1!=0)throw new Error("noUiSlider: 'limit', 'margin' and 'padding' of "+this.xPct[e]+"% range must be divisible by step.");i[e]=g(this.xVal,t,e)}return i},t.prototype.getAbsoluteDistance=function(t,e,i){var n,o=0;if(t<this.xPct[this.xPct.length-1])for(;t>this.xPct[o+1];)o++;else t===this.xPct[this.xPct.length-1]&&(o=this.xPct.length-2);i||t!==this.xPct[o+1]||o++,null===e&&(e=[]);var r=1,s=e[o],a=0,l=0,c=0,u=0;for(n=i?(t-this.xPct[o])/(this.xPct[o+1]-this.xPct[o]):(this.xPct[o+1]-t)/(this.xPct[o+1]-this.xPct[o]);s>0;)a=this.xPct[o+1+u]-this.xPct[o+u],e[o+u]*r+100-100*n>100?(l=a*n,r=(s-100*n)/e[o+u],n=1):(l=e[o+u]*a/100*r,r=0),i?(c-=l,this.xPct.length+u>=1&&u--):(c+=l,this.xPct.length-u>=1&&u++),s=e[o+u]*r;return t+c},t.prototype.toStepping=function(t){return t=y(this.xVal,this.xPct,t)},t.prototype.fromStepping=function(t){return function(t,e,i){if(i>=100)return t.slice(-1)[0];var n=v(i,e),o=t[n-1],r=t[n],s=e[n-1];return function(t,e){return e*(t[1]-t[0])/100+t[0]}([o,r],(i-s)*m(s,e[n]))}(this.xVal,this.xPct,t)},t.prototype.getStep=function(t){return t=b(this.xPct,this.xSteps,this.snap,t)},t.prototype.getDefaultStep=function(t,e,i){var n=v(t,this.xPct);return(100===t||e&&t===this.xPct[n-1])&&(n=Math.max(n-1,1)),(this.xVal[n]-this.xVal[n-1])/i},t.prototype.getNearbySteps=function(t){var e=v(t,this.xPct);return{stepBefore:{startValue:this.xVal[e-2],step:this.xNumSteps[e-2],highestStep:this.xHighestCompleteStep[e-2]},thisStep:{startValue:this.xVal[e-1],step:this.xNumSteps[e-1],highestStep:this.xHighestCompleteStep[e-1]},stepAfter:{startValue:this.xVal[e],step:this.xNumSteps[e],highestStep:this.xHighestCompleteStep[e]}}},t.prototype.countStepDecimals=function(){var t=this.xNumSteps.map(d);return Math.max.apply(null,t)},t.prototype.convert=function(t){return this.getStep(this.toStepping(t))},t.prototype.handleEntryPoint=function(t,e){var i;if(!a(i="min"===t?0:"max"===t?100:parseFloat(t))||!a(e[0]))throw new Error("noUiSlider: 'range' value isn't numeric.");this.xPct.push(i),this.xVal.push(e[0]);var n=Number(e[1]);i?this.xSteps.push(!isNaN(n)&&n):isNaN(n)||(this.xSteps[0]=n),this.xHighestCompleteStep.push(0)},t.prototype.handleStepPoint=function(t,e){if(e)if(this.xVal[t]!==this.xVal[t+1]){this.xSteps[t]=g([this.xVal[t],this.xVal[t+1]],e,0)/m(this.xPct[t],this.xPct[t+1]);var i=(this.xVal[t+1]-this.xVal[t])/this.xNumSteps[t],n=Math.ceil(Number(i.toFixed(3))-1),o=this.xVal[t]+this.xNumSteps[t]*n;this.xHighestCompleteStep[t]=o}else this.xSteps[t]=this.xHighestCompleteStep[t]=this.xVal[t]},t}(),w={to:function(t){return void 0===t?"":t.toFixed(2)},from:Number},S={target:"target",base:"base",origin:"origin",handle:"handle",handleLower:"handle-lower",handleUpper:"handle-upper",touchArea:"touch-area",horizontal:"horizontal",vertical:"vertical",background:"background",connect:"connect",connects:"connects",ltr:"ltr",rtl:"rtl",textDirectionLtr:"txt-dir-ltr",textDirectionRtl:"txt-dir-rtl",draggable:"draggable",drag:"state-drag",tap:"state-tap",active:"active",tooltip:"tooltip",pips:"pips",pipsHorizontal:"pips-horizontal",pipsVertical:"pips-vertical",marker:"marker",markerHorizontal:"marker-horizontal",markerVertical:"marker-vertical",markerNormal:"marker-normal",markerLarge:"marker-large",markerSub:"marker-sub",value:"value",valueHorizontal:"value-horizontal",valueVertical:"value-vertical",valueNormal:"value-normal",valueLarge:"value-large",valueSub:"value-sub"},E={tooltips:".__tooltips",aria:".__aria"};function C(t,e){if(!a(e))throw new Error("noUiSlider: 'step' is not numeric.");t.singleStep=e}function D(t,e){if(!a(e))throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");t.keyboardPageMultiplier=e}function k(t,e){if(!a(e))throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");t.keyboardDefaultStep=e}function P(t,e){if("object"!=typeof e||Array.isArray(e))throw new Error("noUiSlider: 'range' is not an object.");if(void 0===e.min||void 0===e.max)throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");if(e.min===e.max)throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");t.spectrum=new x(e,t.snap||!1,t.singleStep)}function _(t,e){if(e=u(e),!Array.isArray(e)||!e.length)throw new Error("noUiSlider: 'start' option is incorrect.");t.handles=e.length,t.start=e}function I(t,e){if("boolean"!=typeof e)throw new Error("noUiSlider: 'snap' option must be a boolean.");t.snap=e}function A(t,e){if("boolean"!=typeof e)throw new Error("noUiSlider: 'animate' option must be a boolean.");t.animate=e}function T(t,e){if("number"!=typeof e)throw new Error("noUiSlider: 'animationDuration' option must be a number.");t.animationDuration=e}function M(t,e){var i,n=[!1];if("lower"===e?e=[!0,!1]:"upper"===e&&(e=[!1,!0]),!0===e||!1===e){for(i=1;i<t.handles;i++)n.push(e);n.push(!1)}else{if(!Array.isArray(e)||!e.length||e.length!==t.handles+1)throw new Error("noUiSlider: 'connect' option doesn't match handle count.");n=e}t.connect=n}function z(t,e){switch(e){case"horizontal":t.ort=0;break;case"vertical":t.ort=1;break;default:throw new Error("noUiSlider: 'orientation' option is invalid.")}}function L(t,e){if(!a(e))throw new Error("noUiSlider: 'margin' option must be numeric.");0!==e&&(t.margin=t.spectrum.getDistance(e))}function O(t,e){if(!a(e))throw new Error("noUiSlider: 'limit' option must be numeric.");if(t.limit=t.spectrum.getDistance(e),!t.limit||t.handles<2)throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.")}function F(t,e){var i;if(!a(e)&&!Array.isArray(e))throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");if(Array.isArray(e)&&2!==e.length&&!a(e[0])&&!a(e[1]))throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");if(0!==e){for(Array.isArray(e)||(e=[e,e]),t.padding=[t.spectrum.getDistance(e[0]),t.spectrum.getDistance(e[1])],i=0;i<t.spectrum.xNumSteps.length-1;i++)if(t.padding[0][i]<0||t.padding[1][i]<0)throw new Error("noUiSlider: 'padding' option must be a positive number(s).");var n=e[0]+e[1],o=t.spectrum.xVal[0];if(n/(t.spectrum.xVal[t.spectrum.xVal.length-1]-o)>1)throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.")}}function N(t,e){switch(e){case"ltr":t.dir=0;break;case"rtl":t.dir=1;break;default:throw new Error("noUiSlider: 'direction' option was not recognized.")}}function U(t,e){if("string"!=typeof e)throw new Error("noUiSlider: 'behaviour' must be a string containing options.");var i=e.indexOf("tap")>=0,n=e.indexOf("drag")>=0,o=e.indexOf("fixed")>=0,r=e.indexOf("snap")>=0,s=e.indexOf("hover")>=0,a=e.indexOf("unconstrained")>=0;if(o){if(2!==t.handles)throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");L(t,t.start[1]-t.start[0])}if(a&&(t.margin||t.limit))throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");t.events={tap:i||r,drag:n,fixed:o,snap:r,hover:s,unconstrained:a}}function R(t,e){if(!1!==e)if(!0===e||n(e)){t.tooltips=[];for(var i=0;i<t.handles;i++)t.tooltips.push(e)}else{if((e=u(e)).length!==t.handles)throw new Error("noUiSlider: must pass a formatter for all handles.");e.forEach((function(t){if("boolean"!=typeof t&&!n(t))throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.")})),t.tooltips=e}}function j(t,e){if(!n(e))throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");t.ariaFormat=e}function W(t,e){if(!function(t){return n(t)&&"function"==typeof t.from}(e))throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");t.format=e}function V(t,e){if("boolean"!=typeof e)throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");t.keyboardSupport=e}function H(t,e){t.documentElement=e}function q(t,e){if("string"!=typeof e&&!1!==e)throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");t.cssPrefix=e}function B(t,e){if("object"!=typeof e)throw new Error("noUiSlider: 'cssClasses' must be an object.");"string"==typeof t.cssPrefix?(t.cssClasses={},Object.keys(e).forEach((function(i){t.cssClasses[i]=t.cssPrefix+e[i]}))):t.cssClasses=e}function Z(t){var e={margin:null,limit:null,padding:null,animate:!0,animationDuration:300,ariaFormat:w,format:w},i={step:{r:!1,t:C},keyboardPageMultiplier:{r:!1,t:D},keyboardDefaultStep:{r:!1,t:k},start:{r:!0,t:_},connect:{r:!0,t:M},direction:{r:!0,t:N},snap:{r:!1,t:I},animate:{r:!1,t:A},animationDuration:{r:!1,t:T},range:{r:!0,t:P},orientation:{r:!1,t:z},margin:{r:!1,t:L},limit:{r:!1,t:O},padding:{r:!1,t:F},behaviour:{r:!0,t:U},ariaFormat:{r:!1,t:j},format:{r:!1,t:W},tooltips:{r:!1,t:R},keyboardSupport:{r:!0,t:V},documentElement:{r:!1,t:H},cssPrefix:{r:!0,t:q},cssClasses:{r:!0,t:B}},n={connect:!1,direction:"ltr",behaviour:"tap",orientation:"horizontal",keyboardSupport:!0,cssPrefix:"noUi-",cssClasses:S,keyboardPageMultiplier:5,keyboardDefaultStep:10};t.format&&!t.ariaFormat&&(t.ariaFormat=t.format),Object.keys(i).forEach((function(o){if(r(t[o])||void 0!==n[o])i[o].t(e,r(t[o])?t[o]:n[o]);else if(i[o].r)throw new Error("noUiSlider: '"+o+"' is required.")})),e.pips=t.pips;var o=document.createElement("div"),s=void 0!==o.style.msTransform,a=void 0!==o.style.transform;e.transformRule=a?"transform":s?"msTransform":"webkitTransform";return e.style=[["left","top"],["right","bottom"]][e.dir][e.ort],e}function X(e,i,n){var a,d,m,g,v,y,b,x=window.navigator.pointerEnabled?{start:"pointerdown",move:"pointermove",end:"pointerup"}:window.navigator.msPointerEnabled?{start:"MSPointerDown",move:"MSPointerMove",end:"MSPointerUp"}:{start:"mousedown touchstart",move:"mousemove touchmove",end:"mouseup touchend"},w=window.CSS&&CSS.supports&&CSS.supports("touch-action","none")&&function(){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("test",null,e)}catch(t){}return t}(),S=e,C=i.spectrum,D=[],k=[],P=[],_=0,I={},A=e.ownerDocument,T=i.documentElement||A.documentElement,M=A.body,z="rtl"===A.dir||1===i.ort?0:100;function L(t,e){var i=A.createElement("div");return e&&h(i,e),t.appendChild(i),i}function O(t,e){var n=L(t,i.cssClasses.origin),o=L(n,i.cssClasses.handle);return L(o,i.cssClasses.touchArea),o.setAttribute("data-handle",String(e)),i.keyboardSupport&&(o.setAttribute("tabindex","0"),o.addEventListener("keydown",(function(t){return function(t,e){if(U()||R(e))return!1;var n=["Left","Right"],o=["Down","Up"],r=["PageDown","PageUp"],s=["Home","End"];i.dir&&!i.ort?n.reverse():i.ort&&!i.dir&&(o.reverse(),r.reverse());var a,l=t.key.replace("Arrow",""),c=l===r[0],u=l===r[1],d=l===o[0]||l===n[0]||c,h=l===o[1]||l===n[1]||u,p=l===s[0],f=l===s[1];if(!(d||h||p||f))return!0;if(t.preventDefault(),h||d){var m=i.keyboardPageMultiplier,g=d?0:1,v=gt(e)[g];if(null===v)return!1;!1===v&&(v=C.getDefaultStep(k[e],d,i.keyboardDefaultStep)),(u||c)&&(v*=m),v=Math.max(v,1e-7),v*=d?-1:1,a=D[e]+v}else a=f?i.spectrum.xVal[i.spectrum.xVal.length-1]:i.spectrum.xVal[0];return dt(e,C.toStepping(a),!0,!0),rt("slide",e),rt("update",e),rt("change",e),rt("set",e),!1}(t,e)}))),o.setAttribute("role","slider"),o.setAttribute("aria-orientation",i.ort?"vertical":"horizontal"),0===e?h(o,i.cssClasses.handleLower):e===i.handles-1&&h(o,i.cssClasses.handleUpper),n}function F(t,e){return!!e&&L(t,i.cssClasses.connect)}function N(t,e){return!(!i.tooltips||!i.tooltips[e])&&L(t.firstChild,i.cssClasses.tooltip)}function U(){return S.hasAttribute("disabled")}function R(t){return d[t].hasAttribute("disabled")}function j(){v&&(ot("update"+E.tooltips),v.forEach((function(t){t&&o(t)})),v=null)}function W(){j(),v=d.map(N),nt("update"+E.tooltips,(function(t,e,n){if(v&&i.tooltips&&!1!==v[e]){var o=t[e];!0!==i.tooltips[e]&&(o=i.tooltips[e].to(n[e])),v[e].innerHTML=o}}))}function V(t,e){return t.map((function(t){return C.fromStepping(e?C.getStep(t):t)}))}function H(e){var i,n=function(e){if(e.mode===t.PipsMode.Range||e.mode===t.PipsMode.Steps)return C.xVal;if(e.mode===t.PipsMode.Count){if(e.values<2)throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");for(var i=e.values-1,n=100/i,o=[];i--;)o[i]=i*n;return o.push(100),V(o,e.stepped)}return e.mode===t.PipsMode.Positions?V(e.values,e.stepped):e.mode===t.PipsMode.Values?e.stepped?e.values.map((function(t){return C.fromStepping(C.getStep(C.toStepping(t)))})):e.values:[]}(e),o={},r=C.xVal[0],s=C.xVal[C.xVal.length-1],a=!1,l=!1,c=0;return i=n.slice().sort((function(t,e){return t-e})),(n=i.filter((function(t){return!this[t]&&(this[t]=!0)}),{}))[0]!==r&&(n.unshift(r),a=!0),n[n.length-1]!==s&&(n.push(s),l=!0),n.forEach((function(i,r){var s,u,d,h,p,f,m,g,v,y,b=i,x=n[r+1],w=e.mode===t.PipsMode.Steps;for(w&&(s=C.xNumSteps[r]),s||(s=x-b),void 0===x&&(x=b),s=Math.max(s,1e-7),u=b;u<=x;u=Number((u+s).toFixed(7))){for(g=(p=(h=C.toStepping(u))-c)/(e.density||1),y=p/(v=Math.round(g)),d=1;d<=v;d+=1)o[(f=c+d*y).toFixed(5)]=[C.fromStepping(f),0];m=n.indexOf(u)>-1?t.PipsType.LargeValue:w?t.PipsType.SmallValue:t.PipsType.NoValue,!r&&a&&u!==x&&(m=0),u===x&&l||(o[h.toFixed(5)]=[u,m]),c=h}})),o}function q(e,n,o){var r,s,a=A.createElement("div"),l=((r={})[t.PipsType.None]="",r[t.PipsType.NoValue]=i.cssClasses.valueNormal,r[t.PipsType.LargeValue]=i.cssClasses.valueLarge,r[t.PipsType.SmallValue]=i.cssClasses.valueSub,r),c=((s={})[t.PipsType.None]="",s[t.PipsType.NoValue]=i.cssClasses.markerNormal,s[t.PipsType.LargeValue]=i.cssClasses.markerLarge,s[t.PipsType.SmallValue]=i.cssClasses.markerSub,s),u=[i.cssClasses.valueHorizontal,i.cssClasses.valueVertical],d=[i.cssClasses.markerHorizontal,i.cssClasses.markerVertical];function p(t,e){var n=e===i.cssClasses.value,o=n?l:c;return e+" "+(n?u:d)[i.ort]+" "+o[t]}return h(a,i.cssClasses.pips),h(a,0===i.ort?i.cssClasses.pipsHorizontal:i.cssClasses.pipsVertical),Object.keys(e).forEach((function(r){!function(e,r,s){if((s=n?n(r,s):s)!==t.PipsType.None){var l=L(a,!1);l.className=p(s,i.cssClasses.marker),l.style[i.style]=e+"%",s>t.PipsType.NoValue&&((l=L(a,!1)).className=p(s,i.cssClasses.value),l.setAttribute("data-value",String(r)),l.style[i.style]=e+"%",l.innerHTML=String(o.to(r)))}}(r,e[r][0],e[r][1])})),a}function B(){g&&(o(g),g=null)}function X(t){B();var e=H(t),i=t.filter,n=t.format||{to:function(t){return String(Math.round(t))}};return g=S.appendChild(q(e,i,n))}function Y(){var t=a.getBoundingClientRect(),e="offset"+["Width","Height"][i.ort];return 0===i.ort?t.width||a[e]:t.height||a[e]}function G(t,e,n,o){var r=function(r){var s,a,l=function(t,e,i){var n=0===t.type.indexOf("touch"),o=0===t.type.indexOf("mouse"),r=0===t.type.indexOf("pointer"),s=0,a=0;0===t.type.indexOf("MSPointer")&&(r=!0);if("mousedown"===t.type&&!t.buttons&&!t.touches)return!1;if(n){var l=function(e){var n=e.target;return n===i||i.contains(n)||t.composed&&t.composedPath().shift()===i};if("touchstart"===t.type){var c=Array.prototype.filter.call(t.touches,l);if(c.length>1)return!1;s=c[0].pageX,a=c[0].pageY}else{var u=Array.prototype.find.call(t.changedTouches,l);if(!u)return!1;s=u.pageX,a=u.pageY}}e=e||f(A),(o||r)&&(s=t.clientX+e.x,a=t.clientY+e.y);return t.pageOffset=e,t.points=[s,a],t.cursor=o||r,t}(r,o.pageOffset,o.target||e);return!!l&&(!(U()&&!o.doNotReject)&&(s=S,a=i.cssClasses.tap,!((s.classList?s.classList.contains(a):new RegExp("\\b"+a+"\\b").test(s.className))&&!o.doNotReject)&&(!(t===x.start&&void 0!==l.buttons&&l.buttons>1)&&((!o.hover||!l.buttons)&&(w||l.preventDefault(),l.calcPoint=l.points[i.ort],void n(l,o))))))},s=[];return t.split(" ").forEach((function(t){e.addEventListener(t,r,!!w&&{passive:!0}),s.push([t,r])})),s}function K(t){var e,n,o,r,s,l,u=100*(t-(e=a,n=i.ort,o=e.getBoundingClientRect(),r=e.ownerDocument,s=r.documentElement,l=f(r),/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)&&(l.x=0),n?o.top+l.y-s.clientTop:o.left+l.x-s.clientLeft))/Y();return u=c(u),i.dir?100-u:u}function $(t,e){"mouseout"===t.type&&"HTML"===t.target.nodeName&&null===t.relatedTarget&&Q(t,e)}function J(t,e){if(-1===navigator.appVersion.indexOf("MSIE 9")&&0===t.buttons&&0!==e.buttonsProperty)return Q(t,e);var n=(i.dir?-1:1)*(t.calcPoint-e.startCalcPoint);lt(n>0,100*n/e.baseSize,e.locations,e.handleNumbers,e.connect)}function Q(t,e){e.handle&&(p(e.handle,i.cssClasses.active),_-=1),e.listeners.forEach((function(t){T.removeEventListener(t[0],t[1])})),0===_&&(p(S,i.cssClasses.drag),ut(),t.cursor&&(M.style.cursor="",M.removeEventListener("selectstart",s))),e.handleNumbers.forEach((function(t){rt("change",t),rt("set",t),rt("end",t)}))}function tt(t,e){if(!e.handleNumbers.some(R)){var n;if(1===e.handleNumbers.length)n=d[e.handleNumbers[0]].children[0],_+=1,h(n,i.cssClasses.active);t.stopPropagation();var o=[],r=G(x.move,T,J,{target:t.target,handle:n,connect:e.connect,listeners:o,startCalcPoint:t.calcPoint,baseSize:Y(),pageOffset:t.pageOffset,handleNumbers:e.handleNumbers,buttonsProperty:t.buttons,locations:k.slice()}),a=G(x.end,T,Q,{target:t.target,handle:n,listeners:o,doNotReject:!0,handleNumbers:e.handleNumbers}),l=G("mouseout",T,$,{target:t.target,handle:n,listeners:o,doNotReject:!0,handleNumbers:e.handleNumbers});o.push.apply(o,r.concat(a,l)),t.cursor&&(M.style.cursor=getComputedStyle(t.target).cursor,d.length>1&&h(S,i.cssClasses.drag),M.addEventListener("selectstart",s,!1)),e.handleNumbers.forEach((function(t){rt("start",t)}))}}function et(t){t.stopPropagation();var e=K(t.calcPoint),n=function(t){var e=100,i=!1;return d.forEach((function(n,o){if(!R(o)){var r=k[o],s=Math.abs(r-t);(s<e||s<=e&&t>r||100===s&&100===e)&&(i=o,e=s)}})),i}(e);!1!==n&&(i.events.snap||l(S,i.cssClasses.tap,i.animationDuration),dt(n,e,!0,!0),ut(),rt("slide",n,!0),rt("update",n,!0),rt("change",n,!0),rt("set",n,!0),i.events.snap&&tt(t,{handleNumbers:[n]}))}function it(t){var e=K(t.calcPoint),i=C.getStep(e),n=C.fromStepping(i);Object.keys(I).forEach((function(t){"hover"===t.split(".")[0]&&I[t].forEach((function(t){t.call(vt,n)}))}))}function nt(t,e){I[t]=I[t]||[],I[t].push(e),"update"===t.split(".")[0]&&d.forEach((function(t,e){rt("update",e)}))}function ot(t){var e=t&&t.split(".")[0],i=e?t.substring(e.length):t;Object.keys(I).forEach((function(t){var n=t.split(".")[0],o=t.substring(n.length);e&&e!==n||i&&i!==o||function(t){return t===E.aria||t===E.tooltips}(o)&&i!==o||delete I[t]}))}function rt(t,e,n){Object.keys(I).forEach((function(o){var r=o.split(".")[0];t===r&&I[o].forEach((function(t){t.call(vt,D.map(i.format.to),e,D.slice(),n||!1,k.slice(),vt)}))}))}function st(t,e,n,o,r,s){var a;return d.length>1&&!i.events.unconstrained&&(o&&e>0&&(a=C.getAbsoluteDistance(t[e-1],i.margin,!1),n=Math.max(n,a)),r&&e<d.length-1&&(a=C.getAbsoluteDistance(t[e+1],i.margin,!0),n=Math.min(n,a))),d.length>1&&i.limit&&(o&&e>0&&(a=C.getAbsoluteDistance(t[e-1],i.limit,!1),n=Math.min(n,a)),r&&e<d.length-1&&(a=C.getAbsoluteDistance(t[e+1],i.limit,!0),n=Math.max(n,a))),i.padding&&(0===e&&(a=C.getAbsoluteDistance(0,i.padding[0],!1),n=Math.max(n,a)),e===d.length-1&&(a=C.getAbsoluteDistance(100,i.padding[1],!0),n=Math.min(n,a))),!((n=c(n=C.getStep(n)))===t[e]&&!s)&&n}function at(t,e){var n=i.ort;return(n?e:t)+", "+(n?t:e)}function lt(t,e,i,n,o){var r=i.slice(),s=n[0],a=[!t,t],l=[t,!t];n=n.slice(),t&&n.reverse(),n.length>1?n.forEach((function(t,i){var n=st(r,t,r[t]+e,a[i],l[i],!1);!1===n?e=0:(e=n-r[t],r[t]=n)})):a=l=[!0];var c=!1;n.forEach((function(t,n){c=dt(t,i[t]+e,a[n],l[n])||c})),c&&(n.forEach((function(t){rt("update",t),rt("slide",t)})),null!=o&&rt("drag",s))}function ct(t,e){return i.dir?100-t-e:t}function ut(){P.forEach((function(t){var e=k[t]>50?-1:1,i=3+(d.length+e*t);d[t].style.zIndex=String(i)}))}function dt(t,e,n,o,r){return r||(e=st(k,t,e,n,o,!1)),!1!==e&&(function(t,e){k[t]=e,D[t]=C.fromStepping(e);var n="translate("+at(10*(ct(e,0)-z)+"%","0")+")";d[t].style[i.transformRule]=n,ht(t),ht(t+1)}(t,e),!0)}function ht(t){if(m[t]){var e=0,n=100;0!==t&&(e=k[t-1]),t!==m.length-1&&(n=k[t]);var o=n-e,r="translate("+at(ct(e,o)+"%","0")+")",s="scale("+at(o/100,"1")+")";m[t].style[i.transformRule]=r+" "+s}}function pt(t,e){return null===t||!1===t||void 0===t?k[e]:("number"==typeof t&&(t=String(t)),!1!==(t=i.format.from(t))&&(t=C.toStepping(t)),!1===t||isNaN(t)?k[e]:t)}function ft(t,e,n){var o=u(t),r=void 0===k[0];e=void 0===e||e,i.animate&&!r&&l(S,i.cssClasses.tap,i.animationDuration),P.forEach((function(t){dt(t,pt(o[t],t),!0,!1,n)}));for(var s=1===P.length?0:1;s<P.length;++s)P.forEach((function(t){dt(t,k[t],!0,!0,n)}));ut(),P.forEach((function(t){rt("update",t),null!==o[t]&&e&&rt("set",t)}))}function mt(t){if(void 0===t&&(t=!1),t)return 1===D.length?D[0]:D.slice(0);var e=D.map(i.format.to);return 1===e.length?e[0]:e}function gt(t){var e=k[t],n=C.getNearbySteps(e),o=D[t],r=n.thisStep.step,s=null;if(i.snap)return[o-n.stepBefore.startValue||null,n.stepAfter.startValue-o||null];!1!==r&&o+r>n.stepAfter.startValue&&(r=n.stepAfter.startValue-o),s=o>n.thisStep.startValue?n.thisStep.step:!1!==n.stepBefore.step&&o-n.stepBefore.highestStep,100===e?r=null:0===e&&(s=null);var a=C.countStepDecimals();return null!==r&&!1!==r&&(r=Number(r.toFixed(a))),null!==s&&!1!==s&&(s=Number(s.toFixed(a))),[s,r]}h(y=S,i.cssClasses.target),0===i.dir?h(y,i.cssClasses.ltr):h(y,i.cssClasses.rtl),0===i.ort?h(y,i.cssClasses.horizontal):h(y,i.cssClasses.vertical),h(y,"rtl"===getComputedStyle(y).direction?i.cssClasses.textDirectionRtl:i.cssClasses.textDirectionLtr),a=L(y,i.cssClasses.base),function(t,e){var n=L(e,i.cssClasses.connects);d=[],(m=[]).push(F(n,t[0]));for(var o=0;o<i.handles;o++)d.push(O(e,o)),P[o]=o,m.push(F(n,t[o+1]))}(i.connect,a),(b=i.events).fixed||d.forEach((function(t,e){G(x.start,t.children[0],tt,{handleNumbers:[e]})})),b.tap&&G(x.start,a,et,{}),b.hover&&G(x.move,a,it,{hover:!0}),b.drag&&m.forEach((function(t,e){if(!1!==t&&0!==e&&e!==m.length-1){var n=d[e-1],o=d[e],r=[t];h(t,i.cssClasses.draggable),b.fixed&&(r.push(n.children[0]),r.push(o.children[0])),r.forEach((function(i){G(x.start,i,tt,{handles:[n,o],handleNumbers:[e-1,e],connect:t})}))}})),ft(i.start),i.pips&&X(i.pips),i.tooltips&&W(),ot("update"+E.aria),nt("update"+E.aria,(function(t,e,n,o,r){P.forEach((function(t){var e=d[t],o=st(k,t,0,!0,!0,!0),s=st(k,t,100,!0,!0,!0),a=r[t],l=String(i.ariaFormat.to(n[t]));o=C.fromStepping(o).toFixed(1),s=C.fromStepping(s).toFixed(1),a=C.fromStepping(a).toFixed(1),e.children[0].setAttribute("aria-valuemin",o),e.children[0].setAttribute("aria-valuemax",s),e.children[0].setAttribute("aria-valuenow",a),e.children[0].setAttribute("aria-valuetext",l)}))}));var vt={destroy:function(){for(ot(E.aria),ot(E.tooltips),Object.keys(i.cssClasses).forEach((function(t){p(S,i.cssClasses[t])}));S.firstChild;)S.removeChild(S.firstChild);delete S.noUiSlider},steps:function(){return P.map(gt)},on:nt,off:ot,get:mt,set:ft,setHandle:function(t,e,i,n){if(!((t=Number(t))>=0&&t<P.length))throw new Error("noUiSlider: invalid handle number, got: "+t);dt(t,pt(e,t),!0,!0,n),rt("update",t),i&&rt("set",t)},reset:function(t){ft(i.start,t)},__moveHandles:function(t,e,i){lt(t,e,k,i)},options:n,updateOptions:function(t,e){var o=mt(),s=["margin","limit","padding","range","animate","snap","step","format","pips","tooltips"];s.forEach((function(e){void 0!==t[e]&&(n[e]=t[e])}));var a=Z(n);s.forEach((function(e){void 0!==t[e]&&(i[e]=a[e])})),C=a.spectrum,i.margin=a.margin,i.limit=a.limit,i.padding=a.padding,i.pips?X(i.pips):B(),i.tooltips?W():j(),k=[],ft(r(t.start)?t.start:o,e)},target:S,removePips:B,removeTooltips:j,getTooltips:function(){return v},getOrigins:function(){return d},pips:X};return vt}function Y(t,e){if(!t||!t.nodeName)throw new Error("noUiSlider: create requires a single element, got: "+t);if(t.noUiSlider)throw new Error("noUiSlider: Slider was already initialized.");var i=X(t,Z(e),e);return t.noUiSlider=i,i}var G={__spectrum:x,cssClasses:S,create:Y};t.create=Y,t.cssClasses=S,t.default=G,Object.defineProperty(t,"__esModule",{value:!0})}));


async function runThemeJs() {
    /*
    @license
      Impulse by Archetype Themes (https://archetypethemes.co)
      Access unminified JS in assets/theme.js
    
      Use this event listener to run your own JS outside of this file.
      Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers
    
      document.addEventListener('page:loaded', function() {
        // Page has loaded and theme assets are ready
      });
    */
    
    window.theme = window.theme || {};
    window.Shopify = window.Shopify || {};
    
    theme.config = {
      bpSmall: false,
      hasSessionStorage: true,
      hasLocalStorage: true,
      mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
      youTubeReady: false,
      vimeoReady: false,
      vimeoLoading: false,
      isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
      stickyHeader: false,
      rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
    };
    
    if (theme.config.isTouch) {
      document.documentElement.className += ' supports-touch';
    }
    
    if (console && console.log) {
      console.log('Impulse theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
    }
    
    theme.recentlyViewed = {
      recent: {}, // will store handle+url of recent products
      productInfo: {} // will store product data to reduce API calls
    };
    
    (function(){
      'use strict';
    
      theme.delegate = {
        on: function(event, callback, options){
          if( !this.namespaces ) // save the namespaces on the DOM element itself
            this.namespaces = {};
      
          this.namespaces[event] = callback;
          options = options || false;
      
          this.addEventListener(event.split('.')[0], callback, options);
          return this;
        },
        off: function(event) {
          if (!this.namespaces) { return }
          this.removeEventListener(event.split('.')[0], this.namespaces[event]);
          delete this.namespaces[event];
          return this;
        }
      };
      
      // Extend the DOM with these above custom methods
      window.on = Element.prototype.on = theme.delegate.on;
      window.off = Element.prototype.off = theme.delegate.off;
      
      theme.utils = {
        defaultTo: function(value, defaultValue) {
          return (value == null || value !== value) ? defaultValue : value
        },
      
        wrap: function(el, wrapper) {
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
        },
      
        debounce: function(wait, callback, immediate) {
          var timeout;
          return function() {
            var context = this, args = arguments;
            var later = function() {
              timeout = null;
              if (!immediate) callback.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) callback.apply(context, args);
          }
        },
      
        throttle: function(limit, callback) {
          var waiting = false;
          return function () {
            if (!waiting) {
              callback.apply(this, arguments);
              waiting = true;
              setTimeout(function () {
                waiting = false;
              }, limit);
            }
          }
        },
      
        prepareTransition: function(el, callback) {
          el.addEventListener('transitionend', removeClass);
      
          function removeClass(evt) {
            el.classList.remove('is-transitioning');
            el.removeEventListener('transitionend', removeClass);
          }
      
          el.classList.add('is-transitioning');
          el.offsetWidth; // check offsetWidth to force the style rendering
      
          if (typeof callback === 'function') {
            callback();
          }
        },
      
        // _.compact from lodash
        // Creates an array with all falsey values removed. The values `false`, `null`,
        // `0`, `""`, `undefined`, and `NaN` are falsey.
        // _.compact([0, 1, false, 2, '', 3]);
        // => [1, 2, 3]
        compact: function(array) {
          var index = -1,
              length = array == null ? 0 : array.length,
              resIndex = 0,
              result = [];
      
          while (++index < length) {
            var value = array[index];
            if (value) {
              result[resIndex++] = value;
            }
          }
          return result;
        },
      
        serialize: function(form) {
          var arr = [];
          Array.prototype.slice.call(form.elements).forEach(function(field) {
            if (
              !field.name ||
              field.disabled ||
              ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
            )
              return;
            if (field.type === 'select-multiple') {
              Array.prototype.slice.call(field.options).forEach(function(option) {
                if (!option.selected) return;
                arr.push(
                  encodeURIComponent(field.name) +
                    '=' +
                    encodeURIComponent(option.value)
                );
              });
              return;
            }
            if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
              return;
            arr.push(
              encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
            );
          });
          return arr.join('&');
        }
      };
      
      theme.a11y = {
        trapFocus: function(options) {
          var eventsName = {
            focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
            focusout: options.namespace
              ? 'focusout.' + options.namespace
              : 'focusout',
            keydown: options.namespace
              ? 'keydown.' + options.namespace
              : 'keydown.handleFocus'
          };
      
          // Get every possible visible focusable element
          var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
          var elArray = [].slice.call(focusableEls);
          var focusableElements = elArray.filter(el => el.offsetParent !== null);
      
          var firstFocusable = focusableElements[0];
          var lastFocusable = focusableElements[focusableElements.length - 1];
      
          if (!options.elementToFocus) {
            options.elementToFocus = options.container;
          }
      
          options.container.setAttribute('tabindex', '-1');
          options.elementToFocus.focus();
      
          document.documentElement.off('focusin');
          document.documentElement.on(eventsName.focusout, function() {
            document.documentElement.off(eventsName.keydown);
          });
      
          document.documentElement.on(eventsName.focusin, function(evt) {
            if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;
      
            document.documentElement.on(eventsName.keydown, function(evt) {
              _manageFocus(evt);
            });
          });
      
          function _manageFocus(evt) {
            if (evt.keyCode !== 9) return;
            /**
             * On the first focusable element and tab backward,
             * focus the last element
             */
            if (evt.target === lastFocusable && !evt.shiftKey) {
              evt.preventDefault();
              firstFocusable.focus();
            }
          }
        },
        removeTrapFocus: function(options) {
          var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';
      
          if (options.container) {
            options.container.removeAttribute('tabindex');
          }
      
          document.documentElement.off(eventName);
        },
      
        lockMobileScrolling: function(namespace, element) {
          var el = element ? element : document.documentElement;
          document.documentElement.classList.add('lock-scroll');
          el.on('touchmove' + namespace, function() {
            return true;
          });
        },
      
        unlockMobileScrolling: function(namespace, element) {
          document.documentElement.classList.remove('lock-scroll');
          var el = element ? element : document.documentElement;
          el.off('touchmove' + namespace);
        }
      };
      
      // Add class when tab key starts being used to show outlines
      document.documentElement.on('keyup.tab', function(evt) {
        if (evt.keyCode === 9) {
          document.documentElement.classList.add('tab-outline');
          document.documentElement.off('keyup.tab');
        }
      });
      
      const trapFocusHandlers = {};
      
      /**
       * Currency Helpers
       * -----------------------------------------------------------------------------
       * A collection of useful functions that help with currency formatting
       *
       * Current contents
       * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
       *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
       * - getBaseUnit - Splits unit price apart to get value + unit
       *
       */
      
      theme.Currency = (function() {
        var moneyFormat = '${{amount}}';
        var superScript = theme && theme.settings && theme.settings.superScriptPrice;
      
        function formatMoney(cents, format) {
          if (!format) {
            format = theme.settings.moneyFormat;
          }
      
          if (typeof cents === 'string') {
            cents = cents.replace('.', '');
          }
          var value = '';
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = (format || moneyFormat);
      
          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = theme.utils.defaultTo(precision, 2);
            thousands = theme.utils.defaultTo(thousands, ',');
            decimal = theme.utils.defaultTo(decimal, '.');
      
            if (isNaN(number) || number == null) {
              return 0;
            }
      
            number = (number / 100.0).toFixed(precision);
      
            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      
            return dollarsAmount + centsAmount;
          }
      
          switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
      
              if (superScript && value && value.includes('.')) {
                value = value.replace('.', '<sup>') + '</sup>';
              }
      
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
      
              if (superScript && value && value.includes(',')) {
                value = value.replace(',', '<sup>') + '</sup>';
              }
      
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ');
              break;
          }
      
          return formatString.replace(placeholderRegex, value);
        }
      
        function getBaseUnit(variant) {
          if (!variant) {
            return;
          }
      
          if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
            return;
          }
      
          return variant.unit_price_measurement.reference_value === 1
            ? variant.unit_price_measurement.reference_unit
            : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        }
      
        return {
          formatMoney: formatMoney,
          getBaseUnit: getBaseUnit
        }
      })();
      
      theme.Images = (function() {
      
        /**
         * Find the Shopify image attribute size
         */
        function imageSize(src) {
          if (!src) {
            return '620x'; // default based on theme
          }
      
          var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
      
          if (match !== null) {
            return match[1];
          } else {
            return null;
          }
        }
      
        /**
         * Adds a Shopify size attribute to a URL
         */
        function getSizedImageUrl(src, size) {
          if (!src) {
            return src;
          }
      
          if (size == null) {
            return src;
          }
      
          if (size === 'master') {
            return this.removeProtocol(src);
          }
      
          var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      
          if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
      
            return this.removeProtocol(prefix[0] + '_' + size + suffix);
          }
      
          return null;
        }
      
        function removeProtocol(path) {
          return path.replace(/http(s)?:/, '');
        }
      
        function buildImagePath(string, widths) {
      
          if (string == null) return [];
      
          if (widths) {
            const imageUrls = [];
      
            widths.forEach(width => {
              let url = `${string}?width=${width}`;
              if (width === widths[widths.length - 1]) {
                url += ` ${width}w`
              } else {
                url += ` ${width}w,`
              }
              imageUrls.push(url);
            })
            return imageUrls;
          } else {
            return [string];
          }
        }
      
        return {
          imageSize: imageSize,
          getSizedImageUrl: getSizedImageUrl,
          removeProtocol: removeProtocol,
          buildImagePath: buildImagePath
        };
      })();
      
      // Init section function when it's visible, then disable observer
      theme.initWhenVisible = function (options) {
        var threshold = options.threshold ? options.threshold : 0
      
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (typeof options.callback === 'function') {
                options.callback()
                observer.unobserve(entry.target)
              }
            }
          })
        }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })
      
        observer.observe(options.element)
      }
      
      theme.LibraryLoader = (function() {
        var types = {
          link: 'link',
          script: 'script'
        };
      
        var status = {
          requested: 'requested',
          loaded: 'loaded'
        };
      
        var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
      
        var libraries = {
          youtubeSdk: {
            tagId: 'youtube-sdk',
            src: 'https://www.youtube.com/iframe_api',
            type: types.script
          },
          vimeo: {
            tagId: 'vimeo-api',
            src: 'https://player.vimeo.com/api/player.js',
            type: types.script
          },
          shopifyXr: {
            tagId: 'shopify-model-viewer-xr',
            src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
            type: types.script
          },
          modelViewerUi: {
            tagId: 'shopify-model-viewer-ui',
            src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
            type: types.script
          },
          modelViewerUiStyles: {
            tagId: 'shopify-model-viewer-ui-styles',
            src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
            type: types.link
          }
        };
      
        function load(libraryName, callback) {
          var library = libraries[libraryName];
      
          if (!library) return;
          if (library.status === status.requested) return;
      
          callback = callback || function() {};
          if (library.status === status.loaded) {
            callback();
            return;
          }
      
          library.status = status.requested;
      
          var tag;
      
          switch (library.type) {
            case types.script:
              tag = createScriptTag(library, callback);
              break;
            case types.link:
              tag = createLinkTag(library, callback);
              break;
          }
      
          tag.id = library.tagId;
          library.element = tag;
      
          var firstScriptTag = document.getElementsByTagName(library.type)[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
      
        function createScriptTag(library, callback) {
          var tag = document.createElement('script');
          tag.src = library.src;
          tag.addEventListener('load', function() {
            library.status = status.loaded;
            callback();
          });
          return tag;
        }
      
        function createLinkTag(library, callback) {
          var tag = document.createElement('link');
          tag.href = library.src;
          tag.rel = 'stylesheet';
          tag.type = 'text/css';
          tag.addEventListener('load', function() {
            library.status = status.loaded;
            callback();
          });
          return tag;
        }
      
        return {
          load: load
        };
      })();
      
      theme.rteInit = function() {
        // Wrap tables so they become scrollable on small screens
        document.querySelectorAll('.rte table').forEach(table => {
          var wrapWith = document.createElement('div');
          wrapWith.classList.add('table-wrapper');
          theme.utils.wrap(table, wrapWith);
        });
      
        // Wrap video iframe embeds so they are responsive
        document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
          wrapVideo(iframe);
        });
        document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
          wrapVideo(iframe);
        });
      
        function wrapVideo(iframe) {
          // Reset the src attribute on each iframe after page load
          // for Chrome's "incorrect iFrame content on 'back'" bug.
          // https://code.google.com/p/chromium/issues/detail?id=395791
          iframe.src = iframe.src;
          var wrapWith = document.createElement('div');
          wrapWith.classList.add('video-wrapper');
          theme.utils.wrap(iframe, wrapWith);
        }
      
        // Remove CSS that adds animated underline under image links
        document.querySelectorAll('.rte a img').forEach(img => {
          img.parentNode.classList.add('rte__image');
        });
      }
      
      theme.Sections = function Sections() {
        this.constructors = {};
        this.instances = [];
      
        document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
        document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
        document.addEventListener('shopify:section:select', this._onSelect.bind(this));
        document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
        document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
      };
      
      theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
        _createInstance: function(container, constructor, scope) {
          var id = container.getAttribute('data-section-id');
          var type = container.getAttribute('data-section-type');
      
          constructor = constructor || this.constructors[type];
      
          if (typeof constructor === 'undefined') {
            return;
          }
      
          // If custom scope passed, check to see if instance
          // is already initialized so we don't double up
          if (scope) {
            var instanceExists = this._findInstance(id);
            if (instanceExists) {
              this._removeInstance(id);
            }
          }
      
          // If a section fails to init, handle the error without letting all subsequest section registers to fail
          try {
            var instance = Object.assign(new constructor(container), {
              id: id,
              type: type,
              container: container
            });
            this.instances.push(instance);
          } catch (e) {
            console.error(e);
          }
        },
      
        _findInstance: function(id) {
          for (var i = 0; i < this.instances.length; i++) {
            if (this.instances[i].id === id) {
              return this.instances[i];
            }
          }
        },
      
        _removeInstance: function(id) {
          var i = this.instances.length;
          var instance;
      
          while(i--) {
            if (this.instances[i].id === id) {
              instance = this.instances[i];
              this.instances.splice(i, 1);
              break;
            }
          }
      
          return instance;
        },
      
        _onSectionLoad: function(evt, subSection, subSectionId) {
          if (window.AOS) { AOS.refreshHard() }
          if (theme && theme.initGlobals) {
            theme.initGlobals();
          }
      
          var container = subSection ? subSection : evt.target;
          var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
      
          if (!section) {
            return;
          }
      
          this._createInstance(section);
      
          var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
      
          // Check if we have subsections to load
          var haveSubSections = container.querySelectorAll('[data-subsection]');
          if (haveSubSections.length) {
            this.loadSubSections(container);
          }
      
          // Run JS only in case of the section being selected in the editor
          // before merchant clicks "Add"
          if (instance && typeof instance.onLoad === 'function') {
            instance.onLoad(evt);
          }
      
          // Force editor to trigger scroll event when loading a section
          setTimeout(function() {
            window.dispatchEvent(new Event('scroll'));
          }, 200);
        },
      
        _onSectionUnload: function(evt) {
          this.instances = this.instances.filter(function(instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
      
            if (isEventInstance) {
              if (typeof instance.onUnload === 'function') {
                instance.onUnload(evt);
              }
            }
      
            return !isEventInstance;
          });
        },
      
        loadSubSections: function(scope) {
          if (!scope) {
            return;
          }
      
          var sections = scope.querySelectorAll('[data-section-id]');
      
          sections.forEach(el => {
            this._onSectionLoad(null, el, el.dataset.sectionId);
          });
        },
      
        _onSelect: function(evt) {
          var instance = this._findInstance(evt.detail.sectionId);
      
          if (
            typeof instance !== 'undefined' &&
            typeof instance.onSelect === 'function'
          ) {
            instance.onSelect(evt);
          }
        },
      
        _onDeselect: function(evt) {
          var instance = this._findInstance(evt.detail.sectionId);
      
          if (
            typeof instance !== 'undefined' &&
            typeof instance.onDeselect === 'function'
          ) {
            instance.onDeselect(evt);
          }
        },
      
        _onBlockSelect: function(evt) {
          var instance = this._findInstance(evt.detail.sectionId);
      
          if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockSelect === 'function'
          ) {
            instance.onBlockSelect(evt);
          }
        },
      
        _onBlockDeselect: function(evt) {
          var instance = this._findInstance(evt.detail.sectionId);
      
          if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockDeselect === 'function'
          ) {
            instance.onBlockDeselect(evt);
          }
        },
      
        register: function(type, constructor, scope) {
          this.constructors[type] = constructor;
      
          var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
      
          if (scope) {
            sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
          }
      
          sections.forEach(
            function(container) {
              this._createInstance(container, constructor, scope);
            }.bind(this)
          );
        },
      
        reinit: function(section) {
          for (var i = 0; i < this.instances.length; i++) {
            var instance = this.instances[i];
            if (instance['type'] === section) {
              if (typeof instance.forceReload === 'function') {
                instance.forceReload();
              }
            }
          }
        }
      });
      
      /*
        Options:
          container
          enableHistoryState - enable when on single product page to update URL
          singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
          originalSelectorId - selector for base variant selector (visually hidden)
          variants - JSON parsed object of product variant info
       */
      theme.Variants = (function() {
      
        function Variants(options) {
          this.container = options.container;
          this.variants = options.variants;
          this.singleOptionSelector = options.singleOptionSelector;
          this.originalSelectorId = options.originalSelectorId;
          this.enableHistoryState = options.enableHistoryState;
          this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
          this.currentlySelectedValues = this._getCurrentOptions();
          this.currentVariant = this._getVariantFromOptions();
      
          this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
            el.addEventListener('change', this._onSelectChange.bind(this));
          });
        }
      
        Variants.prototype = Object.assign({}, Variants.prototype, {
      
          _getCurrentOptions: function() {
            var result = [];
      
            this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
              var type = el.getAttribute('type');
      
              if (type === 'radio' || type === 'checkbox') {
                if (el.checked) {
                  result.push({
                    value: el.value,
                    index: el.dataset.index
                  });
                }
              } else {
                result.push({
                  value: el.value,
                  index: el.dataset.index
                });
              }
            });
      
            // remove any unchecked input values if using radio buttons or checkboxes
            result = theme.utils.compact(result);
      
            return result;
          },
      
          // Pull the number out of the option index name, e.g. 'option1' -> 1
          _numberFromOptionKey: function(key) {
            return parseInt(key.substr(-1));
          },
      
          // Options should be ordered from highest to lowest priority. Make sure that priority
          // is represented using weighted values when finding best match
          _getWeightedOptionMatchCount: function(variant) {
            return this._getCurrentOptions().reduce((count, {value, index}) => {
              const optionIndex = this._numberFromOptionKey(index);
              const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
              return variant[index] === value ? count + weightedCount : count;
            },0)
          },
      
          _getFullMatch(needsToBeAvailable) {
            const currentlySelectedOptions = this._getCurrentOptions();
            const variants = this.variants;
      
            return variants.find(variant => {
              const isMatch = currentlySelectedOptions.every(({value, index}) => {
                return variant[index] === value;
              });
      
              if (needsToBeAvailable) {
                return isMatch && variant.available;
              } else {
                return isMatch;
              }
            });
          },
      
          // Find a variant that is available and best matches last selected option
          _getClosestAvailableMatch: function(lastSelectedOption) {
            if (!lastSelectedOption) return null;
      
            const currentlySelectedOptions = this._getCurrentOptions();
            const variants = this.variants;
      
            const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
              return currentlySelectedOptions
                .filter(
                  // Only match based selected options that are equal and preceeding the last selected option
                  ({value, index}) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
                ).every(({value, index}) => {
                  // Variant needs to have options that match the current and preceeding selection options
                  return variant[index] === value;
                }) && variant.available
            });
      
            return potentialAvailableMatches.reduce((bestMatch, variant) => {
              // If this is the first potential match we've found, store it as the best match
              if (bestMatch === null) return variant;
      
              // If this is not the first potential match, compare the number of options our current best match has in common
              // compared to the next contender.
              const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
              const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);
      
              return newCount > bestMatchCount ? variant : bestMatch;
            }, null);
          },
      
          _getVariantFromOptions: function(lastSelectedOption) {
            const availableFullMatch = this._getFullMatch(true);
            const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
            const fullMatch = this._getFullMatch(false);
      
            if (this.dynamicVariantsEnabled) {
              // Add some additional smarts to variant matching if Dynamic Variants are enabled
              return availableFullMatch || closestAvailableMatch || fullMatch || null;
            } else {
              // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
              return fullMatch || null;
            }
      
          },
      
          _updateInputState: function (variant, el) {
            return (input) => {
              if (variant === null) return;
      
              const index = input.dataset.index;
              const value = input.value;
              const type = input.getAttribute('type');
      
              if (type === 'radio' || type === 'checkbox') {
                input.checked = variant[index] === value
              } else {
                input.value = variant[index];
              }
            }
          },
      
          _onSelectChange: function({srcElement}) {
            const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
      
            // Get the best variant based on the current selection + last selected element
            const variant = this._getVariantFromOptions({
              index: srcElement.dataset.index,
              value: srcElement.value
            });
      
            // Update DOM option input states based on the variant that was found
            optionSelectElements.forEach(this._updateInputState(variant, srcElement))
      
            // Make sure our currently selected values are up to date after updating state of DOM
            const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();
      
            const detail = {
              variant,
              currentlySelectedValues,
              value: srcElement.value,
              index: srcElement.parentElement.dataset.index
            }
      
            this.container.dispatchEvent(new CustomEvent('variantChange', {detail}));
            document.dispatchEvent(new CustomEvent('variant:change', {detail}));
      
            if (!variant) {
              return;
            }
      
            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateUnitPrice(variant);
            this._updateSKU(variant);
            this.currentVariant = variant;
      
            if (this.enableHistoryState) {
              this._updateHistoryState(variant);
            }
          },
      
          _updateImages: function(variant) {
            if (!variant.featured_image) {
              return;
            }
      
            this.container.dispatchEvent(new CustomEvent('variantImageChange', {
              detail: {
                variant: variant
              }
            }));
          },
      
          _updatePrice: function(variant) {
            if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
              return;
            }
      
            this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
              detail: {
                variant: variant
              }
            }));
          },
      
          _updateUnitPrice: function(variant) {
            if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
              return;
            }
      
            this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
              detail: {
                variant: variant
              }
            }));
          },
      
          _updateSKU: function(variant) {
            if (this.currentVariant && variant.sku === this.currentVariant.sku) {
              return;
            }
      
            this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
              detail: {
                variant: variant
              }
            }));
          },
      
          _updateHistoryState: function(variant) {
            if (!history.replaceState || !variant) {
              return;
            }
      
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({path: newurl}, '', newurl);
          },
      
          _updateMasterSelect: function(variant) {
            let masterSelect = this.container.querySelector(this.originalSelectorId);
            if (!masterSelect) return;
      
            masterSelect.value = variant.id;
            // Force a change event so Shop Pay installments works after a variant is changed
            masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      
        return Variants;
      })();
      
      window.vimeoApiReady = function () {
        theme.config.vimeoLoading = true
      
        // Because there's no way to check for the Vimeo API being loaded
        // asynchronously, we use this terrible timeout to wait for it being ready
        checkIfVimeoIsReady()
          .then(function () {
            theme.config.vimeoReady = true
            theme.config.vimeoLoading = false
            document.dispatchEvent(new CustomEvent('vimeoReady'))
          })
      }
      
      function checkIfVimeoIsReady () {
        let wait
        let timeout
      
        return new Promise((resolve, reject) => {
          wait = setInterval(function () {
            if (!Vimeo) {
              return
            }
      
            clearInterval(wait)
            clearTimeout(timeout)
            resolve()
          }, 500)
      
          timeout = setTimeout(function () {
            clearInterval(wait)
            reject()
          }, 4000) // subjective. test up to 8 times over 4 seconds
        })
      }
      
      theme.VimeoPlayer = (function () {
        const classes = {
          loading: 'loading',
          loaded: 'loaded',
          interactable: 'video-interactable'
        }
      
        const defaults = {
          byline: false,
          loop: true,
          muted: true,
          playsinline: true,
          portrait: false,
          title: false
        }
      
        function VimeoPlayer (divId, videoId, options) {
          this.divId = divId
          this.el = document.getElementById(divId)
          this.videoId = videoId
          this.iframe = null
          this.options = options
      
          if (this.options && this.options.videoParent) {
            this.parent = this.el.closest(this.options.videoParent)
          }
      
          this.setAsLoading()
      
          if (theme.config.vimeoReady) {
            this.init()
          } else {
            theme.LibraryLoader.load('vimeo', window.vimeoApiReady)
            document.addEventListener('vimeoReady', this.init.bind(this))
          }
        }
      
        VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
          init: function () {
            const args = defaults
            args.id = this.videoId
      
            this.videoPlayer = new Vimeo.Player(this.el, args)
      
            this.videoPlayer.ready().then(this.playerReady.bind(this))
          },
      
          playerReady: function () {
            this.iframe = this.el.querySelector('iframe')
            this.iframe.setAttribute('tabindex', '-1')
      
            if (this.options.loop === 'false') {
              this.videoPlayer.setLoop(false)
            }
      
            // When sound is enabled in section settings,
            // for some mobile browsers Vimeo video playback
            // will stop immediately after starting and
            // will require users to tap the play button once more
            if (this.options.style === 'sound') {
              this.videoPlayer.setVolume(1)
            } else {
              this.videoPlayer.setVolume(0)
            }
      
            this.setAsLoaded()
      
            // pause when out of view
            const observer = new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  this.play()
                } else {
                  this.pause()
                }
              })
            }, { rootMargin: '0px 0px 50px 0px' })
      
            observer.observe(this.iframe)
          },
      
          setAsLoading: function () {
            if (!this.parent) return
            this.parent.classList.add(classes.loading)
          },
      
          setAsLoaded: function () {
            if (!this.parent) return
            this.parent.classList.remove(classes.loading)
            this.parent.classList.add(classes.loaded)
            this.parent.classList.add(classes.interactable) // Once video is loaded, we should be able to interact with it
            if (Shopify && Shopify.designMode) {
              if (window.AOS) {AOS.refreshHard()}
            }
          },
      
          enableInteraction: function () {
            if (!this.parent) return
            this.parent.classList.add(classes.interactable)
          },
      
          play: function () {
            if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
              this.videoPlayer.play()
            }
          },
      
          pause: function () {
            if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
              this.videoPlayer.pause()
            }
          },
      
          destroy: function () {
            if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
              this.videoPlayer.destroy()
            }
          }
        })
      
        return VimeoPlayer
      })()
      
      window.onYouTubeIframeAPIReady = function() {
        theme.config.youTubeReady = true;
        document.dispatchEvent(new CustomEvent('youTubeReady'));
      }
      
      /*============================================================================
        YouTube SDK method
        Parameters:
          - player div id (required)
          - arguments
            - videoId (required)
            - videoParent (selector, optional for section loading state)
            - events (object, optional)
      ==============================================================================*/
      theme.YouTube = (function() {
        var classes = {
          loading: 'loading',
          loaded: 'loaded',
          interactable: 'video-interactable'
        }
      
        var defaults = {
          width: 1280,
          height: 720,
          playerVars: {
            autohide: 0,
            autoplay: 1,
            cc_load_policy: 0,
            controls: 0,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0
          }
        };
      
        function YouTube(divId, options) {
          this.divId = divId;
          this.iframe = null;
      
          this.attemptedToPlay = false;
      
          // API callback events
          defaults.events = {
            onReady: this.onVideoPlayerReady.bind(this),
            onStateChange: this.onVideoStateChange.bind(this)
          };
      
          this.options = Object.assign({}, defaults, options);
      
          if (this.options) {
            if (this.options.videoParent) {
              this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
            }
      
            // Most YT videos will autoplay. If in product media,
            // will handle in theme.Product instead
            if (!this.options.autoplay) {
              this.options.playerVars.autoplay = this.options.autoplay;
            }
      
            if (this.options.style === 'sound') {
              this.options.playerVars.controls = 1;
              this.options.playerVars.autoplay = 0;
            }
      
          }
      
          this.setAsLoading();
      
          if (theme.config.youTubeReady) {
            this.init();
          } else {
            theme.LibraryLoader.load('youtubeSdk');
            document.addEventListener('youTubeReady', this.init.bind(this));
          }
        }
      
        YouTube.prototype = Object.assign({}, YouTube.prototype, {
          init: function() {
            this.videoPlayer = new YT.Player(this.divId, this.options);
          },
      
          onVideoPlayerReady: function(evt) {
            this.iframe = document.getElementById(this.divId); // iframe once YT loads
            this.iframe.setAttribute('tabindex', '-1');
      
            if (this.options.style !== 'sound') {
              evt.target.mute();
            }
      
            // pause when out of view
            var observer = new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  this.play();
                } else {
                  this.pause();
                }
              });
            }, {rootMargin: '0px 0px 50px 0px'});
      
            observer.observe(this.iframe);
          },
      
          onVideoStateChange: function(evt) {
            switch (evt.data) {
              case -1: // unstarted
                // Handle low power state on iOS by checking if
                // video is reset to unplayed after attempting to buffer
                if (this.attemptedToPlay) {
                  this.setAsLoaded();
                  this.enableInteraction();
                }
                break;
              case 0: // ended, loop it
                this.play(evt);
                break;
              case 1: // playing
                this.setAsLoaded();
                break;
              case 3: // buffering
                this.attemptedToPlay = true;
                break;
            }
          },
      
          setAsLoading: function() {
            if (!this.parent) return;
            this.parent.classList.add(classes.loading);
          },
      
          setAsLoaded: function() {
            if (!this.parent) return;
            this.parent.classList.remove(classes.loading);
            this.parent.classList.add(classes.loaded);
            if (Shopify && Shopify.designMode) {
              if (window.AOS) {AOS.refreshHard()}
            }
          },
      
          enableInteraction: function() {
            if (!this.parent) return;
            this.parent.classList.add(classes.interactable);
          },
      
          play: function() {
            if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
              this.videoPlayer.playVideo();
            }
          },
      
          pause: function() {
            if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
              this.videoPlayer.pauseVideo();
            }
          },
      
          destroy: function() {
            if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
              this.videoPlayer.destroy();
            }
          }
        });
      
        return YouTube;
      })();
      
      // Prevent vertical scroll while using flickity sliders
      (function() {
        var e = !1;
        var t;
      
        document.body.addEventListener('touchstart', function(i) {
          if (!i.target.closest('.flickity-slider')) {
            return e = !1;
            void 0;
          }
          e = !0;
          t = {
            x: i.touches[0].pageX,
            y: i.touches[0].pageY
          }
        })
      
        document.body.addEventListener('touchmove', function(i) {
          if (e && i.cancelable) {
            var n = {
              x: i.touches[0].pageX - t.x,
              y: i.touches[0].pageY - t.y
            };
            Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
          }
        }, { passive: !1 })
      })();
      
    
      /**
       * Ajax Renderer
       * -----------------------------------------------------------------------------
       * Render sections without reloading the page.
       * @param {Object[]} sections - The section to update on render.
       * @param {string} sections[].sectionId - The ID of the section from Shopify.
       * @param {string} sections[].nodeId - The ID of the DOM node to replace.
       * @param {Function} sections[].onReplace (optional) - The custom render function.
       * @param {boolean} debug - Output logs to console for debugging.
       *
       */
      
      theme.AjaxRenderer = (function () {
        function AjaxRenderer({ sections, onReplace, debug } = {}) {
          this.sections = sections || [];
          this.cachedSections = [];
          this.onReplace = onReplace;
          this.debug = Boolean(debug);
        }
      
        AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
          renderPage: function (basePath, newParams, updateURLHash = true) {
            const currentParams = new URLSearchParams(window.location.search);
            const updatedParams = this.getUpdatedParams(currentParams, newParams)
      
            const sectionRenders = this.sections.map(section => {
      
              const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
              const cachedSectionUrl = cachedSection => cachedSection.url === url;
      
              return this.cachedSections.some(cachedSectionUrl)
                ? this.renderSectionFromCache(cachedSectionUrl, section)
                : this.renderSectionFromFetch(url, section);
            });
      
            if (updateURLHash) this.updateURLHash(updatedParams);
      
            return Promise.all(sectionRenders);
          },
      
          renderSectionFromCache: function (url, section) {
            const cachedSection = this.cachedSections.find(url);
      
            this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
            this.renderSection(cachedSection.html, section);
            return Promise.resolve(section);
          },
      
          renderSectionFromFetch: function (url, section) {
            this.log(`[AjaxRenderer] redering from fetch: url=${url}`);
      
            return new Promise((resolve, reject) => {
              fetch(url)
                .then(response => response.text())
                .then(responseText => {
                  const html = responseText;
                  this.cachedSections = [...this.cachedSections, { html, url }];
                  this.renderSection(html, section);
                  resolve(section);
                })
                .catch(err => reject(err));
            });
          },
      
          renderSection: function (html, section) {
            this.log(
              `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
            );
      
            const newDom = new DOMParser().parseFromString(html, 'text/html');
            if (this.onReplace) {
              this.onReplace(newDom, section);
            } else {
              if (typeof section.nodeId === 'string') {
                var newContentEl = newDom.getElementById(section.nodeId);
                if (!newContentEl) {
                  return;
                }
      
                document.getElementById(section.nodeId).innerHTML =
                  newContentEl.innerHTML;
              } else {
                section.nodeId.forEach(id => {
                  document.getElementById(id).innerHTML =
                    newDom.getElementById(id).innerHTML;
                });
              }
            }
      
            return section;
          },
      
          getUpdatedParams: function (currentParams, newParams) {
            const clone = new URLSearchParams(currentParams);
            const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
      
            // Find what params need to be removed
            // delete happens first as we cannot specify keys based off of values
            for (const [key, value] of clone.entries()) {
              if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
                clone.delete(key);
              };
            }
      
            // Find what params need to be added
            for (const [key, value] of newParams.entries()) {
              if (!clone.getAll(key).includes(value) && value !== '') {
                clone.append(key, value);
              }
            }
      
            return clone;
          },
      
          updateURLHash: function (searchParams) {
            history.pushState(
              {},
              '',
              `${window.location.pathname}${
                searchParams && '?'.concat(searchParams)
              }`,
            );
          },
      
          log: function (...args) {
            if (this.debug) {
              console.log(...args);
            }
          },
        });
      
        return AjaxRenderer;
      })();
      
      if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
        navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
          shop: window.Shopify.shop,
          themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
          role: window.Shopify.theme.role,
          route: window.location.pathname,
          themeId: window.Shopify.theme.id,
          themeStoreId: window.Shopify.theme.theme_store_id || 0,
          isThemeEditor: !!window.Shopify.designMode
        }))
      }
      theme.cart = {
        getCart: function() {
          var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
          return fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          }).then(response => response.json());
        },
      
        getCartProductMarkup: function() {
          var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
      
          url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
      
          return fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          })
          .then(response => response.text())
          .catch(e => console.error(e));
        },
      
        changeItem: function(key, qty) {
      
          return this._updateCart({
            url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
            data: JSON.stringify({
              id: key,
              quantity: qty
            })
          })
        },
      
        _updateCart: function(params) {
          return fetch(params.url, {
            method: 'POST',
            body: params.data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            }
          })
          .then(response => { return response.text() })
          .then(cart => { return cart; });
        },
      
        updateAttribute: function(key, value) {
          return this._updateCart({
            url: '/cart/update.js',
            data: JSON.stringify({
              attributes: {
                [key]: theme.cart.attributeToString(value)
              }
            })
          });
        },
      
        updateNote: function(note) {
          return this._updateCart({
            url: '/cart/update.js',
            data: JSON.stringify({
              note: theme.cart.attributeToString(note)
            })
          });
        },
      
        attributeToString: function(attribute) {
          if ((typeof attribute) !== 'string') {
            attribute += '';
            if (attribute === 'undefined') {
              attribute = '';
            }
          }
          return attribute.trim();
        }
      }
      
      /*============================================================================
        CartForm
        - Prevent checkout when terms checkbox exists
        - Listen to quantity changes, rebuild cart (both widget and page)
      ==============================================================================*/
      theme.CartForm = (function() {
        var selectors = {
          products: '[data-products]',
          qtySelector: '.js-qty__wrapper',
          discounts: '[data-discounts]',
          savings: '[data-savings]',
          subTotal: '[data-subtotal]',
      
          cartBubble: '.cart-link__bubble',
          cartNote: '[name="note"]',
          termsCheckbox: '.cart__terms-checkbox',
          checkoutBtn: '.cart__checkout'
        };
      
        var classes = {
          btnLoading: 'btn--loading'
        };
      
        var config = {
          requiresTerms: false
        };
      
        function CartForm(form) {
          if (!form) {
            return;
          }
      
          this.form = form;
          this.wrapper = form.parentNode;
          this.location = form.dataset.location;
          this.namespace = '.cart-' + this.location;
          this.products = form.querySelector(selectors.products)
          this.submitBtn = form.querySelector(selectors.checkoutBtn);
      
          this.discounts = form.querySelector(selectors.discounts);
          this.savings = form.querySelector(selectors.savings);
          this.subtotal = form.querySelector(selectors.subTotal);
          this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
          this.noteInput = form.querySelector(selectors.cartNote);
      
          this.cartItemsUpdated = false;
      
          if (this.termsCheckbox) {
            config.requiresTerms = true;
          }
      
          this.init();
        }
      
        CartForm.prototype = Object.assign({}, CartForm.prototype, {
          init: function() {
            this.initQtySelectors();
      
            document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
      
            this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
      
            if (this.noteInput) {
              this.noteInput.addEventListener('change', function() {
                var newNote = this.value;
                theme.cart.updateNote(newNote);
              });
            }
      
            // Dev-friendly way to build the cart
            document.addEventListener('cart:build', function() {
              this.buildCart();
            }.bind(this));
          },
      
          reInit: function() {
            this.initQtySelectors();
          },
      
          onSubmit: function(evt) {
            this.submitBtn.classList.add(classes.btnLoading);
      
            /*
              Checks for drawer or cart open class on body element
              and then stops the form from being submitted. We are also
              checking against a custom property, this.cartItemsUpdated = false.
      
              Error is handled in the quantityChanged method
      
              For Expanse/Fetch/Gem quick add, if an error is present it is alerted
              through the add to cart fetch request in quick-add.js.
      
              Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
              Expanse/Fetch/Gem when using quick add
            */
      
            if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
              document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
              this.submitBtn.classList.remove(classes.btnLoading);
              evt.preventDefault();
              return false;
            }
      
            if (config.requiresTerms) {
              if (this.termsCheckbox.checked) {
                // continue to checkout
              } else {
                alert(theme.strings.cartTermsConfirmation);
                this.submitBtn.classList.remove(classes.btnLoading)
                evt.preventDefault();
                return false;
              }
            }
          },
      
          /*============================================================================
            Query cart page to get markup
          ==============================================================================*/
          _parseProductHTML: function(text) {
            const html = document.createElement('div');
            html.innerHTML = text;
      
            return {
              items: html.querySelector('.cart__items'),
              discounts: html.querySelector('.cart__discounts')
            }
          },
      
          buildCart: function() {
            theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
          },
      
          cartMarkup: function(text) {
            var markup = this._parseProductHTML(text);
            var items = markup.items;
            var count = parseInt(items.dataset.count);
            var subtotal = items.dataset.cartSubtotal;
            var savings = items.dataset.cartSavings;
      
            this.updateCartDiscounts(markup.discounts);
            this.updateSavings(savings);
      
            if (count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }
      
            this.updateCount(count);
      
            // Append item markup
            this.products.innerHTML = '';
            this.products.append(items);
      
            // Update subtotal
            this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      
            this.reInit();
      
            if (window.AOS) { AOS.refreshHard() }
      
            if (Shopify && Shopify.StorefrontExpressButtons) {
              Shopify.StorefrontExpressButtons.initialize();
            }
          },
      
          updateCartDiscounts: function(markup) {
            if (!this.discounts) {
              return;
            }
            this.discounts.innerHTML = '';
            this.discounts.append(markup);
          },
      
          /*============================================================================
            Quantity handling
          ==============================================================================*/
          initQtySelectors: function() {
            this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
              var selector = new theme.QtySelector(el, {
                namespace: this.namespace,
                isCart: true
              });
            });
          },
      
          quantityChanged: function(evt) {
            var key = evt.detail[0];
            var qty = evt.detail[1];
            var el = evt.detail[2];
      
            if (!key || !qty) {
              return;
            }
      
            // Disable qty selector so multiple clicks can't happen while loading
            if (el) {
              el.classList.add('is-loading');
            }
      
            theme.cart.changeItem(key, qty)
              .then(function(cart) {
      
                const parsedCart = JSON.parse(cart);
      
                if (parsedCart.status === 422) {
                  alert(parsedCart.message);
                } else {
                  const updatedItem = parsedCart.items.find(item => item.key === key);
      
                  // Update cartItemsUpdated property on object so we can reference later
                  if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                    this.cartItemsUpdated = true;
                  }
      
                  if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                    if (updatedItem.quantity !== qty) {
                    }
                    // Reset property on object so that checkout button will work as usual
                    this.cartItemsUpdated = false;
                  }
      
                  if (parsedCart.item_count > 0) {
                    this.wrapper.classList.remove('is-empty');
                  } else {
                    this.wrapper.classList.add('is-empty');
                  }
                }
      
                this.buildCart();
      
                document.dispatchEvent(new CustomEvent('cart:updated', {
                  detail: {
                    cart: parsedCart
                  }
                }));
              }.bind(this))
              .catch(function(XMLHttpRequest){});
          },
      
          /*============================================================================
            Update elements of the cart
          ==============================================================================*/
          updateSubtotal: function(subtotal) {
            this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
          },
      
          updateSavings: function(savings) {
            if (!this.savings) {
              return;
            }
      
            if (savings > 0) {
              var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
              this.savings.classList.remove('hide');
              this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
            } else {
              this.savings.classList.add('hide');
            }
          },
      
          updateCount: function(count) {
            var countEls = document.querySelectorAll('.cart-link__bubble-num');
      
            if (countEls.length) {
              countEls.forEach(el => {
                el.innerText = count;
              });
            }
      
            // show/hide bubble(s)
            var bubbles = document.querySelectorAll(selectors.cartBubble);
            if (bubbles.length) {
              if (count > 0) {
                bubbles.forEach(b => {
                  b.classList.add('cart-link__bubble--visible');
                });
              } else {
                bubbles.forEach(b => {
                  b.classList.remove('cart-link__bubble--visible');
                });
              }
            }
          }
        });
      
        return CartForm;
      })();
      
      // Either collapsible containers all acting individually,
      // or tabs that can only have one open at a time
      theme.collapsibles = (function() {
        var selectors = {
          trigger: '.collapsible-trigger',
          module: '.collapsible-content',
          moduleInner: '.collapsible-content__inner',
          tabs: '.collapsible-trigger--tab'
        };
      
        var classes = {
          hide: 'hide',
          open: 'is-open',
          autoHeight: 'collapsible--auto-height',
          tabs: 'collapsible-trigger--tab'
        };
      
        var namespace = '.collapsible';
      
        var isTransitioning = false;
      
        function init(scope) {
          var el = scope ? scope : document;
          el.querySelectorAll(selectors.trigger).forEach(trigger => {
            var state = trigger.classList.contains(classes.open);
            trigger.setAttribute('aria-expanded', state);
      
            trigger.off('click' + namespace);
            trigger.on('click' + namespace, toggle);
          });
        }
      
        function toggle(evt) {
          if (isTransitioning) {
            return;
          }
      
          isTransitioning = true;
      
          var el = evt.currentTarget;
          var isOpen = el.classList.contains(classes.open);
          var isTab = el.classList.contains(classes.tabs);
          var moduleId = el.getAttribute('aria-controls');
          var container = document.getElementById(moduleId);
      
          if (!moduleId) {
            moduleId = el.dataset.controls;
          }
      
          // No ID, bail
          if (!moduleId) {
            return;
          }
      
          // If container=null, there isn't a matching ID.
          // Check if data-id is set instead. Could be multiple.
          // Select based on being in the same parent div.
          if (!container) {
            var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
            if (multipleMatches.length > 0) {
              container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
            }
          }
      
          if (!container) {
            isTransitioning = false;
            return;
          }
      
          var height = container.querySelector(selectors.moduleInner).offsetHeight;
          var isAutoHeight = container.classList.contains(classes.autoHeight);
          var parentCollapsibleEl = container.parentNode.closest(selectors.module);
          var childHeight = height;
      
          if (isTab) {
            if(isOpen) {
              isTransitioning = false;
              return;
            }
      
            var newModule;
            document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
              el.classList.remove(classes.open);
              newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
              setTransitionHeight(newModule, 0, true);
            });
          }
      
          // If isAutoHeight, set the height to 0 just after setting the actual height
          // so the closing animation works nicely
          if (isOpen && isAutoHeight) {
            setTimeout(function() {
              height = 0;
              setTransitionHeight(container, height, isOpen, isAutoHeight);
            }, 0);
          }
      
          if (isOpen && !isAutoHeight) {
            height = 0;
          }
      
          el.setAttribute('aria-expanded', !isOpen);
          if (isOpen) {
            el.classList.remove(classes.open);
          } else {
            el.classList.add(classes.open);
          }
      
          setTransitionHeight(container, height, isOpen, isAutoHeight);
      
          // If we are in a nested collapsible element like the mobile nav,
          // also set the parent element's height
          if (parentCollapsibleEl) {
            var parentHeight = parentCollapsibleEl.style.height;
      
            if (isOpen && parentHeight === 'auto') {
              childHeight = 0; // Set childHeight to 0 if parent is initially opened
            }
      
            var totalHeight = isOpen
                            ? parentCollapsibleEl.offsetHeight - childHeight
                            : height + parentCollapsibleEl.offsetHeight;
      
            setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
          }
        }
      
        function setTransitionHeight(container, height, isOpen, isAutoHeight) {
          container.classList.remove(classes.hide);
          theme.utils.prepareTransition(container, function() {
      
            container.style.height = height+'px';
            if (isOpen) {
              container.classList.remove(classes.open);
            } else {
              container.classList.add(classes.open);
            }
          });
      
          if (!isOpen && isAutoHeight) {
            var o = container;
            window.setTimeout(function() {
              o.css('height','auto');
              isTransitioning = false;
            }, 500);
          } else {
            isTransitioning = false;
          }
        }
      
        return {
          init: init
        };
      })();
      
      // Shopify-built select-like popovers for currency and language selection
      theme.Disclosure = (function() {
        var selectors = {
          disclosureForm: '[data-disclosure-form]',
          disclosureList: '[data-disclosure-list]',
          disclosureToggle: '[data-disclosure-toggle]',
          disclosureInput: '[data-disclosure-input]',
          disclosureOptions: '[data-disclosure-option]'
        };
      
        var classes = {
          listVisible: 'disclosure-list--visible'
        };
      
        function Disclosure(disclosure) {
          this.container = disclosure;
          this._cacheSelectors();
          this._setupListeners();
        }
      
        Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
          _cacheSelectors: function() {
            this.cache = {
              disclosureForm: this.container.closest(selectors.disclosureForm),
              disclosureList: this.container.querySelector(selectors.disclosureList),
              disclosureToggle: this.container.querySelector(
                selectors.disclosureToggle
              ),
              disclosureInput: this.container.querySelector(
                selectors.disclosureInput
              ),
              disclosureOptions: this.container.querySelectorAll(
                selectors.disclosureOptions
              )
            };
          },
      
          _setupListeners: function() {
            this.eventHandlers = this._setupEventHandlers();
      
            this.cache.disclosureToggle.addEventListener(
              'click',
              this.eventHandlers.toggleList
            );
      
            this.cache.disclosureOptions.forEach(function(disclosureOption) {
              disclosureOption.addEventListener(
                'click',
                this.eventHandlers.connectOptions
              );
            }, this);
      
            this.container.addEventListener(
              'keyup',
              this.eventHandlers.onDisclosureKeyUp
            );
      
            this.cache.disclosureList.addEventListener(
              'focusout',
              this.eventHandlers.onDisclosureListFocusOut
            );
      
            this.cache.disclosureToggle.addEventListener(
              'focusout',
              this.eventHandlers.onDisclosureToggleFocusOut
            );
      
            document.body.addEventListener('click', this.eventHandlers.onBodyClick);
          },
      
          _setupEventHandlers: function() {
            return {
              connectOptions: this._connectOptions.bind(this),
              toggleList: this._toggleList.bind(this),
              onBodyClick: this._onBodyClick.bind(this),
              onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
              onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
              onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
            };
          },
      
          _connectOptions: function(event) {
            event.preventDefault();
      
            this._submitForm(event.currentTarget.dataset.value);
          },
      
          _onDisclosureToggleFocusOut: function(event) {
            var disclosureLostFocus =
              this.container.contains(event.relatedTarget) === false;
      
            if (disclosureLostFocus) {
              this._hideList();
            }
          },
      
          _onDisclosureListFocusOut: function(event) {
            var childInFocus = event.currentTarget.contains(event.relatedTarget);
      
            var isVisible = this.cache.disclosureList.classList.contains(
              classes.listVisible
            );
      
            if (isVisible && !childInFocus) {
              this._hideList();
            }
          },
      
          _onDisclosureKeyUp: function(event) {
            if (event.which !== 27) return;
            this._hideList();
            this.cache.disclosureToggle.focus();
          },
      
          _onBodyClick: function(event) {
            var isOption = this.container.contains(event.target);
            var isVisible = this.cache.disclosureList.classList.contains(
              classes.listVisible
            );
      
            if (isVisible && !isOption) {
              this._hideList();
            }
          },
      
          _submitForm: function(value) {
            this.cache.disclosureInput.value = value;
            this.cache.disclosureForm.submit();
          },
      
          _hideList: function() {
            this.cache.disclosureList.classList.remove(classes.listVisible);
            this.cache.disclosureToggle.setAttribute('aria-expanded', false);
          },
      
          _toggleList: function() {
            var ariaExpanded =
              this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
            this.cache.disclosureList.classList.toggle(classes.listVisible);
            this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
          },
      
          destroy: function() {
            this.cache.disclosureToggle.removeEventListener(
              'click',
              this.eventHandlers.toggleList
            );
      
            this.cache.disclosureOptions.forEach(function(disclosureOption) {
              disclosureOption.removeEventListener(
                'click',
                this.eventHandlers.connectOptions
              );
            }, this);
      
            this.container.removeEventListener(
              'keyup',
              this.eventHandlers.onDisclosureKeyUp
            );
      
            this.cache.disclosureList.removeEventListener(
              'focusout',
              this.eventHandlers.onDisclosureListFocusOut
            );
      
            this.cache.disclosureToggle.removeEventListener(
              'focusout',
              this.eventHandlers.onDisclosureToggleFocusOut
            );
      
            document.body.removeEventListener(
              'click',
              this.eventHandlers.onBodyClick
            );
          }
        });
      
        return Disclosure;
      })();
      
      theme.Drawers = (function() {
        function Drawers(id, name) {
          this.config = {
            id: id,
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + name,
            openClass: 'js-drawer-open',
            closingClass: 'js-drawer-closing',
            activeDrawer: 'drawer--is-open',
            namespace: '.drawer-' + name
          };
      
          this.nodes = {
            page: document.querySelector('#MainContent')
          };
      
          this.drawer = document.querySelector('#' + id);
          this.isOpen = false;
      
          if (!this.drawer) {
            return;
          }
      
          this.init();
        }
      
        Drawers.prototype = Object.assign({}, Drawers.prototype, {
          init: function() {
            // Setup open button(s)
            document.querySelectorAll(this.config.open).forEach(openBtn => {
              openBtn.setAttribute('aria-expanded', 'false');
              openBtn.addEventListener('click', this.open.bind(this));
            });
      
            this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));
      
            // Close modal if a drawer is opened
            document.addEventListener('modalOpen', function() {
              this.close();
            }.bind(this));
          },
      
          open: function(evt, returnFocusEl) {
            if (evt) {
              evt.preventDefault();
            }
      
            if (this.isOpen) {
              return;
            }
      
            // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
            if (evt && evt.stopPropagation) {
              evt.stopPropagation();
              // save the source of the click, we'll focus to this on close
              evt.currentTarget.setAttribute('aria-expanded', 'true');
              this.activeSource = evt.currentTarget;
            } else if (returnFocusEl) {
              returnFocusEl.setAttribute('aria-expanded', 'true');
              this.activeSource = returnFocusEl;
            }
      
            theme.utils.prepareTransition(this.drawer, function() {
              this.drawer.classList.add(this.config.activeDrawer);
            }.bind(this));
      
            document.documentElement.classList.add(this.config.openClass);
            this.isOpen = true;
      
            theme.a11y.trapFocus({
              container: this.drawer,
              namespace: 'drawer_focus'
            });
      
            document.dispatchEvent(new CustomEvent('drawerOpen'));
            document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
      
            this.bindEvents();
          },
      
          close: function(evt) {
            if (!this.isOpen) {
              return;
            }
      
            // Do not close if click event came from inside drawer
            if (evt) {
              if (evt.target.closest('.js-drawer-close')) {
                // Do not close if using the drawer close button
              } else if (evt.target.closest('.drawer')) {
                return;
              }
            }
      
            // deselect any focused form elements
            document.activeElement.blur();
      
            theme.utils.prepareTransition(this.drawer, function() {
              this.drawer.classList.remove(this.config.activeDrawer);
            }.bind(this));
      
            document.documentElement.classList.remove(this.config.openClass);
            document.documentElement.classList.add(this.config.closingClass);
      
            window.setTimeout(function() {
              document.documentElement.classList.remove(this.config.closingClass);
              if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
                this.activeSource.setAttribute('aria-expanded', 'false');
                this.activeSource.focus();
              }
            }.bind(this), 500);
      
            this.isOpen = false;
      
            theme.a11y.removeTrapFocus({
              container: this.drawer,
              namespace: 'drawer_focus'
            });
      
            this.unbindEvents();
          },
      
          bindEvents: function() {
            // Clicking out of drawer closes it
            window.on('click' + this.config.namespace, function(evt) {
              this.close(evt)
              return;
            }.bind(this));
      
            // Pressing escape closes drawer
            window.on('keyup' + this.config.namespace, function(evt) {
              if (evt.keyCode === 27) {
                this.close();
              }
            }.bind(this));
      
            theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
          },
      
          unbindEvents: function() {
            window.off('click' + this.config.namespace);
            window.off('keyup' + this.config.namespace);
      
            theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
          }
        });
      
        return Drawers;
      })();
      
      theme.Modals = (function() {
        function Modal(id, name, options) {
          var defaults = {
            close: '.js-modal-close',
            open: '.js-modal-open-' + name,
            openClass: 'modal--is-active',
            closingClass: 'modal--is-closing',
            bodyOpenClass: ['modal-open'],
            bodyOpenSolidClass: 'modal-open--solid',
            bodyClosingClass: 'modal-closing',
            closeOffContentClick: true
          };
      
          this.id = id;
          this.modal = document.getElementById(id);
      
          if (!this.modal) {
            return false;
          }
      
          this.modalContent = this.modal.querySelector('.modal__inner');
      
          this.config = Object.assign(defaults, options);
          this.modalIsOpen = false;
          this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
          this.isSolid = this.config.solid;
      
          this.init();
        }
      
        Modal.prototype.init = function() {
          document.querySelectorAll(this.config.open).forEach(btn => {
            btn.setAttribute('aria-expanded', 'false');
            btn.addEventListener('click', this.open.bind(this));
          });
      
          this.modal.querySelectorAll(this.config.close).forEach(btn => {
            btn.addEventListener('click', this.close.bind(this));
          });
      
          // Close modal if a drawer is opened
          document.addEventListener('drawerOpen', function() {
            this.close();
          }.bind(this));
        };
      
        Modal.prototype.open = function(evt) {
          // Keep track if modal was opened from a click, or called by another function
          var externalCall = false;
      
          // don't open an opened modal
          if (this.modalIsOpen) {
            return;
          }
      
          // Prevent following href if link is clicked
          if (evt) {
            evt.preventDefault();
          } else {
            externalCall = true;
          }
      
          // Without this, the modal opens, the click event bubbles up to $nodes.page
          // which closes the modal.
          if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
          }
      
          if (this.modalIsOpen && !externalCall) {
            this.close();
          }
      
          this.modal.classList.add(this.config.openClass);
      
          document.documentElement.classList.add(...this.config.bodyOpenClass);
      
          if (this.isSolid) {
            document.documentElement.classList.add(this.config.bodyOpenSolidClass);
          }
      
          this.modalIsOpen = true;
      
          // Delay trap focus to ensure elements are seen by screen readers
          setTimeout(() => {
            theme.a11y.trapFocus({
              container: this.modal,
              elementToFocus: this.focusOnOpen,
              namespace: 'modal_focus'
            });
          }, 100);
      
      
          document.dispatchEvent(new CustomEvent('modalOpen'));
          document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
      
          this.bindEvents();
        };
      
        Modal.prototype.close = function(evt) {
          // don't close a closed modal
          if (!this.modalIsOpen) {
            return;
          }
      
          // Do not close modal if click happens inside modal content
          if (evt) {
            if (evt.target.closest('.js-modal-close')) {
              // Do not close if using the modal close button
            } else if (evt.target.closest('.modal__inner')) {
              return;
            }
          }
      
          // deselect any focused form elements
          document.activeElement.blur();
      
          this.modal.classList.remove(this.config.openClass);
          this.modal.classList.add(this.config.closingClass);
      
          document.documentElement.classList.remove(...this.config.bodyOpenClass);
          document.documentElement.classList.add(this.config.bodyClosingClass);
      
          window.setTimeout(function() {
            document.documentElement.classList.remove(this.config.bodyClosingClass);
            this.modal.classList.remove(this.config.closingClass);
            if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
              this.activeSource.setAttribute('aria-expanded', 'false').focus();
            }
          }.bind(this), 500); // modal close css transition
      
          if (this.isSolid) {
            document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
          }
      
          this.modalIsOpen = false;
      
          theme.a11y.removeTrapFocus({
            container: this.modal,
            namespace: 'modal_focus'
          });
      
          document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
      
          this.unbindEvents();
        };
      
        Modal.prototype.bindEvents = function() {
          window.on('keyup.modal', function(evt) {
            if (evt.keyCode === 27) {
              this.close();
            }
          }.bind(this));
      
          if (this.config.closeOffContentClick) {
            // Clicking outside of the modal content also closes it
            this.modal.on('click.modal', this.close.bind(this));
          }
        };
      
        Modal.prototype.unbindEvents = function() {
          document.documentElement.off('.modal');
      
          if (this.config.closeOffContentClick) {
            this.modal.off('.modal');
          }
        };
      
        return Modal;
      })();
      
      /*============================================================================
        ParallaxImage
      ==============================================================================*/
      
      class ParallaxImage extends HTMLElement {
        constructor() {
          super();
          this.parallaxImage = this.querySelector('[data-parallax-image]');
          this.windowInnerHeight = window.innerHeight;
          this.isActive = false;
          this.timeout = null;
          this.directionMap = {
            right: 0,
            top: 90,
            left: 180,
            bottom: 270
          }
          this.directionMultipliers = {
            0: [  1,  0 ],
            90: [  0, -1 ],
            180: [ -1,  0 ],
            270: [  0,  1 ]
          }
      
          this.init();
          window.addEventListener('scroll', () => this.scrollHandler());
        }
      
        getParallaxInfo() {
          const { width, height, top } = this.parallaxImage.getBoundingClientRect();
          let element = this.parallaxImage;
          let multipliers;
          let { angle, movement } = element.dataset;
      
          let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));
      
          // angle has shorthands "top", "left", "bottom" and "right"
          // nullish coalescing. using `||` here would fail for `0`
          angle = this.directionMap[angle] ?? parseFloat(angle);
      
          // fallback if undefined
          // NaN is the only value that doesn't equal itself
          if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
          if (movementPixels !== movementPixels) movementPixels = 100; // 100px
      
          // check if angle is located in top half and/or left half
          angle %= 360;
          if (angle < 0) angle += 360
      
          const toLeft = angle > 90 && angle < 270;
          const toTop  = angle < 180;
      
          element.style[toLeft ? 'left' : 'right'] = 0;
          element.style[toTop  ? 'top' : 'bottom'] = 0;
      
          // if it's not a perfectly horizontal or vertical movement, get cos and sin
          if (angle % 90) {
            const radians = angle * Math.PI / 180
            multipliers = [ Math.cos(radians), Math.sin(radians) * -1 ] // only sin has to be inverted
          } else {
            multipliers = this.directionMultipliers[angle];
          }
      
          // increase width and height according to movement and multipliers
          if (multipliers[0]) element.style.width  = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
          if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;
      
          return {
            element,
            movementPixels,
            multipliers,
            top,
            height
          }
        }
      
        init() {
          const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();;
      
          const scrolledInContainer = this.windowInnerHeight - top;
          const scrollArea = this.windowInnerHeight + height;
          const progress = scrolledInContainer / scrollArea;
      
          if (progress > -0.1 && progress < 1.1) {
            const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
            element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
          }
      
          if (this.isActive) requestAnimationFrame(this.init.bind(this));
        }
      
        scrollHandler() {
          if (this.isActive) {
            clearTimeout(this.timeout);
          } else {
            this.isActive = true;
            requestAnimationFrame(this.init.bind(this));
          }
      
          this.timeout = setTimeout(() => this.isActive = false, 20);
        }
      }
      
      customElements.define('parallax-image', ParallaxImage);
      
      if (typeof window.noUiSlider === 'undefined') {
        throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
      }
      
      theme.PriceRange = (function () {
        var defaultStep = 10;
        var selectors = {
          priceRange: '.price-range',
          priceRangeSlider: '.price-range__slider',
          priceRangeInputMin: '.price-range__input-min',
          priceRangeInputMax: '.price-range__input-max',
          priceRangeDisplayMin: '.price-range__display-min',
          priceRangeDisplayMax: '.price-range__display-max',
        };
      
        function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
          this.container = container;
          this.onChange = onChange;
          this.onUpdate = onUpdate;
          this.sliderOptions = sliderOptions || {};
      
          return this.init();
        }
      
        PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
          init: function () {
            if (!this.container.classList.contains('price-range')) {
              throw new Error('You must instantiate PriceRange with a valid container')
            }
      
            this.formEl = this.container.closest('form');
            this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
            this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
            this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
            this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
            this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);
      
            this.minRange = parseFloat(this.container.dataset.min) || 0;
            this.minValue = parseFloat(this.container.dataset.minValue) || 0;
            this.maxRange = parseFloat(this.container.dataset.max) || 100;
            this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
      
            return this.createPriceRange();
          },
      
          createPriceRange: function () {
            if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
              this.sliderEl.noUiSlider.destroy();
            }
      
            var slider = noUiSlider.create(this.sliderEl, {
              connect: true,
              step: defaultStep,
              ...this.sliderOptions,
              // Do not allow overriding these options
              start: [this.minValue, this.maxValue],
              range: {
                min: this.minRange,
                max: this.maxRange,
              },
            });
      
            slider.on('update', values => {
              this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                values[0],
                theme.settings.moneyFormat,
              );
              this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                values[1],
                theme.settings.moneyFormat,
              );
      
              if (this.onUpdate) {
                this.onUpdate(values);
              }
            });
      
            slider.on('change', values => {
              this.inputMinEl.value = values[0];
              this.inputMaxEl.value = values[1];
      
              if (this.onChange) {
                const formData = new FormData(this.formEl);
                this.onChange(formData);
              }
            });
      
            return slider;
          },
        });
      
        return PriceRange;
      })();
      
      theme.AjaxProduct = (function() {
        var status = {
          loading: false
        };
      
        function ProductForm(form, submit, args) {
          this.form = form;
          this.args = args;
      
          var submitSelector = submit ? submit : '.add-to-cart';
      
          if (this.form) {
            this.addToCart = form.querySelector(submitSelector);
            this.form.addEventListener('submit', this.addItemFromForm.bind(this));
          }
        };
      
        ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
          addItemFromForm: function(evt, callback){
            evt.preventDefault();
      
            if (status.loading) {
              return;
            }
      
            // Loading indicator on add to cart button
            this.addToCart.classList.add('btn--loading');
      
            status.loading = true;
      
            var data = theme.utils.serialize(this.form);
      
            fetch(theme.routes.cartAdd, {
              method: 'POST',
              body: data,
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => response.json())
            .then(function(data) {
              if (data.status === 422) {
                this.error(data);
              } else {
                var product = data;
                this.success(product);
              }
      
              status.loading = false;
              this.addToCart.classList.remove('btn--loading');
      
              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains('template-cart')) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this));
          },
      
          success: function(product) {
            var errors = this.form.querySelector('.errors');
            if (errors) {
              errors.remove();
            }
      
            if (theme.settings.cartType === 'page') {
              window.location = theme.routes.cartPage;
            }
      
            this.form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: product,
                addToCartBtn: this.addToCart
              },
              bubbles: true
            }));
      
            if (this.args && this.args.scopedEventId) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
                detail: {
                  product: product,
                  addToCartBtn: this.addToCart
                }
              }));
            }
          },
      
          error: function(error) {
            if (!error.description) {
              console.warn(error);
              return;
            }
      
            var errors = this.form.querySelector('.errors');
            if (errors) {
              errors.remove();
            }
      
            var errorDiv = document.createElement('div');
            errorDiv.classList.add('errors', 'text-center');
      
            if (typeof error.description === 'object') {
              errorDiv.textContent = error.message;
            } else {
              errorDiv.textContent = error.description;
            }
      
            this.form.append(errorDiv);
      
            this.form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
              detail: {
                errorMessage: error.description
              },
              bubbles: true
            }));
      
            if (this.args && this.args.scopedEventId) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
                detail: {
                  errorMessage: error.description
                }
              }));
            }
          }
        });
      
        return ProductForm;
      })();
      
      theme.ProductMedia = (function() {
        var modelJsonSections = {};
        var models = {};
        var xrButtons = {};
      
        var selectors = {
          mediaGroup: '[data-product-single-media-group]',
          xrButton: '[data-shopify-xr]'
        };
      
        function init(modelViewerContainers, sectionId) {
          modelJsonSections[sectionId] = {
            loaded: false
          };
      
          modelViewerContainers.forEach(function(container, index) {
            var mediaId = container.dataset.mediaId;
            var modelViewerElement = container.querySelector('model-viewer');
            var modelId = modelViewerElement.dataset.modelId;
      
            if (index === 0) {
              var mediaGroup = container.closest(selectors.mediaGroup);
              var xrButton = mediaGroup.querySelector(selectors.xrButton);
              xrButtons[sectionId] = {
                element: xrButton,
                defaultId: modelId
              };
            }
      
            models[mediaId] = {
              modelId: modelId,
              sectionId: sectionId,
              container: container,
              element: modelViewerElement
            };
      
          });
      
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: setupShopifyXr
            },
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: setupModelViewerUi
            }
          ]);
      
          theme.LibraryLoader.load('modelViewerUiStyles');
        }
      
        function setupShopifyXr(errors) {
          if (errors) return;
      
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', function() {
              setupShopifyXr();
            });
            return;
          }
      
          for (var sectionId in modelJsonSections) {
            if (modelJsonSections.hasOwnProperty(sectionId)) {
              var modelSection = modelJsonSections[sectionId];
      
              if (modelSection.loaded) continue;
      
              var modelJson = document.querySelector('#ModelJson-' + sectionId);
      
              window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
              modelSection.loaded = true;
            }
          }
          window.ShopifyXR.setupXRElements();
        }
      
        function setupModelViewerUi(errors) {
          if (errors) return;
      
          for (var key in models) {
            if (models.hasOwnProperty(key)) {
              var model = models[key];
              if (!model.modelViewerUi && Shopify) {
                model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
              }
              setupModelViewerListeners(model);
            }
          }
        }
      
        function setupModelViewerListeners(model) {
          var xrButton = xrButtons[model.sectionId];
      
          model.container.addEventListener('mediaVisible', function(event) {
            xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
            if (theme.config.isTouch) return;
            if (!event.detail.autoplayMedia) return;
            model.modelViewerUi.play();
          });
      
          model.container.addEventListener('mediaHidden', function() {
            xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
            model.modelViewerUi.pause();
          });
      
          model.container.addEventListener('xrLaunch', function() {
            model.modelViewerUi.pause();
          });
        }
      
        function removeSectionModels(sectionId) {
          for (var key in models) {
            if (models.hasOwnProperty(key)) {
              var model = models[key];
              if (model.sectionId === sectionId) {
                delete models[key];
              }
            }
          }
          delete modelJsonSections[sectionId];
        }
      
        return {
          init: init,
          removeSectionModels: removeSectionModels
        };
      })();
      
      theme.QtySelector = (function() {
        var selectors = {
          input: '.js-qty__num',
          plus: '.js-qty__adjust--plus',
          minus: '.js-qty__adjust--minus'
        };
      
        function QtySelector(el, options) {
          this.wrapper = el;
          this.plus = el.querySelector(selectors.plus);
          this.minus = el.querySelector(selectors.minus);
          this.input = el.querySelector(selectors.input);
          this.minValue = this.input.getAttribute('min') || 1;
      
          var defaults = {
            namespace: null,
            isCart: false,
            key: this.input.dataset.id
          };
      
          this.options = Object.assign({}, defaults, options);
      
          this.init();
        }
      
        QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
          init: function() {
            this.plus.addEventListener('click', function() {
              var qty = this._getQty();
              this._change(qty + 1);
            }.bind(this));
      
            this.minus.addEventListener('click', function() {
              var qty = this._getQty();
              this._change(qty - 1);
            }.bind(this));
      
            this.input.addEventListener('change', function(evt) {
              this._change(this._getQty());
            }.bind(this));
          },
      
          _getQty: function() {
            var qty = this.input.value;
            if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
              // We have a valid number!
            } else {
              // Not a number. Default to 1.
              qty = 1;
            }
            return parseInt(qty);
          },
      
          _change: function(qty) {
            if (qty <= this.minValue) {
              qty = this.minValue;
            }
      
            this.input.value = qty;
      
            if (this.options.isCart) {
              document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
                  detail: [this.options.key, qty, this.wrapper]
              }));
            }
          }
        });
      
        return QtySelector;
      })();
      
      theme.initQuickShop = function() {
        var ids = [];
        var products = document.querySelectorAll('.grid-product');
      
        if (!products.length || !theme.settings.quickView) {
          return;
        }
      
        products.forEach(product => {
          product.addEventListener('mouseover', productMouseover);
          product.addEventListener('focusin', productMouseover);
        });
      
        function productMouseover(evt) {
          var el = evt.currentTarget;
          // No quick view on mobile breakpoint
          if (!theme.config.bpSmall) {
            el.removeEventListener('mouseover', productMouseover);
            el.removeEventListener('focusin', productMouseover);
            if (!el || !el.dataset.productId) {
              // Onboarding product, no real data
              return;
            }
            var productId = el.dataset.productId;
            var handle = el.dataset.productHandle;
            var btn = el.querySelector('.quick-product__btn');
            theme.preloadProductModal(handle, productId, btn);
          }
        }
      };
      
      theme.preloadProductModal = function(handle, productId, btn) {
        var holder = document.getElementById('QuickShopHolder-' + handle);
        var url = theme.routes.home + '/products/' + handle + '?view=modal';
      
        // remove double `/` in case shop might have /en or language in URL
        url = url.replace('//', '/');
      
        fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const div = html.querySelector('.product-section[data-product-handle="'+handle+'"]');
      
          if (!holder) {
            return;
          }
      
          holder.innerHTML = '';
          holder.append(div);
      
          // Setup quick view modal
          var modalId = 'QuickShopModal-' + productId;
          var name = 'quick-modal-' + productId;
          new theme.Modals(modalId, name);
      
          // Register product template inside quick view
          theme.sections.register('product', theme.Product, holder);
      
          // Register collapsible elements
          theme.collapsibles.init();
      
          // Register potential video modal links (when video has sound)
          theme.videoModal();
      
          if (btn) {
            btn.classList.remove('quick-product__btn--not-ready');
          }
        });
      }
      
      // theme.Slideshow handles all flickity based sliders
      // Child navigation is only setup to work on product images
      theme.Slideshow = (function() {
        var classes = {
          animateOut: 'animate-out',
          isPaused: 'is-paused',
          isActive: 'is-active'
        };
      
        var selectors = {
          allSlides: '.slideshow__slide',
          currentSlide: '.is-selected',
          wrapper: '.slideshow-wrapper',
          pauseButton: '.slideshow__pause'
        };
      
        var productSelectors = {
          thumb: '.product__thumb-item:not(.hide)',
          links: '.product__thumb-item:not(.hide) a',
          arrow: '.product__thumb-arrow'
        };
      
        var defaults = {
          adaptiveHeight: false,
          autoPlay: false,
          avoidReflow: false, // custom by Archetype
          childNav: null, // element. Custom by Archetype instead of asNavFor
          childNavScroller: null, // element
          childVertical: false,
          dragThreshold: 7,
          fade: false,
          friction: 0.8,
          initialIndex: 0,
          pageDots: false,
          pauseAutoPlayOnHover: false,
          prevNextButtons: false,
          rightToLeft: theme.config.rtl,
          selectedAttraction: 0.14,
          setGallerySize: true,
          wrapAround: true
        };
      
        function slideshow(el, args) {
          this.el = el;
          this.args = Object.assign({}, defaults, args);
      
          // Setup listeners as part of arguments
          this.args.on = {
            ready: this.init.bind(this),
            change: this.slideChange.bind(this),
            settle: this.afterChange.bind(this)
          };
      
          if (this.args.childNav) {
            this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
            this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
            this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
            if (this.childNavLinks.length) {
              this.initChildNav();
            }
          }
      
          if (this.args.avoidReflow) {
            avoidReflow(el);
          }
      
          this.slideshow = new Flickity(el, this.args);
      
          // Prevent dragging on the product slider from triggering a zoom on product images
          if (el.dataset.zoom && el.dataset.zoom === 'true') {
            this.slideshow.on('dragStart', () => {
              this.slideshow.slider.style.pointerEvents = 'none';
      
              // With fade enabled, we also need to adjust the pointerEvents on the selected slide
              if (this.slideshow.options.fade) {
                this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
              }
            });
            this.slideshow.on('dragEnd', () => {
              this.slideshow.slider.style.pointerEvents = 'auto';
      
              // With fade enabled, we also need to adjust the pointerEvents on the selected slide
              if (this.slideshow.options.fade) {
                this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
              }
            });
          }
      
          if (this.args.autoPlay) {
            var wrapper = el.closest(selectors.wrapper);
            this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
            if (this.pauseBtn) {
              this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
            }
          }
      
          // Reset dimensions on resize
          window.on('resize', theme.utils.debounce(300, function() {
            this.resize();
          }.bind(this)));
      
          // Set flickity-viewport height to first element to
          // avoid awkward page reflows while initializing.
          // Must be added in a `style` tag because element does not exist yet.
          // Slideshow element must have an ID
          function avoidReflow(el) {
            if (!el.id) return;
            var firstChild = el.firstChild;
            while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
              firstChild = firstChild.nextSibling;
            }
            var style = document.createElement('style');
            style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
            document.head.appendChild(style);
          }
        }
      
        slideshow.prototype = Object.assign({}, slideshow.prototype, {
          init: function(el) {
            this.currentSlide = this.el.querySelector(selectors.currentSlide);
      
            // Optional onInit callback
            if (this.args.callbacks && this.args.callbacks.onInit) {
              if (typeof this.args.callbacks.onInit === 'function') {
                this.args.callbacks.onInit(this.currentSlide);
              }
            }
      
            if (window.AOS) { AOS.refresh() }
          },
      
          slideChange: function(index) {
            // Outgoing fade styles
            if (this.args.fade && this.currentSlide) {
              this.currentSlide.classList.add(classes.animateOut);
              this.currentSlide.addEventListener('transitionend', function() {
                this.currentSlide.classList.remove(classes.animateOut);
              }.bind(this));
            }
      
            // Match index with child nav
            if (this.args.childNav) {
              this.childNavGoTo(index);
            }
      
            // Optional onChange callback
            if (this.args.callbacks && this.args.callbacks.onChange) {
              if (typeof this.args.callbacks.onChange === 'function') {
                this.args.callbacks.onChange(index);
              }
            }
      
            // Show/hide arrows depending on selected index
            if (this.arrows && this.arrows.length) {
              this.arrows[0].classList.toggle('hide', index === 0);
              this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
            }
          },
          afterChange: function(index) {
            // Remove all fade animation classes after slide is done
            if (this.args.fade) {
              this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
                slide.classList.remove(classes.animateOut);
              });
            }
      
            this.currentSlide = this.el.querySelector(selectors.currentSlide);
      
            // Match index with child nav (in case slider height changed first)
            if (this.args.childNav) {
              this.childNavGoTo(this.slideshow.selectedIndex);
            }
          },
          destroy: function() {
            if (this.args.childNav && this.childNavLinks.length) {
              this.childNavLinks.forEach(a => {
                a.classList.remove(classes.isActive);
              });
            }
      
            this.slideshow.destroy();
          },
          reposition: function() {
            this.slideshow.reposition();
          },
          _togglePause: function() {
            if (this.pauseBtn.classList.contains(classes.isPaused)) {
              this.pauseBtn.classList.remove(classes.isPaused);
              this.slideshow.playPlayer();
            } else {
              this.pauseBtn.classList.add(classes.isPaused);
              this.slideshow.pausePlayer();
            }
          },
          resize: function() {
            this.slideshow.resize();
          },
          play: function() {
            this.slideshow.playPlayer();
          },
          pause: function() {
            this.slideshow.pausePlayer();
          },
          goToSlide: function(i) {
            this.slideshow.select(i);
          },
          setDraggable: function(enable) {
            this.slideshow.options.draggable = enable;
            this.slideshow.updateDraggable();
          },
      
          initChildNav: function() {
            this.childNavLinks[this.args.initialIndex].classList.add('is-active');
      
            // Setup events
            this.childNavLinks.forEach((link, i) => {
              // update data-index because image-set feature may be enabled
              link.setAttribute('data-index', i);
      
              link.addEventListener('click', function(evt) {
                evt.preventDefault();
                this.goToSlide(this.getChildIndex(evt.currentTarget))
              }.bind(this));
              link.addEventListener('focus', function(evt) {
                this.goToSlide(this.getChildIndex(evt.currentTarget))
              }.bind(this));
              link.addEventListener('keydown', function(evt) {
                if (evt.keyCode === 13) {
                  this.goToSlide(this.getChildIndex(evt.currentTarget))
                }
              }.bind(this));
            });
      
            // Setup optional arrows
            if (this.arrows.length) {
              this.arrows.forEach(arrow => {
                arrow.addEventListener('click', this.arrowClick.bind(this));
              });;
            }
          },
      
          getChildIndex: function(target) {
            return parseInt(target.dataset.index);
          },
      
          childNavGoTo: function(index) {
            this.childNavLinks.forEach(a => {
              a.blur();
              a.classList.remove(classes.isActive);
            });
      
            var el = this.childNavLinks[index];
            el.classList.add(classes.isActive);
      
            if (!this.args.childNavScroller) {
              return;
            }
      
            if (this.args.childVertical) {
              var elTop = el.offsetTop;
              this.args.childNavScroller.scrollTop = elTop - 100;
            } else {
              var elLeft = el.offsetLeft;
              this.args.childNavScroller.scrollLeft = elLeft - 100;
            }
          },
      
          arrowClick: function(evt) {
            if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
              this.slideshow.previous();
            } else {
              this.slideshow.next();
            }
          }
        });
      
        return slideshow;
      })();
      
      /*============================================================================
        VariantAvailability
        - Cross out sold out or unavailable variants
        - To disable, use the Variant Picker Block setting
        - Required markup:
          - class=variant-input-wrap to wrap select or button group
          - class=variant-input to wrap button/label
      ==============================================================================*/
      
      theme.VariantAvailability = (function() {
        var classes = {
          disabled: 'disabled'
        };
      
        function availability(args) {
          this.type = args.type;
          this.variantsObject = args.variantsObject;
          this.currentVariantObject = args.currentVariantObject;
          this.container = args.container;
          this.namespace = args.namespace;
      
          this.init();
        }
      
        availability.prototype = Object.assign({}, availability.prototype, {
          init: function() {
            this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));
      
            // Set default state based on current selected variant
            this.setInitialAvailability();
          },
      
          // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
          createAvailableOptionsTree(variants, currentlySelectedValues) {
            // Reduce variant array into option availability tree
            return variants.reduce((options, variant) => {
      
              // Check each option group (e.g. option1, option2, option3) of the variant
              Object.keys(options).forEach(index => {
      
                if (variant[index] === null) return;
      
                let entry = options[index].find(option => option.value === variant[index]);
      
                if (typeof entry === 'undefined') {
                  // If option has yet to be added to the options tree, add it
                  entry = {value: variant[index], soldOut: true}
                  options[index].push(entry);
                }
      
                const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
                const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')
      
                switch (index) {
                  case 'option1':
                    // Option1 inputs should always remain enabled based on all available variants
                    entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                    break;
                  case 'option2':
                    // Option2 inputs should remain enabled based on available variants that match first option group
                    if (currentOption1 && variant['option1'] === currentOption1.value) {
                      entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                    }
                  case 'option3':
                    // Option 3 inputs should remain enabled based on available variants that match first and second option group
                    if (
                      currentOption1 && variant['option1'] === currentOption1.value
                      && currentOption2 && variant['option2'] === currentOption2.value
                    ) {
                      entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                    }
                }
              })
      
              return options;
            }, { option1: [], option2: [], option3: []})
          },
      
          setInitialAvailability: function() {
            this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
              this.disableVariantGroup(group);
            });
      
            const currentlySelectedValues = this.currentVariantObject.options.map((value,index) => {return {value, index: `option${index+1}`}})
            const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);
      
            for (var [option, values] of Object.entries(initialOptions)) {
              this.manageOptionState(option, values);
            }
          },
      
          setAvailability: function(evt) {
      
            const {value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant} = evt.detail;
      
            // Object to hold all options by value.
            // This will be what sets a button/dropdown as
            // sold out or unavailable (not a combo set as purchasable)
            const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)
      
            // Loop through all option levels and send each
            // value w/ args to function that determines to show/hide/enable/disable
            for (var [option, values] of Object.entries(valuesToManage)) {
              this.manageOptionState(option, values, lastSelectedValue);
            }
          },
      
          manageOptionState: function(option, values) {
            var group = this.container.querySelector('.variant-input-wrap[data-index="'+ option +'"]');
      
            // Loop through each option value
            values.forEach(obj => {
              this.enableVariantOption(group, obj);
            });
          },
      
          enableVariantOption: function(group, obj) {
            // Selecting by value so escape it
            var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
      
            if (this.type === 'dropdown') {
              if (obj.soldOut) {
                group.querySelector('option[value="'+ value +'"]').disabled = true;
              } else {
                group.querySelector('option[value="'+ value +'"]').disabled = false;
              }
            } else {
              var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
              var input = buttonGroup.querySelector('input');
              var label = buttonGroup.querySelector('label');
      
              // Variant exists - enable & show variant
              input.classList.remove(classes.disabled);
              label.classList.remove(classes.disabled);
      
              // Variant sold out - cross out option (remains selectable)
              if (obj.soldOut) {
                input.classList.add(classes.disabled);
                label.classList.add(classes.disabled);
              }
            }
          },
      
          disableVariantGroup: function(group) {
            if (this.type === 'dropdown') {
              group.querySelectorAll('option').forEach(option => {
                option.disabled = true;
              });
            } else {
              group.querySelectorAll('input').forEach(input => {
                input.classList.add(classes.disabled);
              });
              group.querySelectorAll('label').forEach(label => {
                label.classList.add(classes.disabled);
              });
            }
          }
      
        });
      
        return availability;
      })();
      
      // Video modal will auto-initialize for any anchor link that points to YouTube
      // MP4 videos must manually be enabled with:
      //   - .product-video-trigger--mp4 (trigger button)
      //   - .product-video-mp4-sound video player element (cloned into modal)
      //     - see media.liquid for example of this
      theme.videoModal = function() {
        var youtubePlayer;
        var vimeoPlayer;
      
        var videoHolderId = 'VideoHolder';
        var selectors = {
          youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
          vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
          mp4Trigger: '.product-video-trigger--mp4',
          mp4Player: '.product-video-mp4-sound'
        };
      
        var youtubeTriggers = document.querySelectorAll(selectors.youtube);
        var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
        var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
      
        if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
          return;
        }
      
        var videoHolderDiv = document.getElementById(videoHolderId);
      
        if (youtubeTriggers.length) {
          theme.LibraryLoader.load('youtubeSdk');
        }
      
        if (vimeoTriggers.length) {
          theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        }
      
        var modal = new theme.Modals('VideoModal', 'video-modal', {
          closeOffContentClick: true,
          bodyOpenClass: ['modal-open', 'video-modal-open'],
          solid: true
        });
      
        youtubeTriggers.forEach(btn => {
          btn.addEventListener('click', triggerYouTubeModal);
        });
      
        vimeoTriggers.forEach(btn => {
          btn.addEventListener('click', triggerVimeoModal);
        });
      
        mp4Triggers.forEach(btn => {
          btn.addEventListener('click', triggerMp4Modal);
        });
      
        document.addEventListener('modalClose.VideoModal', closeVideoModal);
      
        function triggerYouTubeModal(evt) {
          // If not already loaded, treat as normal link
          if (!theme.config.youTubeReady) {
            return;
          }
      
          evt.preventDefault();
          emptyVideoHolder();
      
          modal.open(evt);
      
          var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
          youtubePlayer = new theme.YouTube(
            videoHolderId,
            {
              videoId: videoId,
              style: 'sound',
              events: {
                onReady: onYoutubeReady
              }
            }
          );
        }
      
        function triggerVimeoModal(evt) {
          // If not already loaded, treat as normal link
          if (!theme.config.vimeoReady) {
            return;
          }
      
          evt.preventDefault();
          emptyVideoHolder();
      
          modal.open(evt);
      
          var videoId = evt.currentTarget.dataset.videoId;
          var videoLoop = evt.currentTarget.dataset.videoLoop;
          vimeoPlayer = new theme.VimeoPlayer(
            videoHolderId,
            videoId,
            {
              style: 'sound',
              loop: videoLoop,
            }
          );
        }
      
        function triggerMp4Modal(evt) {
          emptyVideoHolder();
      
          var el = evt.currentTarget;
          var player = el.parentNode.querySelector(selectors.mp4Player);
      
          // Clone video element and place it in the modal
          var playerClone = player.cloneNode(true);
          playerClone.classList.remove('hide');
      
          videoHolderDiv.append(playerClone);
          modal.open(evt);
      
          // Play new video element
          videoHolderDiv.querySelector('video').play();
        }
      
        function onYoutubeReady(evt) {
          evt.target.unMute();
          evt.target.playVideo();
        }
      
        function getYoutubeVideoId(url) {
          var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
          var match = url.match(regExp);
          return (match&&match[7].length==11)? match[7] : false;
        }
      
        function emptyVideoHolder() {
          videoHolderDiv.innerHTML = '';
        }
      
        function closeVideoModal() {
          if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
            youtubePlayer.destroy();
          } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
            vimeoPlayer.destroy();
          } else {
            emptyVideoHolder();
          }
        }
      };
      
      
      /*============================================================================
        ToolTip
      ==============================================================================*/
      
      class ToolTip extends HTMLElement {
        constructor() {
          super();
          this.el = this;
          this.inner = this.querySelector('[data-tool-tip-inner]');
          this.closeButton = this.querySelector('[data-tool-tip-close]');
          this.toolTipContent = this.querySelector('[data-tool-tip-content]');
          this.toolTipTitle = this.querySelector('[data-tool-tip-title]');
      
          this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');
      
          document.addEventListener('tooltip:open', e => {
            this._open(e.detail.context, e.detail.content);
          });
        }
      
        _open(context, insertedHtml) {
          this.toolTipContent.innerHTML = insertedHtml;
      
          // Ensure we set a title for product availability
          if (context != 'store-availability') {
            this.toolTipTitle.remove();
          }
      
          this._lockScrolling();
      
          if (this.closeButton) {
            this.closeButton.on('click' + '.tooltip-close', () => {
              this._close();
            });
          }
      
          document.documentElement.on('click' + '.tooltip-outerclick', event => {
            if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
          });
      
          document.documentElement.on('keydown' + '.tooltip-esc', event => {
            if (event.code === 'Escape') this._close();
          });
      
          this.el.dataset.toolTipOpen = true;
          this.el.dataset.toolTip = context;
        }
      
        _close() {
          this.toolTipContent.innerHTML = '';
          this.el.dataset.toolTipOpen = 'false';
          this.el.dataset.toolTip = '';
      
          this._unlockScrolling();
      
          this.closeButton.off('click' + '.tooltip-close');
          document.documentElement.off('click' + '.tooltip-outerclick');
          document.documentElement.off('keydown' + '.tooltip-esc');
        }
      
        _lockScrolling() {
          theme.a11y.trapFocus({
            container: this.el,
            namespace: 'tooltip_focus'
          });
      
          theme.a11y.lockMobileScrolling();
          document.documentElement.classList.add('modal-open');
        }
      
        _unlockScrolling() {
          theme.a11y.removeTrapFocus({
            container: this.el,
            namespace: 'tooltip_focus'
          });
      
          theme.a11y.unlockMobileScrolling();
          document.documentElement.classList.remove('modal-open');
        }
      }
      
      customElements.define('tool-tip', ToolTip);
      
      /*============================================================================
        ToolTipTrigger
      ==============================================================================*/
      
      class ToolTipTrigger extends HTMLElement {
        constructor() {
          super();
          this.el = this;
          this.toolTipContent = this.querySelector('[data-tool-tip-content]');
          this.init();
        }
      
        init() {
          const toolTipOpen = new CustomEvent('tooltip:open', {
            detail: {
              context: this.dataset.toolTip,
              content: this.toolTipContent.innerHTML
            },
            bubbles: true
          });
      
          this.el.addEventListener('click', e => {
            e.stopPropagation();
            this.dispatchEvent(toolTipOpen);
          });
        }
      }
      
      customElements.define('tool-tip-trigger', ToolTipTrigger);
      
      /*============================================================================
        NewsletterReminder
      ==============================================================================*/
      
      class NewsletterReminder extends HTMLElement {
        constructor() {
          super();
          this.closeBtn = this.querySelector('[data-close-button]');
          this.popupTrigger = this.querySelector('[data-message]');
      
          this.id = this.dataset.sectionId;
          this.newsletterId = `NewsletterPopup-${ this.id }`;
          this.cookie = Cookies.get(`newsletter-${this.id}`);
          this.cookieName = `newsletter-${this.id}`;
          this.secondsBeforeShow = this.dataset.delaySeconds;
          this.expiry = parseInt(this.dataset.delayDays);
          this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');
      
          this.init();
        }
      
        init() {
          document.addEventListener('shopify:block:select', (evt) => {
            if (evt.detail.sectionId === this.id) {
              this.show(0, true)
            }
          });
      
          document.addEventListener('shopify:block:deselect', (evt) => {
            if (evt.detail.sectionId === this.id) {
              this.hide();
            }
          });
      
          document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
          document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
          document.addEventListener(`newsletter:openReminder`, () => this.show(0));
      
          this.closeBtn.addEventListener('click', () => {
            this.hide();
            Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
          });
      
          this.popupTrigger.addEventListener('click', () => {
            const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
            this.dispatchEvent(reminderOpen);
      
            this.hide();
          });
        }
      
        show(time = this.secondsBeforeShow, forceOpen = false) {
          const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
      
          if (!reminderAppeared) {
            setTimeout(() => {
              this.dataset.enabled = 'true';
              sessionStorage.setItem('reminderAppeared', true);
            }, time * 1000);
          }
        }
      
        hide() {
          this.dataset.enabled = 'false';
        }
      }
      
      customElements.define('newsletter-reminder', NewsletterReminder);
      
      /*============================================================================
        ImageElement
      ==============================================================================*/
      
      class ImageElement extends HTMLElement {
        constructor() {
          super();
      
          this.init();
        }
      
        init() {
      
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
      
            this.removeAnimations();
      
            observer.unobserve(this);
          }
      
          // Set an IntersectionObserver to check if the image is nearly in the viewport
          new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
        }
      
        removeAnimations() {
          // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
          const imageWrap = this.closest('.image-wrap');
          const skrimWrap = this.closest('.skrim__link');
      
          if (imageWrap) {
            imageWrap.classList.add('loaded');
          }
      
          if (skrimWrap) {
            skrimWrap.classList.add('loaded');
          }
        }
      }
      
      customElements.define('image-element', ImageElement);
      
      /*============================================================================
        PredictiveSearch
      ==============================================================================*/
      
      class PredictiveSearch extends HTMLElement {
        constructor() {
          super();
          this.enabled = this.getAttribute('data-enabled');
          this.context = this.getAttribute('data-context');
          this.input = this.querySelector('input[type="search"]');
          this.predictiveSearchResults = this.querySelector('#predictive-search');
          this.closeBtn = this.querySelector('.btn--close-search');
          this.screen = this.querySelector('[data-screen]');
          this.SearchModal = this.closest('#SearchModal') || null;
      
          // Open events
          document.addEventListener('predictive-search:open', e => {
            if (e.detail.context !== this.context) return;
            this.classList.add('is-active');
      
            // Wait for opening events to finish then apply focus
            setTimeout(() => { this.input.focus(); }, 100);
      
            document.body.classList.add('predictive-overflow-hidden');
          });
      
          // listen for class change of 'modal--is-active on this.SearchModal
          if (this.SearchModal) {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                  const modalClass = mutation.target.className;
                  if (modalClass.indexOf('modal--is-active') > -1) {
                    setTimeout(() => { this.input.focus(); }, 100);
                  }
                }
              });
            });
      
            observer.observe(this.SearchModal, {
              attributes: true
            });
          }
      
          if (this.enabled === 'false') return;
      
          // On typing
          this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });
      
          this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
          }, 300).bind(this));
      
          // Close events
          document.addEventListener('predictive-search:close', () => { this.close(); });
          document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
          this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
          this.screen.addEventListener('click', () => { this.close(); });
        }
      
        onChange() {
          const searchTerm = this.input.value.trim();
      
          if (!searchTerm.length) return;
      
          this.getSearchResults(searchTerm);
        }
      
        getSearchResults(searchTerm) {
          const searchObj = {
            'q': searchTerm,
            'resources[limit]': 3,
            'resources[limit_scope]': 'each',
            'resources[options][unavailable_products]': 'last'
          };
      
          const params = this.paramUrl(searchObj);
      
          fetch(`${theme.routes.predictiveSearch}?${params}&section_id=search-results`)
            .then((response) => {
              if (!response.ok) {
                const error = new Error(response.status);
                this.close();
                throw error;
              }
      
              return response.text();
            })
            .then((text) => {
              const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
              this.predictiveSearchResults.innerHTML = resultsMarkup;
              this.open();
      
              AOS.refreshHard();
            })
            .catch((error) => {
              this.close();
              throw error;
            });
        }
      
        open() {
          this.predictiveSearchResults.style.display = 'block';
        }
      
        close() {
          this.predictiveSearchResults.style.display = 'none';
          this.predictiveSearchResults.innerHTML = '';
          this.classList.remove('is-active');
          document.body.classList.remove('predictive-overflow-hidden');
      
          document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
        }
      
        debounce(fn, wait) {
          let t;
          return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
          };
        }
      
        paramUrl(obj) {
          return Object.keys(obj).map(function(key) {
            return key + '=' + encodeURIComponent(obj[key]);
          }).join('&')
        }
      }
      
      customElements.define('predictive-search', PredictiveSearch);
      
      class RecipientForm extends HTMLElement {
        constructor() {
          super();
          this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${ this.dataset.sectionId }`);
          this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
          this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
          this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
          this.dateInput = this.querySelector(`#Recipient-send-on-${ this.dataset.sectionId }`);
          this.addEventListener('change', () => this.onChange());
          this.recipientFields = this.querySelector('.recipient-fields');
      
          this.checkboxInput.addEventListener('change', () => {
            this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none';
          });
        }
      
        connectedCallback() {
          document.addEventListener('ajaxProduct:error', (event) => {
            const productVariantID = event.target.querySelector('[name="id"]').value;
            if (productVariantID === this.dataset.productVariantId) {
              this.displayErrorMessage(event.detail.errorMessage);
            }
          });
      
          document.addEventListener('ajaxProduct:added', (event) => {
            const productVariantID = event.target.querySelector('[name="id"]').value;
            if (productVariantID === this.dataset.productVariantId) {
              this.clearInputFields();
              this.clearErrorMessage();
            }
          });
        }
      
        onChange() {
          if (!this.checkboxInput.checked) {
            this.clearInputFields();
            this.clearErrorMessage();
          }
        }
      
        clearInputFields() {
          this.querySelectorAll('.field__input').forEach(el => el.value = '');
        }
      
        displayErrorMessage(body) {
          this.clearErrorMessage();
          if (body) {
            return Object.entries(body).forEach(([key, value]) => {
              const inputElement = this[`${key}Input`];
              if (!inputElement) return;
      
              inputElement.setAttribute('aria-invalid', true);
              inputElement.classList.add('field__input--error');
            });
          }
        }
      
        clearErrorMessage() {
          this.querySelectorAll('.field__input').forEach(inputElement => {
            inputElement.setAttribute('aria-invalid', false);
            inputElement.removeAttribute('aria-describedby');
            inputElement.classList.remove('field__input--error');
          });
        }
      };
      
      customElements.define('recipient-form', RecipientForm);
      
    
      theme.announcementBar = (function() {
        var args = {
          autoPlay: 5000,
          avoidReflow: true,
          cellAlign: theme.config.rtl ? 'right' : 'left'
        };
        var bar;
        var flickity;
      
        function init() {
          bar = document.getElementById('AnnouncementSlider');
          if (!bar) {
            return;
          }
      
          unload();
      
          if (bar.dataset.blockCount === 1) {
            return;
          }
      
          if (theme.config.bpSmall || bar.dataset.compact === 'true') {
            initSlider();
          }
      
          document.addEventListener('matchSmall', function() {
            unload();
            initSlider();
          });
      
          document.addEventListener('unmatchSmall', function() {
            unload();
            if (bar.dataset.compact === 'true') {
              initSlider();
            }
          });
        }
      
        function initSlider() {
          flickity = new theme.Slideshow(bar, args);
        }
      
        // Go to slide if selected in the editor
        function onBlockSelect(id) {
          var slide = bar.querySelector('#AnnouncementSlide-' + id);
          var index = parseInt(slide.dataset.index);
      
          if (flickity && typeof flickity.pause === 'function') {
            flickity.goToSlide(index);
            flickity.pause();
          }
        }
      
        function onBlockDeselect() {
          if (flickity && typeof flickity.play === 'function') {
            flickity.play();
          }
        }
      
        function unload() {
          if (flickity && typeof flickity.destroy === 'function') {
            flickity.destroy();
          }
        }
      
        return {
          init: init,
          onBlockSelect: onBlockSelect,
          onBlockDeselect: onBlockDeselect,
          unload: unload
        };
      })();
      
      theme.customerTemplates = function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      
        function checkUrlHash() {
          var hash = window.location.hash;
      
          // Allow deep linking to recover password form
          if (hash === '#recover') {
            toggleRecoverPasswordForm();
          }
        }
      
        function toggleRecoverPasswordForm() {
          var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
          var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
        }
      
        function initEventListeners() {
          // Show reset password form
          var recoverForm = document.getElementById('RecoverPassword');
          if (recoverForm) {
            recoverForm.addEventListener('click', function(evt) {
              evt.preventDefault();
              toggleRecoverPasswordForm();
            });
          }
      
          // Hide reset password form
          var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
          if (hideRecoverPassword) {
            hideRecoverPassword.addEventListener('click', function(evt) {
              evt.preventDefault();
              toggleRecoverPasswordForm();
            });
          }
        }
      
        function resetPasswordSuccess() {
          var formState = document.querySelector('.reset-password-success');
      
          // check if reset password form was successfully submitted
          if (!formState) {
            return;
          }
      
          // show success message
          document.getElementById('ResetSuccess').classList.remove('hide');
        }
      
        function customerAddressForm() {
          var newAddressForm = document.getElementById('AddressNewForm');
          var addressForms = document.querySelectorAll('.js-address-form');
      
          if (!newAddressForm || !addressForms.length) {
            return;
          }
      
          // Country/province selector can take a short time to load
          setTimeout(function() {
            document.querySelectorAll('.js-address-country').forEach(el => {
              var countryId = el.dataset.countryId;
              var provinceId = el.dataset.provinceId;
              var provinceContainerId = el.dataset.provinceContainerId;
      
              new Shopify.CountryProvinceSelector(
                countryId,
                provinceId,
                {
                  hideElement: provinceContainerId
                }
              );
            });
          }, 1000);
      
          // Toggle new/edit address forms
          document.querySelectorAll('.address-new-toggle').forEach(el => {
            el.addEventListener('click', function() {
              newAddressForm.classList.toggle('hide');
            });
          });
      
          document.querySelectorAll('.address-edit-toggle').forEach(el => {
            el.addEventListener('click', function(evt) {
              var formId = evt.currentTarget.dataset.formId;
              document.getElementById('EditAddress_' + formId).classList.toggle('hide');
            });
          });
      
          document.querySelectorAll('.address-delete').forEach(el => {
            el.addEventListener('click', function(evt) {
              var formId = evt.currentTarget.dataset.formId;
              var confirmMessage = evt.currentTarget.dataset.confirmMessage;
      
              if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                if (Shopify) {
                  Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
                }
              }
            })
          });
        }
      };
      
      theme.CartDrawer = (function() {
        var selectors = {
          drawer: '#CartDrawer',
          form: '#CartDrawerForm'
        };
      
        function CartDrawer() {
          this.form = document.querySelector(selectors.form);
          this.drawer = new theme.Drawers('CartDrawer', 'cart');
      
          this.init();
        }
      
        CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
          init: function() {
            this.cartForm = new theme.CartForm(this.form);
            this.cartForm.buildCart();
      
            document.addEventListener('ajaxProduct:added', function(evt) {
              this.cartForm.buildCart();
              this.open();
            }.bind(this));
      
            // Dev-friendly way to open cart
            document.addEventListener('cart:open', this.open.bind(this));
            document.addEventListener('cart:close', this.close.bind(this));
          },
      
          open: function() {
            this.drawer.open();
      
            theme.a11y.trapFocus({
              container: this.form,
              elementToFocus: this.form,
              namespace: 'cartdrawer_focus'
            });
          },
      
          close: function() {
            this.drawer.close();
      
            theme.a11y.removeTrapFocus({
              container: this.form,
              namespace: 'cartdrawer_focus'
            });
          }
        });
      
        return CartDrawer;
      })();
      
      theme.headerNav = (function() {
        var selectors = {
          wrapper: '#HeaderWrapper',
          siteHeader: '#SiteHeader',
          searchBtn: '.js-search-header',
          closeSearch: '#SearchClose',
          searchContainer: '.site-header__search-container',
          logo: '#LogoContainer img',
          megamenu: '.megamenu',
          navItems: '.site-nav__item',
          navLinks: '.site-nav__link',
          navLinksWithDropdown: '.site-nav__link--has-dropdown',
          navDropdownLinks: '.site-nav__dropdown-link--second-level',
          navDetails: '.site-nav__details',
        };
      
        var classes = {
          hasDropdownClass: 'site-nav--has-dropdown',
          hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
          dropdownActive: 'is-focused'
        };
      
        var config = {
          namespace: '.siteNav',
          wrapperOverlayed: false,
          overlayedClass: 'is-light',
          overlayEnabledClass: 'header-wrapper--sticky',
          stickyEnabled: false,
          stickyActive: false,
          stickyClass: 'site-header--stuck',
          stickyHeaderWrapper: 'StickyHeaderWrap',
          openTransitionClass: 'site-header--opening',
          lastScroll: 0
        };
      
        // Elements used in resize functions, defined in init
        var wrapper;
        var siteHeader;
      
        function init() {
          wrapper = document.querySelector(selectors.wrapper);
          siteHeader = document.querySelector(selectors.siteHeader);
      
          config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
          if (config.stickyEnabled) {
            config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
            stickyHeaderCheck();
          }
      
          theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
          // Disable overlay header if on collection template with no collection image
          if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
            if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
              this.disableOverlayHeader();
            }
          }
      
          menuDetailsHandler();
          searchDrawer();
        }
      
        function menuDetailsHandler() {
          const navDetails = document.querySelectorAll(selectors.navDetails);
      
          navDetails.forEach((navDetail) => {
            const summary = navDetail.querySelector('summary');
      
            // if the navDetail is open, then close it when the user clicks outside of it
            document.addEventListener('click', (evt) => {
              if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
                navDetail.removeAttribute('open');
                summary.setAttribute('aria-expanded', 'false');
              } else {
                if (navDetail.hasAttribute('open')) {
                  summary.setAttribute('aria-expanded', 'false');
                } else {
                  summary.setAttribute('aria-expanded', 'true');
                }
              }
            });
          });
        }
      
        // If the header setting to overlay the menu on the collection image
        // is enabled but the collection setting is disabled, we need to undo
        // the init of the sticky nav
        function disableOverlayHeader() {
          wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
          config.wrapperOverlayed = false;
          theme.settings.overlayHeader = false;
        }
      
        function stickyHeaderCheck() {
          // Disable sticky header if any mega menu is taller than window
          theme.config.stickyHeader = doesMegaMenuFit();
      
          if (theme.config.stickyHeader) {
            config.forceStopSticky = false;
            stickyHeader();
          } else {
            config.forceStopSticky = true;
          }
        }
      
        function doesMegaMenuFit() {
          var largestMegaNav = 0;
          siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
            var h = nav.offsetHeight;
            if (h > largestMegaNav) {
              largestMegaNav = h;
            }
          });
      
          // 120 ~ space of visible header when megamenu open
          if (window.innerHeight < (largestMegaNav + 120)) {
            return false;
          }
      
          return true;
        }
      
        function stickyHeader() {
          config.lastScroll = 0;
      
          var wrapWith = document.createElement('div');
          wrapWith.id = config.stickyHeaderWrapper;
          theme.utils.wrap(siteHeader, wrapWith);
      
          stickyHeaderInitialPosition(siteHeader);
          stickyHeaderHeight();
      
          window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
          window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));
      
          // This gets messed up in the editor, so here's a fix
          if (Shopify && Shopify.designMode) {
            setTimeout(function() {
              stickyHeaderHeight();
            }, 250);
          }
        }
      
        function stickyHeaderInitialPosition(header) {
          const headerParent = header.closest('.shopify-section-group-header-group');
          const parentNextSibling = headerParent.nextElementSibling;
      
          // if parentNextSibling has same class as headerParent, then header is above announcement bar
          if (parentNextSibling && parentNextSibling.classList.contains('shopify-section-group-header-group')) {
            // get height of announcement bar and set header wrapper top to that value
            const nextSiblingHeight = parentNextSibling.offsetHeight;
            document.querySelector(selectors.wrapper).style.top = nextSiblingHeight + 'px';
          }
        }
      
        function stickyHeaderHeight() {
          if (!config.stickyEnabled) {
            return;
          }
      
          var h = siteHeader.offsetHeight;
      
          // If sticky header is 'active' i.e. we have scrolled a bit down the page
          // the site header has 20px less padding when sticky
          // and this is not factored into the height calculation
          // The 20px is what causes the header to overlap the announcement bar
          // This only applies when the height is being calculated on larger screen sizes
          if (siteHeader.classList.contains('site-header--stuck') && !theme.config.bpSmall) {
            let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
            h += siteHeaderPadding * 2;
          }
      
          var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
          stickyHeader.style.height = h + 'px';
        }
      
        function stickyHeaderScroll() {
          if (!config.stickyEnabled) {
            return;
          }
      
          if (config.forceStopSticky) {
            return;
          }
      
          requestAnimationFrame(scrollHandler);
      
          config.lastScroll = window.scrollY;
        }
      
        function scrollHandler() {
          if (window.scrollY > 250) {
            if (config.stickyActive) {
              return;
            }
      
            config.stickyActive = true;
      
            siteHeader.classList.add(config.stickyClass);
            if (config.wrapperOverlayed) {
              wrapper.classList.remove(config.overlayedClass);
            }
      
            // Add open transition class after element is set to fixed
            // so CSS animation is applied correctly
            setTimeout(function() {
              siteHeader.classList.add(config.openTransitionClass);
            }, 100);
          } else {
            if (!config.stickyActive) {
              return;
            }
      
            config.stickyActive = false;
      
            siteHeader.classList.remove(config.openTransitionClass);
            siteHeader.classList.remove(config.stickyClass);
            if (config.wrapperOverlayed) {
              wrapper.classList.add(config.overlayedClass);
            }
          }
        }
      
        function searchDrawer() {
          document.querySelectorAll(selectors.searchBtn).forEach(btn => {
            btn.addEventListener('click', function(evt) {
              evt.preventDefault();
              evt.stopPropagation();
              document.dispatchEvent(new CustomEvent('predictive-search:open', {
                detail: {
                  context: 'header'
                },
                bubbles: true
              }));
      
              // add is-active class to .site-header__search-container
              document.querySelector(selectors.searchContainer).classList.add('is-active');
            });
          });
      
          document.addEventListener('predictive-search:close-all', function() {
            closeSearchDrawer();
          });
        }
      
        function closeSearchDrawer(evt) {
          // Do not close if click event came from inside drawer
          if (evt) {
            // evt.path is non-standard, so have fallback
            var path = evt.path || (evt.composedPath && evt.composedPath());
            for (var i = 0; i < path.length; i++) {
              if (path[i].classList) {
                if (path[i].classList.contains('site-header__search-btn')) {
                  break;
                }
      
                if (path[i].classList.contains('site-header__search-container')) {
                  return;
                }
              }
            }
          }
      
          // deselect any focused form elements
          document.activeElement.blur();
      
          document.documentElement.classList.add('js-drawer-closing');
          document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
      
          window.setTimeout(function() {
            document.documentElement.classList.remove('js-drawer-closing');
          }.bind(this), 500);
      
          var container = document.querySelector(selectors.searchContainer);
          theme.utils.prepareTransition(container, function() {
            container.classList.remove('is-active');
          }.bind(this));
        }
      
        return {
          init: init,
          disableOverlayHeader: disableOverlayHeader
        };
      })();
      
      window.onpageshow = function(evt) {
        // Removes unload class when returning to page via history
        if (evt.persisted) {
          document.body.classList.remove('unloading');
          document.querySelectorAll('.cart__checkout').forEach(el => {
            el.classList.remove('btn--loading');
          });
        }
      };
      
      theme.buildProductGridItem = function(items, gridWidth, rowOf, imageSizes) {
        var output = '';
      
        items.forEach(product => {
          var image = theme.buildProductImage(product, imageSizes);
      
          let priceMarkup = '';
          let vendorMarkup = '';
      
          if (theme.settings.predictiveSearchPrice) priceMarkup = `<div class="grid-product__price">${theme.strings.productFrom}${theme.Currency.formatMoney(product.price_min, theme.moneyFormat)}</div>`;
          if (theme.settings.predictiveSearchVendor) vendorMarkup = `<div class="grid-product__vendor">${product.vendor}</div>`;
      
          var markup = `
            <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
              <div class="grid-product__content">
                <a href="${product.url}" class="grid-product__link">
                  <div class="grid-product__image-mask">
                    ${image}
                  </div>
                  <div class="grid-product__meta">
                    <div class="grid-product__title">${product.title}</div>
                    ${priceMarkup}
                    ${vendorMarkup}
                  </div>
                </a>
              </div>
            </div>
          `;
      
          output += markup;
        });
      
        return output;
      }
      
      theme.buildProductImage = function(product, imageSizes) {
        var size = theme.settings.productImageSize;
        var output = '';
      
        if (size === 'natural') {
          const template = document.getElementById("naturalImageMarkup");
          const clonedMarkup = template.content.cloneNode(true);
          const imageEl = clonedMarkup.querySelector('img');
          const imageWrapperEl = clonedMarkup.querySelector('.image-wrap');
      
          imageWrapperEl.style.paddingBottom = `${product.image_aspect_ratio}%`;
      
          addImageProperties(imageEl, imageSizes);
      
          const imageDiv = document.createElement('div');
          imageDiv.appendChild(clonedMarkup);
      
          output = imageDiv.innerHTML;
        } else {
          const template = document.getElementById("fixedRatioImageMarkup");
          const clonedMarkup = template.content.cloneNode(true);
          const imageEl = clonedMarkup.querySelector('img');
          const imageWrapperEl = clonedMarkup.querySelector('.grid__image-ratio');
      
          imageWrapperEl.classList.add(`grid__image-ratio--${size}`);
      
          if (!theme.settings.productImageCover) {
            imageEl.classList.add('grid__image-contain');
          }
      
          addImageProperties(imageEl, imageSizes);
      
          const imageDiv = document.createElement('div');
          imageDiv.appendChild(clonedMarkup);
      
          output = imageDiv.innerHTML;
        }
      
        function addImageProperties(imageEl, imageSizes) {
          imageEl.src = product.image_responsive_url;
          imageEl.srcset = product.image_responsive_urls.toString();
          imageEl.alt = product.title;
          imageEl.sizes = imageSizes;
        }
      
        return output;
      }
      
    
      /*============================================================================
        Age Verification Popup
      ==============================================================================*/
      
      class AgeVerificationPopup extends HTMLElement {
        constructor() {
          super();
      
          this.cookieName = this.id;
          this.cookie = Cookies.get(this.cookieName);
      
          this.classes = {
            activeContent: 'age-verification-popup__content--active',
            inactiveContent: 'age-verification-popup__content--inactive',
            inactiveDeclineContent: 'age-verification-popup__decline-content--inactive',
            activeDeclineContent: 'age-verification-popup__decline-content--active',
          }
      
          this.declineButton = this.querySelector('[data-age-verification-popup-decline-button]');
          this.declineContent = this.querySelector('[data-age-verification-popup-decline-content]');
          this.content = this.querySelector('[data-age-verification-popup-content]');
          this.returnButton = this.querySelector('[data-age-verification-popup-return-button]');
          this.exitButton = this.querySelector('[data-age-verification-popup-exit-button]');
          this.backgroundImage = this.querySelector('[data-background-image]');
          this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');
      
          if (Shopify.designMode) {
            document.addEventListener('shopify:section:select', (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) {
                this.init();
              }
            })
      
            document.addEventListener('shopify:section:load', (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) {
                this.init();
      
                // If 'Test mode' is enabled, remove the cookie we've set
                if (this.dataset.testMode === 'true' && this.cookie) {
                  Cookies.remove(this.cookieName);
                }
      
                // Check session storage if user was editing on the second view
                const secondViewVisited = sessionStorage.getItem(this.id);
      
                if (!secondViewVisited) return;
      
                this.showDeclineContent();
              }
            })
      
            document.addEventListener('shopify:section:unload', (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) {
                this.modal.close();
              }
            })
          }
      
          // Age verification popup will only be hidden if test mode is disabled AND
          // either a cookie exists OR visibility is toggled in the editor
          if ((this.cookie) && this.dataset.testMode === 'false') return;
      
          this.init();
        }
      
        init() {
          this.modal = new theme.Modals(this.id, 'age-verification-popup-modal', {
            closeOffContentClick: false
          });
      
          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'block';
          }
      
          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'block';
          }
      
          this.modal.open();
      
          theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
      
          if (this.declineButton) {
            this.declineButton.addEventListener('click', (e) => {
              e.preventDefault();
              this.showDeclineContent();
      
              // If in editor, save to session storage to indicate that user has moved on to the second view
              // Allows view to persist while making changes in the editor
              if (Shopify.designMode) {
                sessionStorage.setItem(this.id, 'second-view');
              }
            });
          }
      
          if (this.returnButton) {
            this.returnButton.addEventListener('click', (e) => {
              e.preventDefault();
              this.hideDeclineContent();
      
              // Remove data from session storage so second view doesn't persist
              const secondViewVisited = sessionStorage.getItem(this.id);
      
              if (Shopify.designMode && secondViewVisited) {
                sessionStorage.removeItem(this.id);
              }
            })
          }
      
          if (this.exitButton) {
            this.exitButton.addEventListener('click', (e) => {
              e.preventDefault();
      
              // We don't want to set a cookie if in test mode
              if (this.dataset.testMode === 'false') {
                Cookies.set(this.cookieName, 'entered', { expires: 30, sameSite: 'none', secure: true });
              }
      
              if (this.backgroundImage) {
                this.backgroundImage.style.display = 'none';
              }
      
              if (theme.config.bpSmall && this.mobileBackgroundImage) {
                this.mobileBackgroundImage.style.display = 'none';
              }
      
              this.modal.close();
      
              theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
            })
          }
        }
      
        showDeclineContent() {
          this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
          this.declineContent.classList.add(this.classes.activeDeclineContent);
      
          this.content.classList.add(this.classes.inactiveContent);
          this.content.classList.remove(this.classes.activeContent);
        }
      
        hideDeclineContent() {
          this.declineContent.classList.add(this.classes.inactiveDeclineContent);
          this.declineContent.classList.remove(this.classes.activeDeclineContent);
      
          this.content.classList.remove(this.classes.inactiveContent);
          this.content.classList.add(this.classes.activeContent);
        }
      }
      
      customElements.define('age-verification-popup', AgeVerificationPopup);
      
      
      
      theme.Maps = (function() {
        var config = {
          zoom: 14
        };
        var apiStatus = null;
        var mapsToLoad = [];
      
        var errors = {};
      
        var selectors = {
          section: '[data-section-type="map"]',
          map: '[data-map]',
          mapOverlay: '.map-section__overlay'
        };
      
        // Global function called by Google on auth errors.
        // Show an auto error message on all map instances.
        window.gm_authFailure = function() {
          if (!Shopify.designMode) {
            return;
          }
      
          document.querySelectorAll(selectors.section).forEach(section => {
            section.classList.add('map-section--load-error');
          });
      
          document.querySelectorAll(selectors.map).forEach(map => {
            map.parentNode.removeChild(map);
          });
      
          window.mapError(theme.strings.authError);
        };
      
        window.mapError = function(error) {
          var message = document.createElement('div');
          message.classList.add('map-section__error', 'errors', 'text-center');
          message.innerHTML = error;
          document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
            overlay.parentNode.prepend(message);
          });
          document.querySelectorAll('.map-section__link').forEach(link => {
            link.classList.add('hide');
          });
        };
      
        function Map(container) {
          this.container = container;
          this.sectionId = this.container.getAttribute('data-section-id');
          this.namespace = '.map-' + this.sectionId;
          this.map = container.querySelector(selectors.map);
          this.key = this.map.dataset.apiKey;
      
          errors = {
            addressNoResults: theme.strings.addressNoResults,
            addressQueryLimit: theme.strings.addressQueryLimit,
            addressError: theme.strings.addressError,
            authError: theme.strings.authError
          };
      
          if (!this.key) {
            return;
          }
      
          theme.initWhenVisible({
            element: this.container,
            callback: this.prepMapApi.bind(this),
            threshold: 20
          });
        }
      
        // API has loaded, load all Map instances in queue
        function initAllMaps() {
          mapsToLoad.forEach(instance => {
            instance.createMap();
          });
        }
      
        function geolocate(map) {
          var geocoder = new google.maps.Geocoder();
      
          if (!map) {
            return;
          }
      
          var address = map.dataset.addressSetting;
      
          var deferred = new Promise((resolve, reject) => {
            geocoder.geocode({ address: address }, function(results, status) {
              if (status !== google.maps.GeocoderStatus.OK) {
                reject(status);
              }
              resolve(results);
            });
          });
      
          return deferred;
        }
      
        Map.prototype = Object.assign({}, Map.prototype, {
          prepMapApi: function() {
            if (apiStatus === 'loaded') {
              this.createMap();
            } else {
              mapsToLoad.push(this);
      
              if (apiStatus !== 'loading') {
                apiStatus = 'loading';
                if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
      
                  var script = document.createElement('script');
                  script.onload = function () {
                    apiStatus = 'loaded';
                    initAllMaps();
                  };
                  script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
                  document.head.appendChild(script);
                }
              }
            }
          },
      
          createMap: function() {
            var mapDiv = this.map;
      
            return geolocate(mapDiv)
              .then(
                function(results) {
                  var mapOptions = {
                    zoom: config.zoom,
                    backgroundColor: 'none',
                    center: results[0].geometry.location,
                    draggable: false,
                    clickableIcons: false,
                    scrollwheel: false,
                    disableDoubleClickZoom: true,
                    disableDefaultUI: true
                  };
      
                  var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
                  var center = (this.center = map.getCenter());
      
                  var marker = new google.maps.Marker({
                    map: map,
                    position: map.getCenter()
                  });
      
                  google.maps.event.addDomListener(
                    window,
                    'resize',
                    theme.utils.debounce(250, function() {
                      google.maps.event.trigger(map, 'resize');
                      map.setCenter(center);
                      mapDiv.removeAttribute('style');
                    })
                  );
      
                  if (Shopify.designMode) {
                    if (window.AOS) { AOS.refreshHard() }
                  }
                }.bind(this)
              )
              .catch(function(status) {
                var errorMessage;
      
                switch (status) {
                  case 'ZERO_RESULTS':
                    errorMessage = errors.addressNoResults;
                    break;
                  case 'OVER_QUERY_LIMIT':
                    errorMessage = errors.addressQueryLimit;
                    break;
                  case 'REQUEST_DENIED':
                    errorMessage = errors.authError;
                    break;
                  default:
                    errorMessage = errors.addressError;
                    break;
                }
      
                // Show errors only to merchant in the editor.
                if (Shopify.designMode) {
                  window.mapError(errorMessage);
                }
              });
          },
      
          onUnload: function() {
            if (this.map.length === 0) {
              return;
            }
            // Causes a harmless JS error when a section without an active map is reloaded
            if (google && google.maps && google.maps.event) {
              google.maps.event.clearListeners(this.map, 'resize');
            }
          }
        });
      
        return Map;
      })();
      
      theme.NewsletterPopup = (function () {
        function NewsletterPopup(container) {
          this.container = container;
          var sectionId = this.container.getAttribute('data-section-id');
      
          this.cookieName = 'newsletter-' + sectionId;
          this.cookie = Cookies.get(this.cookieName);
      
          if (!container) {
            return;
          }
      
          // Prevent popup on Shopify robot challenge page
          if (window.location.pathname === '/challenge') {
            return;
          }
      
          // Prevent popup on password page
          if (window.location.pathname === '/password') {
            return;
          }
      
          this.data = {
            secondsBeforeShow: container.dataset.delaySeconds,
            daysBeforeReappear: container.dataset.delayDays,
            hasReminder: container.dataset.hasReminder,
            testMode: container.dataset.testMode
          };
      
          this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
      
          // Set cookie if optional button is clicked
          var btn = container.querySelector('.popup-cta a');
          if (btn) {
            btn.addEventListener('click', function () {
              this.closePopup(true);
            }.bind(this));
          }
      
          // Open modal if errors or success message exist
          if (container.querySelector('.errors') || container.querySelector('.note--success')) {
            this.modal.open();
          }
      
          // Set cookie as opened if success message
          if (container.querySelector('.note--success')) {
            this.closePopup(true);
            return;
          }
      
          document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
      
          if (!this.cookie) {
            this.initPopupDelay();
          }
      
          // Open modal if triggered by newsletter reminder
          document.addEventListener('reminder:openNewsletter', () => {
            this.modal.open();
          });
        }
      
        NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
          initPopupDelay: function () {
            if (this.data.testMode === 'true') {
              return;
            }
            setTimeout(function () {
              const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
              if (newsletterAppeared) {
                const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
                this.container.dispatchEvent(openReminder);
              } else {
                this.modal.open();
                sessionStorage.setItem('newsletterAppeared', true);
              }
      
            }.bind(this), this.data.secondsBeforeShow * 1000);
          },
      
          closePopup: function (success) {
            // Remove a cookie in case it was set in test mode
            if (this.data.testMode === 'true') {
              Cookies.remove(this.cookieName, { path: '/' });
              return;
            }
      
            var expiry = success ? 200 : this.data.daysBeforeReappear;
            var hasReminder = (this.data.hasReminder === 'true');
            var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
      
            if (hasReminder && reminderAppeared) {
              Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
            } else if(!hasReminder) {
              Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
            }
          },
      
          onLoad: function () {
            this.modal.open();
          },
      
          onSelect: function () {
            this.modal.open();
          },
      
          onDeselect: function () {
            this.modal.close();
          },
      
          onBlockSelect: function () {
            this.modal.close();
          },
      
          onBlockDeselect: function () {
            this.modal.open();
          },
      
          onUnload: function() {
            this.modal.close();
          }
        });
      
        return NewsletterPopup;
      })();
      
      theme.PasswordHeader = (function() {
        function PasswordHeader() {
          this.init();
        }
      
        PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
          init: function() {
            if (!document.querySelector('#LoginModal')) {
              return;
            }
      
            var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
              focusIdOnOpen: 'password',
              solid: true
            });
      
            // Open modal if errors exist
            if (document.querySelectorAll('.errors').length) {
              passwordModal.open();
            }
          }
        });
      
        return PasswordHeader;
      })();
      
      theme.Photoswipe = (function() {
        var selectors = {
          trigger: '.js-photoswipe__zoom',
          images: '.photoswipe__image',
          slideshowTrack: '.flickity-viewport ',
          activeImage: '.is-selected'
        };
      
        function Photoswipe(container, sectionId) {
          this.container = container;
          this.sectionId = sectionId;
          this.namespace = '.photoswipe-' + this.sectionId;
          this.gallery;
          this.images;
          this.items;
          this.inSlideshow = false;
      
          if (!container || container.dataset.zoom === 'false') {
            return;
          }
      
          this.init();
        }
      
        Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
          init: function() {
            this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
              trigger.on('click' + this.namespace, this.triggerClick.bind(this));
            });
          },
      
          triggerClick: function(evt) {
            // Streamline changes between a slideshow and
            // stacked images, so recheck if we are still
            // working with a slideshow when initializing zoom
            if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
              this.inSlideshow = true;
            } else {
              this.inSlideshow = false;
            }
      
            this.items = this.getImageData();
      
            var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;
      
            var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
      
            this.initGallery(this.items, index);
          },
      
          // Because of image set feature, need to get index based on location in parent
          getChildIndex: function(el) {
            var i = 0;
            while( (el = el.previousSibling) != null ) {
              i++;
            }
      
            // 1-based index required
            return i + 1;
          },
      
          getImageData: function() {
            this.images = this.inSlideshow
                            ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
                            : this.container.querySelectorAll(selectors.images);
      
            var items = [];
            var options = {};
      
            this.images.forEach(el => {
              var item = {
                msrc: el.currentSrc || el.src,
                src: el.getAttribute('data-photoswipe-src'),
                w: el.getAttribute('data-photoswipe-width'),
                h: el.getAttribute('data-photoswipe-height'),
                el: el,
                initialZoomLevel: 0.5
              }
      
              items.push(item);
            });
      
            return items;
          },
      
          initGallery: function(items, index) {
            var pswpElement = document.querySelectorAll('.pswp')[0];
      
            var options = {
              allowPanToNext: false,
              captionEl: false,
              closeOnScroll: false,
              counterEl: false,
              history: false,
              index: index - 1,
              pinchToClose: false,
              preloaderEl: false,
              scaleMode: 'zoom',
              shareEl: false,
              tapToToggleControls: false,
              getThumbBoundsFn: function(index) {
                var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                var thumbnail = items[index].el;
                var rect = thumbnail.getBoundingClientRect();
                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
              }
            }
      
            this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            this.gallery.listen('afterChange', this.afterChange.bind(this));
            this.gallery.init();
      
            this.preventiOS15Scrolling();
          },
      
          afterChange: function() {
            var index = this.gallery.getCurrentIndex();
            this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
              detail: {
                index: index
              }
            }));
          },
      
          syncHeight: function() {
            document.documentElement.style.setProperty(
              "--window-inner-height", 
              `${window.innerHeight}px`
            );
          },
      
          // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
          preventiOS15Scrolling: function() {
            let initialScrollPos;
      
            if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return; 
            
            this.syncHeight();
                  
            // Store scroll position to restore it later
            initialScrollPos = window.scrollY;
            
            // Add class to root element when PhotoSwipe opens
            document.documentElement.classList.add('pswp-open-in-ios');
      
            window.addEventListener('resize', this.syncHeight);
          
            this.gallery.listen('destroy', () => {
              document.documentElement.classList.remove('pswp-open-in-ios');
              window.scrollTo(0, initialScrollPos);
            });
          }
        });
      
        return Photoswipe;
      })();
      
      
      /*============================================================================
        ProductRecommendations
      ==============================================================================*/
      
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();
          this.el = this;
          this.url = this.dataset.url;
          this.intent = this.dataset.intent;
          this.placeholder = this.querySelector('.product-recommendations-placeholder');
          this.productResults =  this.querySelector('.grid-product');
          this.sectionId = this.dataset.sectionId;
          this.blockId = this.dataset.blockId;
      
          document.addEventListener('recommendations:loaded', (e) => {
            this.colorImages = this.el.querySelectorAll('.grid-product__color-image');
            if (this.colorImages.length) {
              this.swatches = this.el.querySelectorAll('.color-swatch--with-image');
              this.colorSwatchHovering();
            }
          });
        }
      
        connectedCallback() {
          fetch(this.url)
            .then(response => response.text())
            .then(text => {
      
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
      
            if (!recommendations) {
              this.el.classList.add('hide');
              if (AOS) { AOS.refreshHard() }
              return;
            }
      
            this.placeholder.innerHTML = '';
            this.placeholder.innerHTML = recommendations.innerHTML;
      
            theme.reinitProductGridItem(this.el);
      
            this.slideshow = this.querySelector('[data-slideshow]');
      
            if (this.slideshow) {
              this.setupSlider();
            }
      
            document.dispatchEvent(new CustomEvent('recommendations:loaded', {
              detail: {
                section: this.el,
                intent: this.intent
              }
            }));
      
            })
            .catch(e => {
              console.error(e);
            });
        }
      
        setupSlider() {
          const controlType = this.slideshow.dataset.controls;
          const perSlide = parseFloat(this.slideshow.dataset.perSlide);
          const count = parseFloat(this.slideshow.dataset.count);
      
          let prevNextButtons = false;
          let pageDots = true;
      
          if (controlType === 'arrows') {
            pageDots = false;
            prevNextButtons = true;
          }
      
          if (perSlide < count) {
            this.flickity = new theme.Slideshow(this.slideshow, {
              prevNextButtons,
              pageDots,
              adaptiveHeight: true,
              wrapAround: false,
            });
          }
        }
      
        colorSwatchHovering() {
          this.swatches.forEach(swatch => {
            swatch.addEventListener('mouseenter', function() {
              this.setActiveColorImage(swatch);
            }.bind(this));
      
            swatch.addEventListener('touchstart', function(evt) {
              evt.preventDefault();
              this.setActiveColorImage(swatch);
            }.bind(this), {passive: true});
      
            swatch.addEventListener('mouseleave', function() {
              this.removeActiveColorImage(swatch);
            }.bind(this));
          });
        }
      
        setActiveColorImage(swatch) {
          const id = swatch.dataset.variantId;
          const image = swatch.dataset.variantImage;
      
          // Unset all active swatch images
          this.colorImages.forEach(el => {
            el.classList.remove('is-active');
          });
      
          // Unset all active swatches
          this.swatches.forEach(el => {
            el.classList.remove('is-active');
          });
      
          // Set active image and swatch
          const imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);
      
          imageEl.style.backgroundImage = 'url(' + image + ')';
          imageEl.classList.add('is-active');
          swatch.classList.add('is-active');
      
          // Update product grid item href with variant URL
          const variantUrl = swatch.dataset.url;
          const gridItem = swatch.closest('.grid-item__link');
          gridItem.setAttribute('href', variantUrl);
        }
      
        removeActiveColorImage(swatch) {
          const id = swatch.dataset.variantId;
          this.el.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
        }
      }
      
      customElements.define('product-recommendations', ProductRecommendations);
      
      theme.SlideshowSection = (function() {
      
        var selectors = {
          parallaxContainer: '.parallax-container'
        };
      
        function SlideshowSection(container) {
          this.container = container;
          var sectionId = container.getAttribute('data-section-id');
          this.slideshow = container.querySelector('#Slideshow-' + sectionId);
          this.namespace = '.' + sectionId;
      
          this.initialIndex = 0;
      
          if (!this.slideshow) { return }
      
          // Get shopify-created div that section markup lives in,
          // then get index of it inside its parent
          var sectionEl = container.parentElement;
          var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
      
          if (sectionIndex === 0) {
            this.init();
          } else {
            theme.initWhenVisible({
              element: this.container,
              callback: this.init.bind(this)
            });
          }
      
        }
      
        SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
          init: function() {
            var slides = this.slideshow.querySelectorAll('.slideshow__slide');
      
            this.slideshow.classList.remove('loading', 'loading--delayed');
            this.slideshow.classList.add('loaded');
      
            if (slides.length > 1) {
              var sliderArgs = {
                prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
                pageDots: this.slideshow.hasAttribute('data-dots'),
                fade: true,
                setGallerySize: false,
                initialIndex: this.initialIndex,
                autoPlay: this.slideshow.dataset.autoplay === 'true'
                  ? parseInt(this.slideshow.dataset.speed)
                  : false
              };
      
              this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
            } else {
              // Add loaded class to first slide
              slides[0].classList.add('is-selected');
            }
          },
      
          forceReload: function() {
            this.onUnload();
            this.init();
          },
      
          onUnload: function() {
            if (this.flickity && typeof this.flickity.destroy === 'function') {
              this.flickity.destroy();
            }
          },
      
          onDeselect: function() {
            if (this.flickity && typeof this.flickity.play === 'function') {
              this.flickity.play();
            }
          },
      
          onBlockSelect: function(evt) {
            var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
            var index = parseInt(slide.dataset.index);
      
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.goToSlide(index);
              this.flickity.pause();
            } else {
              // If section reloads, slideshow might not have been setup yet, wait a second and try again
              this.initialIndex = index;
              setTimeout(function() {
                if (this.flickity && typeof this.flickity.pause === 'function') {
                  this.flickity.pause();
                }
              }.bind(this), 1000);
            }
          },
      
          onBlockDeselect: function() {
            if (this.flickity && typeof this.flickity.play === 'function') {
              if (this.flickity.args.autoPlay) {
                this.flickity.play();
              }
            }
          }
        });
      
        return SlideshowSection;
      })();
      
      theme.StoreAvailability = (function() {
        var selectors = {
          drawerOpenBtn: '.js-drawer-open-availability',
          modalOpenBtn: '.js-modal-open-availability',
          productTitle: '[data-availability-product-title]'
        };
      
        function StoreAvailability(container) {
          this.container = container;
          this.baseUrl = container.dataset.baseUrl;
          this.productTitle = container.dataset.productName;
        }
      
        StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
          updateContent: function(variantId) {
            var variantSectionUrl =
              this.baseUrl +
              '/variants/' +
              variantId +
              '/?section_id=store-availability';
      
            var self = this;
      
            fetch(variantSectionUrl)
              .then(function(response) {
                return response.text();
              })
              .then(function(html) {
                if (html.trim() === '') {
                  this.container.innerHTML = '';
                  return;
                }
      
                self.container.innerHTML = html;
                self.container.innerHTML = self.container.firstElementChild.innerHTML;
      
                // Setup drawer if have open button
                if (self.container.querySelector(selectors.drawerOpenBtn)) {
                  self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
                }
      
                // Setup modal if have open button
                if (self.container.querySelector(selectors.modalOpenBtn)) {
                  self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
                }
      
                var title = self.container.querySelector(selectors.productTitle);
                if (title) {
                  title.textContent = self.productTitle;
                }
              });
          }
        });
      
        return StoreAvailability;
      })();
      
      theme.VideoSection = (function() {
        var selectors = {
          videoParent: '.video-parent-section'
        };
      
        function videoSection(container) {
          this.container = container;
          this.sectionId = container.getAttribute('data-section-id');
          this.namespace = '.video-' + this.sectionId;
          this.videoObject;
      
          theme.initWhenVisible({
            element: this.container,
            callback: this.init.bind(this),
            threshold: 500
          });
        }
      
        videoSection.prototype = Object.assign({}, videoSection.prototype, {
          init: function() {
            var dataDiv = this.container.querySelector('.video-div');
            if (!dataDiv) {
              return;
            }
            var type = dataDiv.dataset.type;
      
            switch(type) {
              case 'youtube':
                var videoId = dataDiv.dataset.videoId;
                this.initYoutubeVideo(videoId);
                break;
              case 'vimeo':
                var videoId = dataDiv.dataset.videoId;
                this.initVimeoVideo(videoId);
                break;
              case 'mp4':
                this.initMp4Video();
                break;
            }
          },
      
          initYoutubeVideo: function(videoId) {
            this.videoObject = new theme.YouTube(
              'YouTubeVideo-' + this.sectionId,
              {
                videoId: videoId,
                videoParent: selectors.videoParent
              }
            );
          },
      
          initVimeoVideo: function(videoId) {
            this.videoObject = new theme.VimeoPlayer(
              'Vimeo-' + this.sectionId,
              videoId,
              {
                videoParent: selectors.videoParent
              }
            );
          },
      
          initMp4Video: function() {
            var mp4Video = 'Mp4Video-' + this.sectionId;
            var mp4Div = document.getElementById(mp4Video);
            var parent = mp4Div.closest(selectors.videoParent);
      
            if (mp4Div) {
              parent.classList.add('loaded');
      
              var playPromise = document.querySelector('#' + mp4Video).play();
      
              // Edge does not return a promise (video still plays)
              if (playPromise !== undefined) {
                playPromise.then(function() {
                    // playback normal
                  }).catch(function() {
                    mp4Div.setAttribute('controls', '');
                    parent.classList.add('video-interactable');
                  });
              }
            }
          },
      
          onUnload: function(evt) {
            var sectionId = evt.target.id.replace('shopify-section-', '');
            if (this.videoObject && typeof this.videoObject.destroy === 'function') {
              this.videoObject.destroy();
            }
          }
        });
      
        return videoSection;
      })();
      
      /*============================================================================
        CountdownTimer
      ==============================================================================*/
      
      class CountdownTimer extends HTMLElement {
        constructor() {
          super();
          this.el = this;
          this.display = this.querySelector('[data-time-display]');
          this.block = this.closest('.countdown__block--timer');
          this.year = this.el.dataset.year;
          this.month = this.el.dataset.month;
          this.day = this.el.dataset.day;
          this.hour = this.el.dataset.hour;
          this.minute = this.el.dataset.minute;
          this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
          this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
          this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
          this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
          this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
          this.hideTimerOnComplete = this.el.dataset.hideTimer;
          this.completeMessage = this.el.dataset.completeMessage;
      
          this.timerComplete = false;
      
          this.init();
        }
      
        init() {
          setInterval(() => {
            if (!this.timerComplete) {
              this._calculate();
            }
          }, 1000);
      
        }
      
        _calculate() {
          // Find time difference and convert to integer
          const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
          // If time difference is greater than 0, calculate remaining time
          if (timeDifference > 0) {
            const intervals = {
              days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
              hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
              minutes: Math.floor((timeDifference / 1000 / 60) % 60),
              seconds: Math.floor((timeDifference / 1000) % 60),
            };
      
            this.daysPlaceholder.innerHTML = intervals.days;
            this.hoursPlaceholder.innerHTML = intervals.hours;
            this.minutesPlaceholder.innerHTML = intervals.minutes;
            this.secondsPlaceholder.innerHTML = intervals.seconds;
      
            setTimeout(() => {
              this.display.classList.add('countdown__display--loaded');
            }, 1);
          } else {
            if (this.completeMessage && this.messagePlaceholder) {
              this.messagePlaceholder.classList.add('countdown__timer-message--visible');
            }
      
            if (this.hideTimerOnComplete === 'true') {
              this.display.classList.remove('countdown__display--visible');
              this.display.classList.add('countdown__display--hidden');
            }
      
            if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
              this.block.classList.add('countdown__block--hidden');
            }
      
            this.timerComplete = true;
          }
        }
      }
      
      customElements.define('countdown-timer', CountdownTimer);
      
      /*============================================================================
        HotSpots
      ==============================================================================*/
      
      class HotSpots extends HTMLElement {
        constructor() {
          super();
          this.el = this;
          this.buttons = this.querySelectorAll('[data-button]');
          this.hotspotBlocks = this.querySelectorAll('[data-hotspot-block]');
          this.blockContainer = this.querySelector('[data-block-container]');
          this.colorImages = this.querySelectorAll('.grid-product__color-image');
          this.colorSwatches = this.querySelectorAll('.color-swatch--with-image');
      
          this._bindEvents();
          this._setupQuickShop();
      
          if (this.colorImages.length) {
            this._colorSwatchHovering();
          }
        }
      
        _colorSwatchHovering() {
          this.colorSwatches.forEach(swatch => {
            swatch.addEventListener('mouseenter', function() {
              this._setActiveColorImage(swatch);
            }.bind(this));
      
            swatch.addEventListener('touchstart', function(evt) {
              evt.preventDefault();
              this._setActiveColorImage(swatch);
            }.bind(this), {passive: true});
      
            swatch.addEventListener('mouseleave', function() {
              this._removeActiveColorImage(swatch);
            }.bind(this));
          });
        }
      
        _setActiveColorImage(swatch) {
          var id = swatch.dataset.variantId;
          var image = swatch.dataset.variantImage;
      
          // Unset all active swatch images
          this.colorImages.forEach(el => {
            el.classList.remove('is-active');
          });
      
          // Unset all active swatches
          this.colorSwatches.forEach(el => {
            el.classList.remove('is-active');
          });
      
          // Set active image and swatch
          var imageEl = this.el.querySelector('.grid-product__color-image--' + id);
          imageEl.style.backgroundImage = 'url(' + image + ')';
          imageEl.classList.add('is-active');
          swatch.classList.add('is-active');
      
          // Update product grid item href with variant URL
          var variantUrl = swatch.dataset.url;
          var gridItem = swatch.closest('.grid-item__link');
      
          if (gridItem) gridItem.setAttribute('href', variantUrl);
        }
      
        _removeActiveColorImage(swatch) {
          const id = swatch.dataset.variantId;
          this.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
        }
      
        /* Setup event listeners */
        _bindEvents() {
          this.buttons.forEach(button => {
            const id = button.dataset.button;
      
            button.on('click', e => {
              e.preventDefault();
              e.stopPropagation();
              this._showContent(id);
            });
          });
      
          // Display active hotspot block on theme editor select
          document.addEventListener('shopify:block:select', (e) => {
            const blockId = e.detail.blockId;
            this._showContent(`${blockId}`);
          });
        }
      
        /* Toggle sidebar content */
        _showContent(id) {
          // Hide all hotspotBlock
          // Show the hotspotBlock with the id
          this.hotspotBlocks.forEach((block) => {
            if (block.dataset.hotspotBlock === id) {
              block.classList.add('is-active');
            } else {
              block.classList.remove('is-active');
            }
          });
        }
      
        _setupQuickShop() {
          if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
            // Ensure we are utilizing the right version of QuickShop based off of theme
            if (typeof theme.QuickShop === 'function') {
              new theme.QuickShop(this.blockContainer);
            } else if (typeof theme.initQuickShop === 'function') {
              theme.initQuickShop();
            }
      
            if (typeof theme.QuickAdd === 'function') {
              new theme.QuickAdd(this.blockContainer);
            }
          }
        }
      }
      
      customElements.define('hot-spots', HotSpots);
      
      /*============================================================================
        ImageCompare
      ==============================================================================*/
      
      class ImageCompare extends HTMLElement {
        constructor() {
          super();
          this.el = this;
          this.sectionId = this.dataset.sectionId;
          this.button = this.querySelector('[data-button]');
          this.draggableContainer = this.querySelector('[data-draggable]');
          this.primaryImage = this.querySelector('[data-primary-image]');
          this.secondaryImage = this.querySelector('[data-secondary-image]');
      
          this.calculateSizes();
      
          this.active = false;
          this.currentX = 0;
          this.initialX = 0;
          this.xOffset = 0;
      
          this.buttonOffset = this.button.offsetWidth / 2;
      
          this.el.addEventListener("touchstart", this.dragStart, false);
          this.el.addEventListener("touchend", this.dragEnd, false);
          this.el.addEventListener("touchmove", this.drag, false);
      
          this.el.addEventListener("mousedown", this.dragStart, false);
          this.el.addEventListener("mouseup", this.dragEnd, false);
          this.el.addEventListener("mousemove", this.drag, false);
      
          window.on('resize', theme.utils.debounce(250, () => { this.calculateSizes(true)}));
      
          document.addEventListener('shopify:section:load', event => {
            if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
              this.calculateSizes();
            }
          });
        }
      
        calculateSizes(hasResized = false) {
          this.active = false;
          this.currentX = 0;
          this.initialX = 0;
          this.xOffset = 0;
      
          this.buttonOffset = this.button.offsetWidth / 2;
      
          this.elWidth = this.el.offsetWidth;
      
          this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
      
          if (this.primaryImage) {
            this.primaryImage.style.width = `${this.elWidth}px`;
          }
      
          if (hasResized) this.draggableContainer.style.width = `${this.elWidth/2}px`;
        }
      
        dragStart(e) {
          if (e.type === "touchstart") {
            this.initialX = e.touches[0].clientX - this.xOffset;
          } else {
            this.initialX = e.clientX - this.xOffset;
          }
      
          if (e.target === this.button) {
            this.active = true;
          }
        }
      
        dragEnd(e) {
          this.initialX = this.currentX;
      
          this.active = false;
        }
      
        drag(e) {
          if (this.active) {
      
            e.preventDefault();
      
            if (e.type === "touchmove") {
              this.currentX = e.touches[0].clientX - this.initialX;
            } else {
              this.currentX = e.clientX - this.initialX;
            }
      
            this.xOffset = this.currentX;
            this.setTranslate(this.currentX, this.button);
          }
        }
      
        setTranslate(xPos, el) {
          let newXpos = xPos - this.buttonOffset;
          let newVal = (this.elWidth/2) + xPos;
      
          const boundaryPadding = 50;
          const XposMin = (this.elWidth/2 + this.buttonOffset) * -1;
          const XposMax = this.elWidth/2 - this.buttonOffset;
      
          // Set boundaries for dragging
          if (newXpos < (XposMin + boundaryPadding)) {
            newXpos = XposMin + boundaryPadding;
            newVal = boundaryPadding
          } else if (newXpos > (XposMax - boundaryPadding)) {
            newXpos = XposMax - boundaryPadding;
            newVal = this.elWidth - boundaryPadding;
          }
      
          el.style.transform = `translate(${newXpos}px, -50%)`;
          this.draggableContainer.style.width = `${newVal}px`;
        }
      }
      
      customElements.define('image-compare', ImageCompare);
      
    
    
      theme.Blog = (function() {
    
      
    
        function Blog(container) {
    
          this.tagFilters();
    
        }
    
      
    
        Blog.prototype = Object.assign({}, Blog.prototype, {
    
          tagFilters: function() {
    
            var filterBy = document.getElementById('BlogTagFilter');
    
      
    
            if (!filterBy) {
    
              return;
    
            }
    
      
    
            filterBy.addEventListener('change', function() {
    
              location.href = filterBy.value;
    
            });
    
          }
    
        });
    
      
    
        return Blog;
    
      })();
    
      
      theme.CollectionHeader = (function() {
        var hasLoadedBefore = false;
      
        function CollectionHeader(container) {
          this.namespace = '.collection-header';
      
          var heroImageContainer = container.querySelector('.collection-hero');
          if (heroImageContainer) {
            if (hasLoadedBefore) {
              this.checkIfNeedReload();
            }
            heroImageContainer.classList.remove('loading', 'loading--delayed');
            heroImageContainer.classList.add('loaded');
          } else if (theme.settings.overlayHeader) {
            theme.headerNav.disableOverlayHeader();
          }
      
          hasLoadedBefore = true;
        }
      
        CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
          // A liquid variable in the header needs a full page refresh
          // if the collection header hero image setting is enabled
          // and the header is set to sticky. Only necessary in the editor.
          checkIfNeedReload: function() {
            if (!Shopify.designMode) {
              return;
            }
      
            if (theme.settings.overlayHeader) {
              var header = document.querySelector('.header-wrapper');
              if (!header.classList.contains('header-wrapper--overlay')) {
                location.reload();
              }
            }
          }
        });
      
        return CollectionHeader;
      })();
      
      theme.CollectionSidebar = (function() {
        var drawerStyle = false;
        var selectors = {
          sidebar: '#CollectionSidebar',
        };
      
        function CollectionSidebar(container) {
          this.container = container.querySelector(selectors.sidebar);
        }
      
        CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
          init: function() {
            // Do not load when no sidebar exists
            if(!this.container) {
              return;
            }
      
            this.onUnload();
      
            drawerStyle = this.container.dataset.style === 'drawer';
            theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
          },
      
          forceReload: function() {
            this.init();
          },
      
          onSelect: function() {
            if (theme.FilterDrawer) {
              if (!drawerStyle) {
                theme.FilterDrawer.close();
                return;
              }
      
              if (drawerStyle || theme.config.bpSmall) {
                theme.FilterDrawer.open();
              }
            }
          },
      
          onDeselect: function() {
            if (theme.FilterDrawer) {
              theme.FilterDrawer.close();
            }
          },
      
          onUnload: function() {
            if (theme.FilterDrawer) {
              theme.FilterDrawer.close();
            }
          }
        });
      
        return CollectionSidebar;
      })();
      
      theme.Collection = (function() {
        var isAnimating = false;
      
        var selectors = {
          sortSelect: '#SortBy',
      
          colorSwatchImage: '.grid-product__color-image',
          colorSwatch: '.color-swatch--with-image',
      
          collectionGrid: '.collection-grid__wrapper',
          trigger: '.collapsible-trigger',
          sidebar: '#CollectionSidebar',
          filterSidebar: '.collapsible-content--sidebar',
          activeTagList: '.tag-list--active-tags',
          tags: '.tag-list input',
          activeTags: '.tag-list a',
          tagsForm: '.filter-form',
          filters: '.collection-filter',
          priceRange: '.price-range',
        };
      
        var classes = {
          activeTag: 'tag--active',
          removeTagParent: 'tag--remove',
          filterSidebar: 'collapsible-content--sidebar',
          isOpen: 'is-open',
        };
      
        function Collection(container) {
          this.container = container;
          this.sectionId = container.getAttribute('data-section-id');
          this.namespace = '.collection-' + this.sectionId;
          this.sidebar = new theme.CollectionSidebar(container);
          this.context = container.getAttribute('data-context');
          this.ajaxRenderer = new theme.AjaxRenderer({
            sections: [
              {
                sectionId: this.sectionId,
                nodeId: 'CollectionAjaxContent',
              },
            ],
            onReplace: this.onReplaceAjaxContent.bind(this),
          });
      
          this.init();
        }
      
        Collection.prototype = Object.assign({}, Collection.prototype, {
          init: function() {
      
            /* Prevent extra JS from running for featured collection on a collection template */
            if (this.context && this.context === 'featured-collection') {
              this.colorSwatchHovering();
            } else {
              this.initSort();
              this.colorSwatchHovering();
              this.initFilters();
              this.initPriceRange();
              this.sidebar.init();
            }
          },
      
          initSort: function() {
            this.sortSelect = document.querySelector(selectors.sortSelect);
      
            if (this.sortSelect) {
              this.defaultSort = this.getDefaultSortValue();
              this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
            }
          },
      
          getSortValue: function() {
            return this.sortSelect.value || this.defaultSort;
          },
      
          getDefaultSortValue: function() {
            return this.sortSelect.getAttribute('data-default-sortby');
          },
      
          onSortChange: function() {
            this.queryParams = new URLSearchParams(window.location.search);
      
            this.queryParams.set('sort_by', this.getSortValue());
            this.queryParams.delete('page'); // Delete if it exists
      
            window.location.search = this.queryParams.toString();
          },
      
          colorSwatchHovering: function() {
            var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
            if (!colorImages.length) {
              return;
            }
      
            this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
              swatch.addEventListener('mouseenter', () => {
                var id = swatch.dataset.variantId;
                var image = swatch.dataset.variantImage;
                var el = this.container.querySelector('.grid-product__color-image--' + id);
                el.style.backgroundImage = 'url(' + image + ')';
                el.classList.add('is-active');
              });
              swatch.addEventListener('mouseleave', () => {
                var id = swatch.dataset.variantId;
                this.container.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
              });
            });
          },
      
          /*====================
            Collection filters
          ====================*/
          initFilters: function() {
            var tags = document.querySelectorAll(selectors.tags);
      
            if (!tags.length) {
              return;
            }
      
            this.bindBackButton();
      
            // Set mobile top value for filters if sticky header enabled
            if (theme.config.stickyHeader) {
              this.setFilterStickyPosition();
      
              window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
            }
      
            document.querySelectorAll(selectors.activeTags).forEach(tag => {
              tag.addEventListener('click', this.tagClick.bind(this));
            });
      
            document.querySelectorAll(selectors.tagsForm).forEach(form => {
              form.addEventListener('input', this.onFormSubmit.bind(this));
            });
          },
      
          initPriceRange: function() {
            const priceRangeEls = document.querySelectorAll(selectors.priceRange);
            priceRangeEls.forEach((el) => new theme.PriceRange(el, {
              // onChange passes in formData
              onChange: this.renderFromFormData.bind(this),
            }));
          },
      
          tagClick: function(evt) {
            var el = evt.currentTarget;
      
            if (theme.FilterDrawer) {
              theme.FilterDrawer.close();
            }
      
            // Do not ajax-load collection links
            if (el.classList.contains('no-ajax')) {
              return;
            }
      
            evt.preventDefault();
      
            if (isAnimating) {
              return;
            }
      
            isAnimating = true;
      
            const parent = el.parentNode;
            const newUrl = new URL(el.href);
      
            this.renderActiveTag(parent, el);
            this.updateScroll(true);
            this.startLoading();
            this.renderCollectionPage(newUrl.searchParams);
          },
      
          onFormSubmit: function(evt) {
            var el = evt.target;
      
            if (theme.FilterDrawer) {
              theme.FilterDrawer.close();
            }
      
            // Do not ajax-load collection links
            if (el.classList.contains('no-ajax')) {
              return;
            }
      
            evt.preventDefault();
            if (isAnimating) {
              return;
            }
      
            isAnimating = true;
      
            const parent = el.closest('li');
            const formEl = el.closest('form');
            const formData = new FormData(formEl);
      
            this.renderActiveTag(parent, el);
            this.updateScroll(true);
            this.startLoading();
            this.renderFromFormData(formData);
          },
      
          fetchOpenCollasibleFilters: function() {
            return Array.from(
              document.querySelectorAll(
                `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
              ),
            ).map(trigger => trigger.dataset.collapsibleId);
          },
      
          renderActiveTag: function(parent, el) {
            const textEl = parent.querySelector('.tag__text');
      
            if (parent.classList.contains(classes.activeTag)) {
              parent.classList.remove(classes.activeTag);
            } else {
              parent.classList.add(classes.activeTag);
      
              // If adding a tag, show new tag right away.
              // Otherwise, remove it before ajax finishes
              if (el.closest('li').classList.contains(classes.removeTagParent)) {
                parent.remove();
              } else {
                // Append new tag in both drawer and sidebar
                document.querySelectorAll(selectors.activeTagList).forEach(list => {
                  const newTag = document.createElement('li');
                  const newTagLink = document.createElement('a');
                  newTag.classList.add('tag', 'tag--remove');
                  newTagLink.classList.add('btn', 'btn--small');
                  newTagLink.innerText = textEl.innerText;
                  newTag.appendChild(newTagLink);
      
                  list.appendChild(newTag);
                });
              }
            }
          },
      
          renderFromFormData: function(formData) {
            const searchParams = new URLSearchParams(formData);
            this.renderCollectionPage(searchParams);
          },
      
          onReplaceAjaxContent: function(newDom, section) {
            const openCollapsibleIds = this.fetchOpenCollasibleFilters();
      
            openCollapsibleIds.forEach(selector => {
              newDom
                .querySelectorAll(`[data-collapsible-id=${selector}]`)
                .forEach(this.openCollapsible);
            });
      
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }
      
            document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
          },
      
          openCollapsible: function(el) {
            if (el.classList.contains(classes.filterSidebar)) {
              el.style.height = 'auto';
            }
      
            el.classList.add(classes.isOpen);
          },
      
          renderCollectionPage: function(searchParams, updateURLHash = true) {
            this.ajaxRenderer
              .renderPage(window.location.pathname, searchParams, updateURLHash)
              .then(() => {
                theme.sections.reinit('collection-grid');
                this.updateScroll(false);
                this.initPriceRange();
                theme.reinitProductGridItem();
      
                document.dispatchEvent(new CustomEvent('collection:reloaded'));
      
                isAnimating = false;
              });
          },
      
          bindBackButton: function() {
            // Ajax page on back button
            window.off('popstate' + this.namespace);
            window.on('popstate' + this.namespace, function(state) {
              if (state) {
                const newUrl = new URL(window.location.href);
                this.renderCollectionPage(newUrl.searchParams, false);
              }
            }.bind(this));
          },
      
          updateScroll: function(animate) {
            var scrollToElement = document.querySelector('[data-scroll-to]');
            var scrollTo = scrollToElement && scrollToElement.offsetTop;
      
            if (!theme.config.bpSmall) {
              scrollTo -= 15;
            }
      
            if (theme.config.stickyHeader) {
              var headerHeight = document.querySelector('.site-header').offsetHeight;
              scrollTo = scrollTo - headerHeight;
            }
      
            if (animate) {
              window.scrollTo({top: scrollTo, behavior: 'smooth'});
            } else {
              window.scrollTo({top: scrollTo});
            }
          },
      
          setFilterStickyPosition: function() {
            var headerHeight = document.querySelector('.site-header').offsetHeight;
            document.querySelector(selectors.filters).style.top = headerHeight + 10 + 'px';
      
            // Also update top position of sticky sidebar
            var stickySidebar = document.querySelector('.grid__item--sidebar');
            if (stickySidebar) {
              stickySidebar.style.top = headerHeight + 10 + 'px';
            }
          },
      
          forceReload: function() {
            this.init();
          },
      
          startLoading: function() {
            document.querySelector(selectors.collectionGrid).classList.add('unload');
          },
        });
      
        return Collection;
      })();
      
      theme.FooterSection = (function() {
        var selectors = {
          locale: '[data-disclosure-locale]',
          currency: '[data-disclosure-currency]'
        };
      
        function FooterSection(container) {
          this.container = container;
          this.localeDisclosure = null;
          this.currencyDisclosure = null;
      
          this.init();
        }
      
        FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
          init: function() {
            var localeEl = this.container.querySelector(selectors.locale);
            var currencyEl = this.container.querySelector(selectors.currency);
      
            if (localeEl) {
              this.localeDisclosure = new theme.Disclosure(localeEl);
            }
      
            if (currencyEl) {
              this.currencyDisclosure = new theme.Disclosure(currencyEl);
            }
      
            // Change email icon to submit text
            var newsletterInput = document.querySelector('.footer__newsletter-input');
            if (newsletterInput) {
              newsletterInput.addEventListener('keyup', function() {
                newsletterInput.classList.add('footer__newsletter-input--active');
              });
            }
      
            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);
          },
      
          onUnload: function() {
            if (this.localeDisclosure) {
              this.localeDisclosure.destroy();
            }
      
            if (this.currencyDisclosure) {
              this.currencyDisclosure.destroy();
            }
          }
        });
      
        return FooterSection;
      })();
      
      theme.HeaderSection = (function() {
      
        var selectors = {
          locale: '[data-disclosure-locale]',
          currency: '[data-disclosure-currency]'
        };
      
        function HeaderSection(container) {
          this.container = container;
          this.sectionId = this.container.getAttribute('data-section-id');
      
          this.init();
        }
      
        HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
          init: function() {
            // Reload any slideshow if header is reloaded to make sure
            // sticky header works as expected
            // (can be anywhere in sections.instance array)
            if (Shopify && Shopify.designMode) {
              theme.sections.reinit('slideshow-section');
      
              // Set a timer to resize the header in case the logo changes size
              setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
              }, 500);
            }
      
            this.initDrawers();
            this.initDisclosures();
            theme.headerNav.init();
            theme.announcementBar.init();
            this.hoverMenu();
          },
      
          hoverMenu: function() {
            const detailsEl = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
      
            detailsEl.forEach((detail) => {
              const summary = detail.querySelector('summary');
              const summaryLink = summary.dataset.link;
      
              summary.addEventListener('click', e => {
                e.preventDefault();
                window.location.href = summaryLink;
              });
      
              // if detail has :focus-within
              detail.addEventListener('focusin', () => {
                if (!detail.hasAttribute('open')) {
      
                  // close all other details
                  detailsEl.forEach((detail) => {
                    detail.removeAttribute('open');
                    detail.setAttribute('aria-expanded', 'false');
                  });
      
                  detail.setAttribute('open', '');
                  detail.setAttribute('aria-expanded', 'true');
                }
              });
      
              detail.addEventListener('focusout', () => {
                if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
                  detail.removeAttribute('open');
                  detail.setAttribute('aria-expanded', 'false');
                }
              });
      
              detail.addEventListener('mouseover', () => {
                if (!detail.hasAttribute('open')) {
                  detail.setAttribute('open', '');
                  detail.setAttribute('aria-expanded', 'true');
                }
              });
      
              detail.addEventListener('mouseleave', () => {
                if (detail.hasAttribute('open')) {
                  detail.removeAttribute('open');
                  detail.setAttribute('aria-expanded', 'false');
                }
              });
            });
          },
      
          initDisclosures: function() {
            var localeEl = this.container.querySelector(selectors.locale);
            var currencyEl = this.container.querySelector(selectors.currency);
      
            if (localeEl) {
              this.localeDisclosure = new theme.Disclosure(localeEl);
            }
      
            if (currencyEl) {
              this.currencyDisclosure = new theme.Disclosure(currencyEl);
            }
          },
      
          initDrawers: function() {
            theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
            if (theme.settings.cartType === 'drawer') {
              if (!document.body.classList.contains('template-cart')) {
                new theme.CartDrawer();
              }
            }
      
            theme.collapsibles.init(document.getElementById('NavDrawer'));
          },
      
          onUnload: function() {
            theme.NavDrawer.close();
            theme.announcementBar.unload();
      
            if (this.localeDisclosure) {
              this.localeDisclosure.destroy();
            }
      
            if (this.currencyDisclosure) {
              this.currencyDisclosure.destroy();
            }
          }
        });
      
        return HeaderSection;
      })();
      
      theme.Product = (function() {
        var videoObjects = {};
      
        var classes = {
          onSale: 'on-sale',
          disabled: 'disabled',
          isModal: 'is-modal',
          loading: 'loading',
          loaded: 'loaded',
          hidden: 'hide',
          interactable: 'video-interactable',
          visuallyHide: 'visually-invisible',
          lowInventory: 'inventory--low',
        };
      
        var selectors = {
          productVideo: '.product__video',
          videoParent: '.product__video-wrapper',
          slide: '.product-main-slide',
          currentSlide: '.is-selected',
          startingSlide: '.starting-slide',
          variantType: '.variant-wrapper',
          blocks: '[data-product-blocks]',
          blocksHolder: '[data-blocks-holder]',
          dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
        };
      
        function Product(container) {
          this.container = container;
          var sectionId = this.sectionId = container.getAttribute('data-section-id');
          var productId = this.productId = container.getAttribute('data-product-id');
      
          this.inModal = (container.dataset.modal === 'true');
          this.modal;
      
          this.settings = {
            enableHistoryState: container.dataset.history || false,
            namespace: '.product-' + sectionId,
            inventory: false,
            inventoryThreshold: 10,
            modalInit: false,
            hasImages: true,
            imageSetName: null,
            imageSetIndex: null,
            currentImageSet: null,
            imageSize: '620x',
            currentSlideIndex: 0,
            videoLooping: container.dataset.videoLooping
          };
      
          // Overwrite some settings when loaded in modal
          if (this.inModal) {
            this.settings.enableHistoryState = false;
            this.settings.namespace = '.product-' + sectionId + '-modal';
            this.modal = document.getElementById('QuickShopModal-' + productId);
          }
      
          this.selectors = {
            variantsJson: '[data-variant-json]',
            currentVariantJson: '[data-current-variant-json]',
            form: '.product-single__form',
      
            media: '[data-product-media-type-model]',
            closeMedia: '.product-single__close-media',
            photoThumbs: '[data-product-thumb]',
            thumbSlider: '[data-product-thumbs]',
            thumbScroller: '.product__thumbs--scroller',
            mainSlider: '[data-product-photos]',
            imageContainer: '[data-product-images]',
            productImageMain: '[data-product-image-main]',
      
            priceWrapper: '[data-product-price-wrap]',
            price: '[data-product-price]',
            comparePrice: '[data-compare-price]',
            savePrice: '[data-save-price]',
            priceA11y: '[data-a11y-price]',
            comparePriceA11y: '[data-compare-price-a11y]',
            unitWrapper: '[data-unit-price-wrapper]',
            unitPrice: '[data-unit-price]',
            unitPriceBaseUnit: '[data-unit-base]',
            sku: '[data-sku]',
            inventory: '[data-product-inventory]',
            incomingInventory: '[data-incoming-inventory]',
            colorLabel: '[data-variant-color-label]',
      
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
      
            originalSelectorId: '[data-product-select]',
            singleOptionSelector: '[data-variant-input]',
            variantColorSwatch: '.variant__input--color-swatch',
            dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
      
            availabilityContainer: '[data-store-availability-holder]'
          };
      
          this.cacheElements();
      
          this.firstProductImage = this.cache.mainSlider.querySelector('img');
      
          if (!this.firstProductImage) {
            this.settings.hasImages = false;
          }
      
          var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
          if (dataSetEl) {
            this.settings.imageSetName = dataSetEl.dataset.setName;
          }
      
          this.init();
        }
      
        Product.prototype = Object.assign({}, Product.prototype, {
          init: function() {
            if (this.inModal) {
              this.container.classList.add(classes.isModal);
              document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
              document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
            }
      
            if (!this.inModal) {
              this.formSetup();
              this.productSetup();
              this.videoSetup();
              this.initProductSlider();
              this.customMediaListners();
              this.addIdToRecentlyViewed();
            }
          },
      
          cacheElements: function() {
            this.cache = {
              form: this.container.querySelector(this.selectors.form),
              mainSlider: this.container.querySelector(this.selectors.mainSlider),
              thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
              thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
              productImageMain: this.container.querySelector(this.selectors.productImageMain),
      
              // Price-related
              priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
              comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
              comparePrice: this.container.querySelector(this.selectors.comparePrice),
              price: this.container.querySelector(this.selectors.price),
              savePrice: this.container.querySelector(this.selectors.savePrice),
              priceA11y: this.container.querySelector(this.selectors.priceA11y)
            };
          },
      
          formSetup: function() {
            this.initQtySelector();
            this.initAjaxProductForm();
            this.availabilitySetup();
            this.initVariants();
      
            // We know the current variant now so setup image sets
            if (this.settings.imageSetName) {
              this.updateImageSet();
            }
          },
      
          availabilitySetup: function() {
            var container = this.container.querySelector(this.selectors.availabilityContainer);
            if (container) {
              this.storeAvailability = new theme.StoreAvailability(container);
            }
          },
      
          productSetup: function() {
            this.setImageSizes();
            this.initImageZoom();
            this.initModelViewerLibraries();
            this.initShopifyXrLaunch();
          },
      
          setImageSizes: function() {
            if (!this.settings.hasImages) {
              return;
            }
      
            // Get srcset image src, works on most modern browsers
            // otherwise defaults to settings.imageSize
            var currentImage = this.firstProductImage.currentSrc;
      
            if (currentImage) {
              this.settings.imageSize = theme.Images.imageSize(currentImage);
            }
          },
      
          addIdToRecentlyViewed: function() {
            var handle = this.container.getAttribute('data-product-handle');
            var url = this.container.getAttribute('data-product-url');
            var aspectRatio = this.container.getAttribute('data-aspect-ratio');
            var featuredImage = this.container.getAttribute('data-img-url');
      
            // Remove current product if already in set of recent
            if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
              delete theme.recentlyViewed.recent[handle];
            }
      
            // Add it back to the end
            theme.recentlyViewed.recent[handle] = {
              url: url,
              aspectRatio: aspectRatio,
              featuredImage: featuredImage
            };
      
            if (theme.config.hasLocalStorage) {
              window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
            }
          },
      
          initVariants: function() {
            var variantJson = this.container.querySelector(this.selectors.variantsJson);
      
            if (!variantJson) {
              return;
            }
      
            this.variantsObject = JSON.parse(variantJson.innerHTML);
            var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)
      
            var options = {
              container: this.container,
              enableHistoryState: this.settings.enableHistoryState,
              singleOptionSelector: this.selectors.singleOptionSelector,
              originalSelectorId: this.selectors.originalSelectorId,
              variants: this.variantsObject,
              dynamicVariantsEnabled
            };
      
            var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
            if (swatches.length) {
              swatches.forEach(swatch => {
                swatch.addEventListener('change', function(evt) {
                  var color = swatch.dataset.colorName;
                  var index = swatch.dataset.colorIndex;
                  this.updateColorName(color, index);
                }.bind(this))
              });
            }
      
            this.variants = new theme.Variants(options);
      
            // Product availability on page load
            if (this.storeAvailability) {
              var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
      
              this.storeAvailability.updateContent(variant_id);
              this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
            }
      
            this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
            this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
            this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
            this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
      
            if (this.container.querySelector(this.selectors.sku)) {
              this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
            }
      
            var inventoryEl = this.container.querySelector(this.selectors.inventory);
            if (inventoryEl) {
              this.settings.inventory = true;
              this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
      
              // Update inventory on page load
              this.updateInventory({ detail: { variant: this.variants.currentVariant } });
      
              this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
            }
      
            // Update individual variant availability on each selection
            if (dynamicVariantsEnabled) {
              var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);
      
              if (currentVariantJson) {
                var variantType = this.container.querySelector(selectors.variantType);
      
                if (variantType) {
                  new theme.VariantAvailability({
                    container: this.container,
                    namespace: this.settings.namespace,
                    type: variantType.dataset.type,
                    variantsObject: this.variantsObject,
                    currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
                  });
                }
              }
            }
      
            // image set names variant change listeners
            if (this.settings.imageSetName) {
              var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]');
              if (variantWrapper) {
                this.settings.imageSetIndex = variantWrapper.dataset.index;
                this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
              } else {
                this.settings.imageSetName = null;
              }
            }
          },
      
          initQtySelector: function() {
            this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
              new theme.QtySelector(el, {
                namespace: '.product'
              });
            });
          },
      
          initAjaxProductForm: function() {
            new theme.AjaxProduct(this.cache.form);
          },
      
          /*============================================================================
            Variant change methods
          ==============================================================================*/
          updateColorName: function(color, index) {
            // Updates on radio button change, not variant.js
            this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
          },
      
          updateCartButton: function(evt) {
            var variant = evt.detail.variant;
            var cartBtn = this.container.querySelector(this.selectors.addToCart);
            var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
      
            if (!cartBtn) return;
      
            if (variant) {
              if (variant.available) {
                // Available, enable the submit button and change text
                cartBtn.classList.remove(classes.disabled);
                cartBtn.disabled = false;
                var defaultText = cartBtnText.dataset.defaultText;
                cartBtnText.textContent = defaultText;
              } else {
                // Sold out, disable the submit button and change text
                cartBtn.classList.add(classes.disabled);
                cartBtn.disabled = true;
                cartBtnText.textContent = theme.strings.soldOut;
              }
            } else {
              // The variant doesn't exist, disable submit button
              cartBtn.classList.add(classes.disabled);
              cartBtn.disabled = true;
              cartBtnText.textContent = theme.strings.unavailable;
            }
          },
      
          updatePrice: function(evt) {
            var variant = evt.detail.variant;
      
            if (variant) {
              // Regular price
              this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
      
              // Sale price, if necessary
              if (variant.compare_at_price > variant.price) {
                this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
                this.cache.priceWrapper.classList.remove(classes.hidden);
                this.cache.price.classList.add(classes.onSale);
                this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
                this.cache.priceA11y.setAttribute('aria-hidden', 'false');
      
                var savings = variant.compare_at_price - variant.price;
      
                if (theme.settings.saveType == 'percent') {
                  savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
                } else {
                  savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
                }
      
                this.cache.savePrice.classList.remove(classes.hidden);
                this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
              } else {
                if (this.cache.priceWrapper) {
                  this.cache.priceWrapper.classList.add(classes.hidden);
                }
                this.cache.savePrice.classList.add(classes.hidden);
                this.cache.price.classList.remove(classes.onSale);
                if (this.cache.comparePriceA11y) {
                  this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
                }
                this.cache.priceA11y.setAttribute('aria-hidden', 'true');
              }
            }
          },
      
          updateUnitPrice: function(evt) {
            var variant = evt.detail.variant;
      
            if (variant && variant.unit_price) {
              this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
              this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
              this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
            } else {
              this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
            }
          },
      
          imageSetArguments: function(variant) {
            var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
            if (!variant) return;
      
            var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
            var set = this.settings.imageSetName + '_' + setValue;
      
            // Always start on index 0
            this.settings.currentSlideIndex = 0;
      
            // Return object that adds cellSelector to mainSliderArgs
            return {
              cellSelector: '[data-group="'+set+'"]',
              imageSet: set,
              initialIndex: this.settings.currentSlideIndex
            }
          },
      
          updateImageSet: function(evt) {
            // If called directly, use current variant
            var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
            if (!variant) {
              return;
            }
      
            var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);
      
            // Already on the current image group
            if (this.settings.currentImageSet === setValue) {
              return;
            }
      
            this.initProductSlider(variant);
          },
      
          // Show/hide thumbnails based on current image set
          updateImageSetThumbs: function(set) {
            this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
              thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
            });
          },
      
          getImageSetName: function(string) {
            return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
          },
      
          updateSku: function(evt) {
            var variant = evt.detail.variant;
            var newSku = '';
      
            if (variant) {
              if (variant.sku) {
                newSku = variant.sku;
              }
      
              this.container.querySelector(this.selectors.sku).textContent = newSku;
            }
          },
      
          updateInventory: function(evt) {
            var variant = evt.detail.variant;
      
            // Override to display in stock message for sold out variants with policy set to continue
            // Must be set to true in order to display in stock message for sold out variants
            const inStockForOOSAndContinueSelling = false;
      
            if (!variant) {
              // Variant is unavailable
              // So we want to hide both the inventory quantity + incoming transfer notice
              this.toggleInventoryQuantity('hidden', false);
              this.toggleIncomingInventory(false);
              return;
            }
      
            // Inventory management is nil
            // So we want to hide the low inventory message but show an In stock status
            // And hide the incoming transfer notice
            if (!variant.inventory_management) {
              this.toggleInventoryQuantity('visible', false);
              this.toggleIncomingInventory(false);
              return;
            }
      
            if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
              const variantInventoryObject = window.inventories[this.productId][variant.id];
      
              const { quantity, policy, incoming, next_incoming_date } = variantInventoryObject || {};
      
              this.toggleInventoryQuantity(undefined, quantity);
      
              if (inStockForOOSAndContinueSelling) {
                if (quantity <= 0 && policy === 'continue') {
                  this.toggleInventoryQuantity('visible', false);
                  this.toggleIncomingInventory(false);
                  return;
                }
              }
      
              if ((incoming && !variant.available) || (quantity <= 0 && policy === 'continue')) {
                this.toggleIncomingInventory(true, next_incoming_date, policy);
              } else {
                this.toggleIncomingInventory(false);
              }
            }
          },
      
          updateAvailability: function(evt) {
            var variant = evt.detail.variant;
            if (!variant) {
              return;
            }
      
            this.storeAvailability.updateContent(variant.id);
          },
      
          toggleInventoryQuantity: function(state = undefined, quantity) {
            const productInventoryEl = this.container.querySelector(this.selectors.inventory);
            const inventorySalesPoint = productInventoryEl.closest('.sales-point');
      
            if (state && state === 'hidden') {
              // variant is unavailable
              // hide and return
              if (inventorySalesPoint) {
                inventorySalesPoint.classList.add(classes.hidden);
              }
      
              return;
            }
      
            let showLowInventoryMessage = false;
      
            // Check if we should show low inventory message
            if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && parseInt(quantity) > 0) {
              showLowInventoryMessage = true;
            }
      
            if (parseInt(quantity) > 0 || (state && state === 'visible')) {
              if (showLowInventoryMessage) {
                productInventoryEl.parentNode.classList.add(classes.lowInventory);
                if (quantity > 1) {
                  productInventoryEl.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
                } else {
                  productInventoryEl.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
                }
              } else {
                productInventoryEl.parentNode.classList.remove(classes.lowInventory);
                productInventoryEl.textContent = theme.strings.inStockLabel;
              }
      
              if (inventorySalesPoint) {
                inventorySalesPoint.classList.remove(classes.hidden);
              }
      
            } else {
              if (inventorySalesPoint) {
                inventorySalesPoint.classList.add(classes.hidden);
              }
            }
          },
      
          toggleIncomingInventory: function(showIncomingInventory, incomingInventoryDate, policy) {
      
            const incomingInventoryEl = this.container.querySelector(this.selectors.incomingInventory);
            const incomingInventoryIcon = incomingInventoryEl.querySelector('.icon-and-text');
      
            if (!incomingInventoryEl) return;
      
            const incomingInventoryBlockEnabled = incomingInventoryEl.dataset.enabled === 'true';
            const textEl = incomingInventoryEl.querySelector('.js-incoming-text');
      
            // If incoming inventory block is disabled, hide it
            if (!incomingInventoryBlockEnabled) {
              incomingInventoryEl.classList.add(classes.hidden);
              return;
            }
      
            if (showIncomingInventory) {
              if (incomingInventoryDate) {
                textEl.textContent = theme.strings.willBeInStockAfter.replace('[date]', incomingInventoryDate);
                incomingInventoryEl.classList.remove(classes.hidden);
              } else {
                textEl.textContent = theme.strings.waitingForStock;
                incomingInventoryEl.classList.remove(classes.hidden);
              }
      
              // When OOS and incoming inventory and continue selling disabled, update icon to low inventory
              if (incomingInventoryIcon) {
                if (policy !== 'continue') {
                  incomingInventoryIcon.classList.add(classes.lowInventory);
                } else {
                  incomingInventoryIcon.classList.remove(classes.lowInventory);
                }
              }
      
            } else {
              incomingInventoryEl.classList.add(classes.hidden);
            }
          },
      
          /*============================================================================
            Product videos
          ==============================================================================*/
          videoSetup: function() {
            var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);
      
            if (!productVideos.length) {
              return false;
            }
      
            productVideos.forEach(vid => {
              var type = vid.dataset.videoType;
              if (type === 'youtube') {
                this.initYoutubeVideo(vid);
              } else if (type === 'vimeo') {
                this.initVimeoVideo(vid);
              } else if (type === 'mp4') {
                this.initMp4Video(vid);
              }
            });
          },
      
          initYoutubeVideo: function(div) {
            videoObjects[div.id] = new theme.YouTube(
              div.id,
              {
                videoId: div.dataset.videoId,
                videoParent: selectors.videoParent,
                autoplay: false, // will handle this in callback
                style: div.dataset.videoStyle,
                loop: div.dataset.videoLoop,
                events: {
                  onReady: this.youtubePlayerReady.bind(this),
                  onStateChange: this.youtubePlayerStateChange.bind(this)
                }
              }
            );
          },
      
          initVimeoVideo: function(div) {
            videoObjects[div.id] = new theme.VimeoPlayer(
              div.id,
              div.dataset.videoId,
              {
                videoParent: selectors.videoParent,
                autoplay: false,
                style: div.dataset.videoStyle,
                loop: div.dataset.videoLoop,
              }
            )
          },
      
          // Comes from YouTube SDK
          // Get iframe ID with evt.target.getIframe().id
          // Then access product video players with videoObjects[id]
          youtubePlayerReady: function(evt) {
            var iframeId = evt.target.getIframe().id;
      
            if (!videoObjects[iframeId]) {
              // No youtube player data
              return;
            }
      
            var obj = videoObjects[iframeId];
            var player = obj.videoPlayer;
      
            if (obj.options.style !== 'sound') {
              player.mute();
            }
      
            obj.parent.classList.remove('loading');
            obj.parent.classList.add('loaded');
            obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change
      
            // If we have an element, it is in the visible/first slide,
            // and is muted, play it
            if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
              player.playVideo();
            }
          },
      
          _isFirstSlide: function(id) {
            return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
          },
      
          youtubePlayerStateChange: function(evt) {
            var iframeId = evt.target.getIframe().id;
            var obj = videoObjects[iframeId];
      
            switch (evt.data) {
              case -1: // unstarted
                // Handle low power state on iOS by checking if
                // video is reset to unplayed after attempting to buffer
                if (obj.attemptedToPlay) {
                  obj.parent.classList.add('video-interactable');
                }
                break;
              case 0: // ended
                if (obj && obj.options.loop === 'true') {
                  obj.videoPlayer.playVideo();
                }
                break;
              case 3: // buffering
                obj.attemptedToPlay = true;
                break;
            }
          },
      
          initMp4Video: function(div) {
            videoObjects[div.id] = {
              id: div.id,
              type: 'mp4'
            };
      
            if (this._isFirstSlide(div.id)) {
              this.playMp4Video(div.id);
            }
          },
      
          stopVideos: function() {
            for (var [id, vid] of Object.entries(videoObjects)) {
              if (vid.videoPlayer) {
                if (typeof vid.videoPlayer.stopVideo === 'function') {
                  vid.videoPlayer.stopVideo(); // YouTube player
                }
              } else if (vid.type === 'mp4') {
                this.stopMp4Video(vid.id); // MP4 player
              }
            }
          },
      
          _getVideoType: function(video) {
            return video.getAttribute('data-video-type');
          },
      
          _getVideoDivId: function(video) {
            return video.id;
          },
      
          playMp4Video: function(id) {
            var player = this.container.querySelector('#' + id);
            var playPromise = player.play();
      
            if (playPromise !== undefined) {
              playPromise.then(function() {
                // Playing as expected
              })
              .catch(function(error) {
                // Likely low power mode on iOS, show controls
                player.setAttribute('controls', '');
                player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
              });
            }
          },
      
          stopMp4Video: function(id) {
            var player = this.container.querySelector('#' + id);
            if (player && typeof player.pause === 'function') {
              player.pause();
            }
          },
      
          /*============================================================================
            Product images
          ==============================================================================*/
          initImageZoom: function() {
            var container = this.container.querySelector(this.selectors.imageContainer);
            if (!container) {
              return;
            }
            var imageZoom = new theme.Photoswipe(container, this.sectionId);
            container.addEventListener('photoswipe:afterChange', function(evt) {
              if (this.flickity) {
                this.flickity.goToSlide(evt.detail.index);
              }
            }.bind(this));
          },
      
          getThumbIndex: function(target) {
            return target.dataset.index;
          },
      
          updateVariantImage: function(evt) {
            var variant = evt.detail.variant;
            var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
      
            var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
            var imageIndex = this.getThumbIndex(newImage);
      
            // If there is no index, slider is not initalized
            if (typeof imageIndex === 'undefined') {
              return;
            }
      
            // Go to that variant image's slide
            if (this.flickity) {
              this.flickity.goToSlide(imageIndex);
            }
          },
      
          initProductSlider: function(variant) {
            // Stop if only a single image, but add active class to first slide
            if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
              var slide = this.cache.mainSlider.querySelector(selectors.slide);
              if (slide) {
                slide.classList.add('is-selected');
              }
              return;
            }
      
            // Destroy slider in preparation of new initialization
            if (this.flickity && typeof this.flickity.destroy === 'function') {
              this.flickity.destroy();
            }
      
            // If variant argument exists, slideshow is reinitializing because of the
            // image set feature enabled and switching to a new group.
            // currentSlideIndex
            if (!variant) {
              var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
              this.settings.currentSlideIndex = this._slideIndex(activeSlide);
            }
      
            var mainSliderArgs = {
              dragThreshold: 25,
              adaptiveHeight: true,
              avoidReflow: true,
              initialIndex: this.settings.currentSlideIndex,
              childNav: this.cache.thumbSlider,
              childNavScroller: this.cache.thumbScroller,
              childVertical: this.cache.thumbSlider.dataset.position === 'beside',
              pageDots: true, // mobile only with CSS
              wrapAround: true,
              callbacks: {
                onInit: this.onSliderInit.bind(this),
                onChange: this.onSlideChange.bind(this)
              }
            };
      
            // Override default settings if image set feature enabled
            if (this.settings.imageSetName) {
              var imageSetArgs = this.imageSetArguments(variant);
              mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
              this.updateImageSetThumbs(mainSliderArgs.imageSet);
            }
      
            this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
          },
      
          onSliderInit: function(slide) {
            // If slider is initialized with image set feature active,
            // initialize any videos/media when they are first slide
            if (this.settings.imageSetName) {
              this.prepMediaOnSlide(slide);
            }
          },
      
          onSlideChange: function(index) {
            if (!this.flickity) return;
      
            var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+this.settings.currentSlideIndex+'"]');
      
            // If imageSetName exists, use a more specific selector
            var nextSlide = this.settings.imageSetName ?
                            this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
                            this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+index+'"]');
      
            prevSlide.setAttribute('tabindex', '-1');
            nextSlide.setAttribute('tabindex', 0);
      
            // Pause any existing slide video/media
            this.stopMediaOnSlide(prevSlide);
      
            // Prep next slide video/media
            this.prepMediaOnSlide(nextSlide);
      
            // Update current slider index
            this.settings.currentSlideIndex = index;
          },
      
          stopMediaOnSlide(slide) {
            // Stop existing video
            var video = slide.querySelector(selectors.productVideo);
            if (video) {
              var videoType = this._getVideoType(video);
              var videoId = this._getVideoDivId(video);
              if (videoType === 'youtube') {
                if (videoObjects[videoId].videoPlayer) {
                  videoObjects[videoId].videoPlayer.stopVideo();
                  return;
                }
              } else if (videoType === 'mp4') {
                this.stopMp4Video(videoId);
                return;
              }
            }
      
            // Stop existing media
            var currentMedia = slide.querySelector(this.selectors.media);
            if (currentMedia) {
              currentMedia.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          },
      
          prepMediaOnSlide(slide) {
            var video = slide.querySelector(selectors.productVideo);
            if (video) {
              this.flickity.reposition();
              var videoType = this._getVideoType(video);
              var videoId = this._getVideoDivId(video);
              if (videoType === 'youtube') {
                if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
                  videoObjects[videoId].videoPlayer.playVideo();
                  return;
                }
              } else if (videoType === 'mp4') {
                this.playMp4Video(videoId);
              }
            }
      
            var nextMedia = slide.querySelector(this.selectors.media);
            if (nextMedia) {
              nextMedia.dispatchEvent(
                new CustomEvent('mediaVisible', {
                  bubbles: true,
                  cancelable: true
                })
              );
              slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
              slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
            }
          },
      
          _slideIndex: function(el) {
            return el.getAttribute('data-index');
          },
      
          /*============================================================================
            Products when in quick view modal
          ==============================================================================*/
          openModalProduct: function() {
            var initialized = false;
      
            if (!this.settings.modalInit) {
              this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
              var url = this.blocksHolder.dataset.url;
      
              fetch(url).then(function(response) {
                return response.text();
              }).then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var blocks = doc.querySelector(selectors.blocks);
      
                // Because the same product could be opened in quick view
                // on the page we load the form elements from, we need to
                // update any `id`, `for`, and `form` attributes
                blocks.querySelectorAll('[id]').forEach(el => {
                  // Update input `id`
                  var val = el.getAttribute('id');
                  el.setAttribute('id', val + '-modal');
      
                  // Update related label if it exists
                  var label = blocks.querySelector(`[for="${val}"]`);
                  if (label) {
                    label.setAttribute('for', val + '-modal');
                  }
      
                  // Update any collapsible elements
                  var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
                  if (collapsibleTrigger) {
                    collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
                  }
                });
      
                // Update any elements with `form` attribute.
                // Form element already has `-modal` appended
                var form = blocks.querySelector(this.selectors.form);
                if (form) {
                  var formId = form.getAttribute('id');
                  blocks.querySelectorAll('[form]').forEach(el => {
                    el.setAttribute('form', formId);
                  });
                }
      
                this.blocksHolder.innerHTML = '';
                this.blocksHolder.append(blocks);
                this.blocksHolder.classList.add('product-form-holder--loaded');
      
                this.cacheElements();
      
                this.formSetup();
                this.updateModalProductInventory();
      
                if (Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }
      
                // Re-hook up collapsible box triggers
                theme.collapsibles.init(this.container);
      
                document.dispatchEvent(new CustomEvent('quickview:loaded', {
                  detail: {
                    productId: this.productId
                  }
                }));
              }.bind(this));
      
              this.productSetup();
              this.videoSetup();
      
              // Enable product slider in quick view
              // 1. with image sets enabled, make sure we have this.variants before initializing
              // 2. initialize normally, form data not required
              if (this.settings.imageSetName) {
                if (this.variants) {
                  this.initProductSlider();
                } else {
                  document.addEventListener('quickview:loaded', function(evt) {
                    if (evt.detail.productId === this.productId) {
                      this.initProductSlider();
                    }
                  }.bind(this));
                }
              } else {
                this.initProductSlider();
              }
              this.customMediaListners();
              this.addIdToRecentlyViewed();
              this.settings.modalInit = true;
            } else {
              initialized = true;
            }
      
            AOS.refreshHard();
      
            document.dispatchEvent(new CustomEvent('quickview:open', {
              detail: {
                initialized: initialized,
                productId: this.productId
              }
            }));
          },
      
          // Recommended products load via JS and don't add variant inventory to the
          // global variable that we later check. This function scrapes a data div
          // to get that info and manually add the values.
          updateModalProductInventory: function() {
            window.inventories = window.inventories || {};
            this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
              var productId = el.dataset.productId;
              window.inventories[productId] = {};
      
              el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
                window.inventories[productId][el.dataset.id] = {
                  'quantity': el.dataset.quantity,
                  'policy': el.dataset.policy,
                  'incoming': el.dataset.incoming,
                  'next_incoming_date': el.dataset.date
                }
              });
            });
          },
      
          closeModalProduct: function() {
            this.stopVideos();
          },
      
          /*============================================================================
            Product media (3D)
          ==============================================================================*/
          initModelViewerLibraries: function() {
            var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
            if (modelViewerElements.length < 1) return;
      
            theme.ProductMedia.init(modelViewerElements, this.sectionId);
          },
      
          initShopifyXrLaunch: function() {
            document.addEventListener(
              'shopify_xr_launch',
              function() {
                var currentMedia = this.container.querySelector(
                  this.selectors.productMediaWrapper +
                    ':not(.' +
                    self.classes.hidden +
                    ')'
                );
                currentMedia.dispatchEvent(
                  new CustomEvent('xrLaunch', {
                    bubbles: true,
                    cancelable: true
                  })
                );
              }.bind(this)
            );
          },
      
          customMediaListners: function() {
            document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
              el.addEventListener('click', function() {
                var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
                var media = slide.querySelector(this.selectors.media);
                if (media) {
                  media.dispatchEvent(
                    new CustomEvent('mediaHidden', {
                      bubbles: true,
                      cancelable: true
                    })
                  );
                }
              }.bind(this))
            });
      
            var modelViewers = this.container.querySelectorAll('model-viewer');
            if (modelViewers.length) {
              modelViewers.forEach(el => {
                el.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
                  this.mediaLoaded(evt);
                }.bind(this));
      
                el.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
                  this.mediaUnloaded(evt);
                }.bind(this));
              });
            }
          },
      
          mediaLoaded: function(evt) {
            this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
              el.classList.remove(classes.hidden);
            });
      
            if (this.flickity) {
              this.flickity.setDraggable(false);
            }
          },
      
          mediaUnloaded: function(evt) {
            this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
              el.classList.add(classes.hidden);
            });
      
            if (this.flickity) {
              this.flickity.setDraggable(true);
            }
          },
      
          onUnload: function() {
            theme.ProductMedia.removeSectionModels(this.sectionId);
      
            if (this.flickity && typeof this.flickity.destroy === 'function') {
              this.flickity.destroy();
            }
          }
        });
      
        return Product;
      })();
      
      theme.RecentlyViewed = (function() {
        var init = false;
      
        function RecentlyViewed(container) {
          if (!container) {
            return;
          }
      
          this.container = container;
          this.sectionId = this.container.getAttribute('data-section-id');
          this.namespace = '.recently-viewed' + this.sectionId;
          this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
          this.rowOf = this.container.getAttribute('data-row-of');
          this.imageSizes = this.container.getAttribute('data-image-sizes');
      
          theme.initWhenVisible({
            element: this.container,
            callback: this.init.bind(this),
            threshold: 600
          });
        };
      
        RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
          init: function() {
            if (init) {
              return;
            }
      
            init = true;
      
            if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
              // No previous history on page load, so bail
              this.container.classList.add('hide');
              return;
            }
      
            this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
            this.handle = this.container.getAttribute('data-product-handle');
      
            // Request new product info via JS API
            var promises = [];
            Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
              if (handle !== 'undefined') {
                promises.push(this.getProductInfo(handle));
              }
            }.bind(this));
      
            Promise.all(promises).then(function(result) {
              this.setupOutput(result);
              this.captureProductDetails(result);
            }.bind(this));
          },
      
          getProductInfo: function(handle) {
            return new Promise(function(resolve, reject) {
              if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
                resolve(theme.recentlyViewed.productInfo[handle]);
              } else {
                fetch('/products/'+ handle +'.js').then(function(response) {
                  return response.text();
                }).then(function(product) {
                  resolve(product);
                });
              }
            });
          },
      
          setupOutput: function(products) {
            var allProducts = [];
            var data = {};
            var limit = this.container.getAttribute('data-recent-count');
      
            var i = 0;
      
            Object.keys(products).forEach(function (key) {
              if (!products[key]) {
                return;
              }
              var product = JSON.parse(products[key]);
      
              // Ignore current product
              if (product.handle === this.handle) {
                return;
              }
      
              // Ignore undefined key
              if (typeof product.handle == 'undefined') {
                return;
              }
      
              i++;
      
              // New or formatted properties
              const widths = [180, 360, 540, 720, 900];
              product.url = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
              product.image_responsive_url = theme.Images.buildImagePath(product.featured_image),
              product.image_responsive_urls = theme.Images.buildImagePath(product.featured_image, widths),
              product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
      
              // Unit pricing checks first variant
              var firstVariant = product.variants[0];
              if (firstVariant && firstVariant.unit_price) {
                var baseUnit = '';
      
                if (firstVariant.unit_price_measurement) {
                  if (firstVariant.unit_price_measurement.reference_value != 1) {
                    baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
                  }
                  baseUnit += firstVariant.unit_price_measurement.reference_unit;
                }
      
                product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
                if (baseUnit != '') {
                  product.unit_price += '/' + baseUnit;
                }
              }
      
              allProducts.unshift(product);
            }.bind(this));
      
            if (allProducts.length === 0) {
              this.container.classList.add('hide');
              return;
            }
      
            var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.rowOf, this.imageSizes);
      
            this.outputContainer.innerHTML = productMarkup;
      
            if (AOS) {
              AOS.refreshHard();
            }
          },
      
          captureProductDetails: function(products) {
            for (var i = 0; i < products.length; i++) {
              var product = products[i];
              theme.recentlyViewed.productInfo[product.handle] = product;
            }
      
            // Add data to session storage to reduce API requests later
            if (theme.config.hasSessionStorage) {
              sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
            }
          },
      
          onUnload: function() {
            init = false;
          }
        });
      
        return RecentlyViewed;
      })();
      
      theme.Testimonials = (function() {
        var defaults = {
          adaptiveHeight: true,
          avoidReflow: true,
          pageDots: true,
          prevNextButtons: false
        };
      
        function Testimonials(container) {
          this.container = container;
          this.timeout;
          var sectionId = container.getAttribute('data-section-id');
          this.slideshow = container.querySelector('#Testimonials-' + sectionId);
          this.namespace = '.testimonial-' + sectionId;
      
          if (!this.slideshow) { return }
      
          theme.initWhenVisible({
            element: this.container,
            callback: this.init.bind(this),
            threshold: 600
          });
        }
      
        Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
          init: function() {
            // Do not wrap when only a few blocks
            if (this.slideshow.dataset.count <= 3) {
              defaults.wrapAround = false;
            }
      
            this.flickity = new theme.Slideshow(this.slideshow, defaults);
      
            // Autoscroll to next slide on load to indicate more blocks
            if (this.slideshow.dataset.count > 2) {
              this.timeout = setTimeout(function() {
                this.flickity.goToSlide(1);
              }.bind(this), 1000);
            }
          },
      
          onUnload: function() {
            if (this.flickity && typeof this.flickity.destroy === 'function') {
              this.flickity.destroy();
            }
          },
      
          onDeselect: function() {
            if (this.flickity && typeof this.flickity.play === 'function') {
              this.flickity.play();
            }
          },
      
          onBlockSelect: function(evt) {
            var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
            var index = parseInt(slide.dataset.index);
      
            clearTimeout(this.timeout);
      
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.goToSlide(index);
              this.flickity.pause();
            }
          },
      
          onBlockDeselect: function() {
            if (this.flickity && typeof this.flickity.play === 'function') {
              this.flickity.play();
            }
          }
        });
      
        return Testimonials;
      })();
      
    
      theme.isStorageSupported = function(type) {
        // Return false if we are in an iframe without access to sessionStorage
        if (window.self !== window.top) {
          return false;
        }
    
        var testKey = 'test';
        var storage;
        if (type === 'session') {
          storage = window.sessionStorage;
        }
        if (type === 'local') {
          storage = window.localStorage;
        }
    
        try {
          storage.setItem(testKey, '1');
          storage.removeItem(testKey);
          return true;
        } catch (error) {
          return false;
        }
      };
    
      theme.reinitProductGridItem = function(scope) {
        if (AOS) {AOS.refreshHard()}
    
        if (!document.documentElement.classList.contains('modal-open')) {
          theme.initQuickShop();
        }
    
        // Re-hook up collapsible box triggers
        theme.collapsibles.init();
      };
    
      /*============================================================================
        Things that don't require DOM to be ready
      ==============================================================================*/
      theme.config.hasSessionStorage = theme.isStorageSupported('session');
      theme.config.hasLocalStorage = theme.isStorageSupported('local');
      AOS.init({
        easing: 'ease-out-quad',
        once: true,
        offset: 60,
        disableMutationObserver: true
      });
    
      if (theme.config.hasLocalStorage) {
        theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');
    
        if (theme.recentlyViewed.localStorage) {
          theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
        }
      }
    
      theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};
    
      // Trigger events when going between breakpoints
      theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
      matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
        if (mql.matches) {
          theme.config.bpSmall = true;
          document.dispatchEvent(new CustomEvent('matchSmall'));
        }
        else {
          theme.config.bpSmall = false;
          document.dispatchEvent(new CustomEvent('unmatchSmall'));
        }
      });
    
      /*============================================================================
        Things that require DOM to be ready
      ==============================================================================*/
      function DOMready(callback) {
        if (document.readyState != 'loading') callback();
        else document.addEventListener('DOMContentLoaded', callback);
      }
    
      // Load generic JS. Also reinitializes when sections are
      // added, edited, or removed in Shopify's editor
      theme.initGlobals = function() {
        theme.collapsibles.init();
        theme.videoModal();
      }

      // if (typeof pushToMain == 'function') {
      //   await pushToMain();
      // }

    
      DOMready(async function(){
        theme.sections = new theme.Sections();
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('slideshow-section', theme.SlideshowSection);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('header', theme.HeaderSection);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('product', theme.Product);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('blog', theme.Blog);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('password-header', theme.PasswordHeader);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('photoswipe', theme.Photoswipe);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('background-image', theme.BackgroundImage);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('testimonials', theme.Testimonials);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('video-section', theme.VideoSection);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('map', theme.Maps);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('footer-section', theme.FooterSection);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('store-availability', theme.StoreAvailability);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('recently-viewed', theme.RecentlyViewed);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('newsletter-popup', theme.NewsletterPopup);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('collection-header', theme.CollectionHeader);
        typeof pushToMain == 'function' && await pushToMain();
        theme.sections.register('collection-grid', theme.Collection);
        typeof pushToMain == 'function' && await pushToMain();
    
        theme.initGlobals();
        typeof pushToMain == 'function' && await pushToMain();
        theme.initQuickShop();
        typeof pushToMain == 'function' && await pushToMain();
        theme.rteInit();
        typeof pushToMain == 'function' && await pushToMain();
        
        if (document.body.classList.contains('template-cart')) {
          var cartPageForm = document.getElementById('CartPageForm');
          if (cartPageForm) {
            new theme.CartForm(cartPageForm);
            typeof pushToMain == 'function' && await pushToMain();
          }
        }
    
        if (theme.settings.isCustomerTemplate) {
          theme.customerTemplates();
          typeof pushToMain == 'function' && await pushToMain();
        }
    
        document.dispatchEvent(new CustomEvent('page:loaded'));
      });
    
    })();
};
runThemeJs();